/*! jQuery v3.4.1 | (c) JS Foundation and other contributors | jquery.org/license */
!function(e,t){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return t(e)}:t(e)}("undefined"!=typeof window?window:this,function(C,e){"use strict";var t=[],E=C.document,r=Object.getPrototypeOf,s=t.slice,g=t.concat,u=t.push,i=t.indexOf,n={},o=n.toString,v=n.hasOwnProperty,a=v.toString,l=a.call(Object),y={},m=function(e){return"function"==typeof e&&"number"!=typeof e.nodeType},x=function(e){return null!=e&&e===e.window},c={type:!0,src:!0,nonce:!0,noModule:!0};function b(e,t,n){var r,i,o=(n=n||E).createElement("script");if(o.text=e,t)for(r in c)(i=t[r]||t.getAttribute&&t.getAttribute(r))&&o.setAttribute(r,i);n.head.appendChild(o).parentNode.removeChild(o)}function w(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?n[o.call(e)]||"object":typeof e}var f="3.4.1",k=function(e,t){return new k.fn.init(e,t)},p=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;function d(e){var t=!!e&&"length"in e&&e.length,n=w(e);return!m(e)&&!x(e)&&("array"===n||0===t||"number"==typeof t&&0<t&&t-1 in e)}k.fn=k.prototype={jquery:f,constructor:k,length:0,toArray:function(){return s.call(this)},get:function(e){return null==e?s.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=k.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return k.each(this,e)},map:function(n){return this.pushStack(k.map(this,function(e,t){return n.call(e,t,e)}))},slice:function(){return this.pushStack(s.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(0<=n&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:u,sort:t.sort,splice:t.splice},k.extend=k.fn.extend=function(){var e,t,n,r,i,o,a=arguments[0]||{},s=1,u=arguments.length,l=!1;for("boolean"==typeof a&&(l=a,a=arguments[s]||{},s++),"object"==typeof a||m(a)||(a={}),s===u&&(a=this,s--);s<u;s++)if(null!=(e=arguments[s]))for(t in e)r=e[t],"__proto__"!==t&&a!==r&&(l&&r&&(k.isPlainObject(r)||(i=Array.isArray(r)))?(n=a[t],o=i&&!Array.isArray(n)?[]:i||k.isPlainObject(n)?n:{},i=!1,a[t]=k.extend(l,o,r)):void 0!==r&&(a[t]=r));return a},k.extend({expando:"jQuery"+(f+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==o.call(e))&&(!(t=r(e))||"function"==typeof(n=v.call(t,"constructor")&&t.constructor)&&a.call(n)===l)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e,t){b(e,{nonce:t&&t.nonce})},each:function(e,t){var n,r=0;if(d(e)){for(n=e.length;r<n;r++)if(!1===t.call(e[r],r,e[r]))break}else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},trim:function(e){return null==e?"":(e+"").replace(p,"")},makeArray:function(e,t){var n=t||[];return null!=e&&(d(Object(e))?k.merge(n,"string"==typeof e?[e]:e):u.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:i.call(t,e,n)},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;r++)e[i++]=t[r];return e.length=i,e},grep:function(e,t,n){for(var r=[],i=0,o=e.length,a=!n;i<o;i++)!t(e[i],i)!==a&&r.push(e[i]);return r},map:function(e,t,n){var r,i,o=0,a=[];if(d(e))for(r=e.length;o<r;o++)null!=(i=t(e[o],o,n))&&a.push(i);else for(o in e)null!=(i=t(e[o],o,n))&&a.push(i);return g.apply([],a)},guid:1,support:y}),"function"==typeof Symbol&&(k.fn[Symbol.iterator]=t[Symbol.iterator]),k.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(e,t){n["[object "+t+"]"]=t.toLowerCase()});var h=function(n){var e,d,b,o,i,h,f,g,w,u,l,T,C,a,E,v,s,c,y,k="sizzle"+1*new Date,m=n.document,S=0,r=0,p=ue(),x=ue(),N=ue(),A=ue(),D=function(e,t){return e===t&&(l=!0),0},j={}.hasOwnProperty,t=[],q=t.pop,L=t.push,H=t.push,O=t.slice,P=function(e,t){for(var n=0,r=e.length;n<r;n++)if(e[n]===t)return n;return-1},R="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",M="[\\x20\\t\\r\\n\\f]",I="(?:\\\\.|[\\w-]|[^\0-\\xa0])+",W="\\["+M+"*("+I+")(?:"+M+"*([*^$|!~]?=)"+M+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+I+"))|)"+M+"*\\]",$=":("+I+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+W+")*)|.*)\\)|)",F=new RegExp(M+"+","g"),B=new RegExp("^"+M+"+|((?:^|[^\\\\])(?:\\\\.)*)"+M+"+$","g"),_=new RegExp("^"+M+"*,"+M+"*"),z=new RegExp("^"+M+"*([>+~]|"+M+")"+M+"*"),U=new RegExp(M+"|>"),X=new RegExp($),V=new RegExp("^"+I+"$"),G={ID:new RegExp("^#("+I+")"),CLASS:new RegExp("^\\.("+I+")"),TAG:new RegExp("^("+I+"|[*])"),ATTR:new RegExp("^"+W),PSEUDO:new RegExp("^"+$),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+M+"*(even|odd|(([+-]|)(\\d*)n|)"+M+"*(?:([+-]|)"+M+"*(\\d+)|))"+M+"*\\)|)","i"),bool:new RegExp("^(?:"+R+")$","i"),needsContext:new RegExp("^"+M+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+M+"*((?:-\\d)?\\d*)"+M+"*\\)|)(?=[^-]|$)","i")},Y=/HTML$/i,Q=/^(?:input|select|textarea|button)$/i,J=/^h\d$/i,K=/^[^{]+\{\s*\[native \w/,Z=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,ee=/[+~]/,te=new RegExp("\\\\([\\da-f]{1,6}"+M+"?|("+M+")|.)","ig"),ne=function(e,t,n){var r="0x"+t-65536;return r!=r||n?t:r<0?String.fromCharCode(r+65536):String.fromCharCode(r>>10|55296,1023&r|56320)},re=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,ie=function(e,t){return t?"\0"===e?"\ufffd":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e},oe=function(){T()},ae=be(function(e){return!0===e.disabled&&"fieldset"===e.nodeName.toLowerCase()},{dir:"parentNode",next:"legend"});try{H.apply(t=O.call(m.childNodes),m.childNodes),t[m.childNodes.length].nodeType}catch(e){H={apply:t.length?function(e,t){L.apply(e,O.call(t))}:function(e,t){var n=e.length,r=0;while(e[n++]=t[r++]);e.length=n-1}}}function se(t,e,n,r){var i,o,a,s,u,l,c,f=e&&e.ownerDocument,p=e?e.nodeType:9;if(n=n||[],"string"!=typeof t||!t||1!==p&&9!==p&&11!==p)return n;if(!r&&((e?e.ownerDocument||e:m)!==C&&T(e),e=e||C,E)){if(11!==p&&(u=Z.exec(t)))if(i=u[1]){if(9===p){if(!(a=e.getElementById(i)))return n;if(a.id===i)return n.push(a),n}else if(f&&(a=f.getElementById(i))&&y(e,a)&&a.id===i)return n.push(a),n}else{if(u[2])return H.apply(n,e.getElementsByTagName(t)),n;if((i=u[3])&&d.getElementsByClassName&&e.getElementsByClassName)return H.apply(n,e.getElementsByClassName(i)),n}if(d.qsa&&!A[t+" "]&&(!v||!v.test(t))&&(1!==p||"object"!==e.nodeName.toLowerCase())){if(c=t,f=e,1===p&&U.test(t)){(s=e.getAttribute("id"))?s=s.replace(re,ie):e.setAttribute("id",s=k),o=(l=h(t)).length;while(o--)l[o]="#"+s+" "+xe(l[o]);c=l.join(","),f=ee.test(t)&&ye(e.parentNode)||e}try{return H.apply(n,f.querySelectorAll(c)),n}catch(e){A(t,!0)}finally{s===k&&e.removeAttribute("id")}}}return g(t.replace(B,"$1"),e,n,r)}function ue(){var r=[];return function e(t,n){return r.push(t+" ")>b.cacheLength&&delete e[r.shift()],e[t+" "]=n}}function le(e){return e[k]=!0,e}function ce(e){var t=C.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function fe(e,t){var n=e.split("|"),r=n.length;while(r--)b.attrHandle[n[r]]=t}function pe(e,t){var n=t&&e,r=n&&1===e.nodeType&&1===t.nodeType&&e.sourceIndex-t.sourceIndex;if(r)return r;if(n)while(n=n.nextSibling)if(n===t)return-1;return e?1:-1}function de(t){return function(e){return"input"===e.nodeName.toLowerCase()&&e.type===t}}function he(n){return function(e){var t=e.nodeName.toLowerCase();return("input"===t||"button"===t)&&e.type===n}}function ge(t){return function(e){return"form"in e?e.parentNode&&!1===e.disabled?"label"in e?"label"in e.parentNode?e.parentNode.disabled===t:e.disabled===t:e.isDisabled===t||e.isDisabled!==!t&&ae(e)===t:e.disabled===t:"label"in e&&e.disabled===t}}function ve(a){return le(function(o){return o=+o,le(function(e,t){var n,r=a([],e.length,o),i=r.length;while(i--)e[n=r[i]]&&(e[n]=!(t[n]=e[n]))})})}function ye(e){return e&&"undefined"!=typeof e.getElementsByTagName&&e}for(e in d=se.support={},i=se.isXML=function(e){var t=e.namespaceURI,n=(e.ownerDocument||e).documentElement;return!Y.test(t||n&&n.nodeName||"HTML")},T=se.setDocument=function(e){var t,n,r=e?e.ownerDocument||e:m;return r!==C&&9===r.nodeType&&r.documentElement&&(a=(C=r).documentElement,E=!i(C),m!==C&&(n=C.defaultView)&&n.top!==n&&(n.addEventListener?n.addEventListener("unload",oe,!1):n.attachEvent&&n.attachEvent("onunload",oe)),d.attributes=ce(function(e){return e.className="i",!e.getAttribute("className")}),d.getElementsByTagName=ce(function(e){return e.appendChild(C.createComment("")),!e.getElementsByTagName("*").length}),d.getElementsByClassName=K.test(C.getElementsByClassName),d.getById=ce(function(e){return a.appendChild(e).id=k,!C.getElementsByName||!C.getElementsByName(k).length}),d.getById?(b.filter.ID=function(e){var t=e.replace(te,ne);return function(e){return e.getAttribute("id")===t}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&E){var n=t.getElementById(e);return n?[n]:[]}}):(b.filter.ID=function(e){var n=e.replace(te,ne);return function(e){var t="undefined"!=typeof e.getAttributeNode&&e.getAttributeNode("id");return t&&t.value===n}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&E){var n,r,i,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];i=t.getElementsByName(e),r=0;while(o=i[r++])if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),b.find.TAG=d.getElementsByTagName?function(e,t){return"undefined"!=typeof t.getElementsByTagName?t.getElementsByTagName(e):d.qsa?t.querySelectorAll(e):void 0}:function(e,t){var n,r=[],i=0,o=t.getElementsByTagName(e);if("*"===e){while(n=o[i++])1===n.nodeType&&r.push(n);return r}return o},b.find.CLASS=d.getElementsByClassName&&function(e,t){if("undefined"!=typeof t.getElementsByClassName&&E)return t.getElementsByClassName(e)},s=[],v=[],(d.qsa=K.test(C.querySelectorAll))&&(ce(function(e){a.appendChild(e).innerHTML="<a id='"+k+"'></a><select id='"+k+"-\r\\' msallowcapture=''><option selected=''></option></select>",e.querySelectorAll("[msallowcapture^='']").length&&v.push("[*^$]="+M+"*(?:''|\"\")"),e.querySelectorAll("[selected]").length||v.push("\\["+M+"*(?:value|"+R+")"),e.querySelectorAll("[id~="+k+"-]").length||v.push("~="),e.querySelectorAll(":checked").length||v.push(":checked"),e.querySelectorAll("a#"+k+"+*").length||v.push(".#.+[+~]")}),ce(function(e){e.innerHTML="<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var t=C.createElement("input");t.setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),e.querySelectorAll("[name=d]").length&&v.push("name"+M+"*[*^$|!~]?="),2!==e.querySelectorAll(":enabled").length&&v.push(":enabled",":disabled"),a.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&v.push(":enabled",":disabled"),e.querySelectorAll("*,:x"),v.push(",.*:")})),(d.matchesSelector=K.test(c=a.matches||a.webkitMatchesSelector||a.mozMatchesSelector||a.oMatchesSelector||a.msMatchesSelector))&&ce(function(e){d.disconnectedMatch=c.call(e,"*"),c.call(e,"[s!='']:x"),s.push("!=",$)}),v=v.length&&new RegExp(v.join("|")),s=s.length&&new RegExp(s.join("|")),t=K.test(a.compareDocumentPosition),y=t||K.test(a.contains)?function(e,t){var n=9===e.nodeType?e.documentElement:e,r=t&&t.parentNode;return e===r||!(!r||1!==r.nodeType||!(n.contains?n.contains(r):e.compareDocumentPosition&&16&e.compareDocumentPosition(r)))}:function(e,t){if(t)while(t=t.parentNode)if(t===e)return!0;return!1},D=t?function(e,t){if(e===t)return l=!0,0;var n=!e.compareDocumentPosition-!t.compareDocumentPosition;return n||(1&(n=(e.ownerDocument||e)===(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!d.sortDetached&&t.compareDocumentPosition(e)===n?e===C||e.ownerDocument===m&&y(m,e)?-1:t===C||t.ownerDocument===m&&y(m,t)?1:u?P(u,e)-P(u,t):0:4&n?-1:1)}:function(e,t){if(e===t)return l=!0,0;var n,r=0,i=e.parentNode,o=t.parentNode,a=[e],s=[t];if(!i||!o)return e===C?-1:t===C?1:i?-1:o?1:u?P(u,e)-P(u,t):0;if(i===o)return pe(e,t);n=e;while(n=n.parentNode)a.unshift(n);n=t;while(n=n.parentNode)s.unshift(n);while(a[r]===s[r])r++;return r?pe(a[r],s[r]):a[r]===m?-1:s[r]===m?1:0}),C},se.matches=function(e,t){return se(e,null,null,t)},se.matchesSelector=function(e,t){if((e.ownerDocument||e)!==C&&T(e),d.matchesSelector&&E&&!A[t+" "]&&(!s||!s.test(t))&&(!v||!v.test(t)))try{var n=c.call(e,t);if(n||d.disconnectedMatch||e.document&&11!==e.document.nodeType)return n}catch(e){A(t,!0)}return 0<se(t,C,null,[e]).length},se.contains=function(e,t){return(e.ownerDocument||e)!==C&&T(e),y(e,t)},se.attr=function(e,t){(e.ownerDocument||e)!==C&&T(e);var n=b.attrHandle[t.toLowerCase()],r=n&&j.call(b.attrHandle,t.toLowerCase())?n(e,t,!E):void 0;return void 0!==r?r:d.attributes||!E?e.getAttribute(t):(r=e.getAttributeNode(t))&&r.specified?r.value:null},se.escape=function(e){return(e+"").replace(re,ie)},se.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},se.uniqueSort=function(e){var t,n=[],r=0,i=0;if(l=!d.detectDuplicates,u=!d.sortStable&&e.slice(0),e.sort(D),l){while(t=e[i++])t===e[i]&&(r=n.push(i));while(r--)e.splice(n[r],1)}return u=null,e},o=se.getText=function(e){var t,n="",r=0,i=e.nodeType;if(i){if(1===i||9===i||11===i){if("string"==typeof e.textContent)return e.textContent;for(e=e.firstChild;e;e=e.nextSibling)n+=o(e)}else if(3===i||4===i)return e.nodeValue}else while(t=e[r++])n+=o(t);return n},(b=se.selectors={cacheLength:50,createPseudo:le,match:G,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(te,ne),e[3]=(e[3]||e[4]||e[5]||"").replace(te,ne),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||se.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&se.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return G.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&X.test(n)&&(t=h(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(te,ne).toLowerCase();return"*"===e?function(){return!0}:function(e){return e.nodeName&&e.nodeName.toLowerCase()===t}},CLASS:function(e){var t=p[e+" "];return t||(t=new RegExp("(^|"+M+")"+e+"("+M+"|$)"))&&p(e,function(e){return t.test("string"==typeof e.className&&e.className||"undefined"!=typeof e.getAttribute&&e.getAttribute("class")||"")})},ATTR:function(n,r,i){return function(e){var t=se.attr(e,n);return null==t?"!="===r:!r||(t+="","="===r?t===i:"!="===r?t!==i:"^="===r?i&&0===t.indexOf(i):"*="===r?i&&-1<t.indexOf(i):"$="===r?i&&t.slice(-i.length)===i:"~="===r?-1<(" "+t.replace(F," ")+" ").indexOf(i):"|="===r&&(t===i||t.slice(0,i.length+1)===i+"-"))}},CHILD:function(h,e,t,g,v){var y="nth"!==h.slice(0,3),m="last"!==h.slice(-4),x="of-type"===e;return 1===g&&0===v?function(e){return!!e.parentNode}:function(e,t,n){var r,i,o,a,s,u,l=y!==m?"nextSibling":"previousSibling",c=e.parentNode,f=x&&e.nodeName.toLowerCase(),p=!n&&!x,d=!1;if(c){if(y){while(l){a=e;while(a=a[l])if(x?a.nodeName.toLowerCase()===f:1===a.nodeType)return!1;u=l="only"===h&&!u&&"nextSibling"}return!0}if(u=[m?c.firstChild:c.lastChild],m&&p){d=(s=(r=(i=(o=(a=c)[k]||(a[k]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]||[])[0]===S&&r[1])&&r[2],a=s&&c.childNodes[s];while(a=++s&&a&&a[l]||(d=s=0)||u.pop())if(1===a.nodeType&&++d&&a===e){i[h]=[S,s,d];break}}else if(p&&(d=s=(r=(i=(o=(a=e)[k]||(a[k]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]||[])[0]===S&&r[1]),!1===d)while(a=++s&&a&&a[l]||(d=s=0)||u.pop())if((x?a.nodeName.toLowerCase()===f:1===a.nodeType)&&++d&&(p&&((i=(o=a[k]||(a[k]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]=[S,d]),a===e))break;return(d-=v)===g||d%g==0&&0<=d/g}}},PSEUDO:function(e,o){var t,a=b.pseudos[e]||b.setFilters[e.toLowerCase()]||se.error("unsupported pseudo: "+e);return a[k]?a(o):1<a.length?(t=[e,e,"",o],b.setFilters.hasOwnProperty(e.toLowerCase())?le(function(e,t){var n,r=a(e,o),i=r.length;while(i--)e[n=P(e,r[i])]=!(t[n]=r[i])}):function(e){return a(e,0,t)}):a}},pseudos:{not:le(function(e){var r=[],i=[],s=f(e.replace(B,"$1"));return s[k]?le(function(e,t,n,r){var i,o=s(e,null,r,[]),a=e.length;while(a--)(i=o[a])&&(e[a]=!(t[a]=i))}):function(e,t,n){return r[0]=e,s(r,null,n,i),r[0]=null,!i.pop()}}),has:le(function(t){return function(e){return 0<se(t,e).length}}),contains:le(function(t){return t=t.replace(te,ne),function(e){return-1<(e.textContent||o(e)).indexOf(t)}}),lang:le(function(n){return V.test(n||"")||se.error("unsupported lang: "+n),n=n.replace(te,ne).toLowerCase(),function(e){var t;do{if(t=E?e.lang:e.getAttribute("xml:lang")||e.getAttribute("lang"))return(t=t.toLowerCase())===n||0===t.indexOf(n+"-")}while((e=e.parentNode)&&1===e.nodeType);return!1}}),target:function(e){var t=n.location&&n.location.hash;return t&&t.slice(1)===e.id},root:function(e){return e===a},focus:function(e){return e===C.activeElement&&(!C.hasFocus||C.hasFocus())&&!!(e.type||e.href||~e.tabIndex)},enabled:ge(!1),disabled:ge(!0),checked:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&!!e.checked||"option"===t&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!b.pseudos.empty(e)},header:function(e){return J.test(e.nodeName)},input:function(e){return Q.test(e.nodeName)},button:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&"button"===e.type||"button"===t},text:function(e){var t;return"input"===e.nodeName.toLowerCase()&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:ve(function(){return[0]}),last:ve(function(e,t){return[t-1]}),eq:ve(function(e,t,n){return[n<0?n+t:n]}),even:ve(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:ve(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:ve(function(e,t,n){for(var r=n<0?n+t:t<n?t:n;0<=--r;)e.push(r);return e}),gt:ve(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}}).pseudos.nth=b.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})b.pseudos[e]=de(e);for(e in{submit:!0,reset:!0})b.pseudos[e]=he(e);function me(){}function xe(e){for(var t=0,n=e.length,r="";t<n;t++)r+=e[t].value;return r}function be(s,e,t){var u=e.dir,l=e.next,c=l||u,f=t&&"parentNode"===c,p=r++;return e.first?function(e,t,n){while(e=e[u])if(1===e.nodeType||f)return s(e,t,n);return!1}:function(e,t,n){var r,i,o,a=[S,p];if(n){while(e=e[u])if((1===e.nodeType||f)&&s(e,t,n))return!0}else while(e=e[u])if(1===e.nodeType||f)if(i=(o=e[k]||(e[k]={}))[e.uniqueID]||(o[e.uniqueID]={}),l&&l===e.nodeName.toLowerCase())e=e[u]||e;else{if((r=i[c])&&r[0]===S&&r[1]===p)return a[2]=r[2];if((i[c]=a)[2]=s(e,t,n))return!0}return!1}}function we(i){return 1<i.length?function(e,t,n){var r=i.length;while(r--)if(!i[r](e,t,n))return!1;return!0}:i[0]}function Te(e,t,n,r,i){for(var o,a=[],s=0,u=e.length,l=null!=t;s<u;s++)(o=e[s])&&(n&&!n(o,r,i)||(a.push(o),l&&t.push(s)));return a}function Ce(d,h,g,v,y,e){return v&&!v[k]&&(v=Ce(v)),y&&!y[k]&&(y=Ce(y,e)),le(function(e,t,n,r){var i,o,a,s=[],u=[],l=t.length,c=e||function(e,t,n){for(var r=0,i=t.length;r<i;r++)se(e,t[r],n);return n}(h||"*",n.nodeType?[n]:n,[]),f=!d||!e&&h?c:Te(c,s,d,n,r),p=g?y||(e?d:l||v)?[]:t:f;if(g&&g(f,p,n,r),v){i=Te(p,u),v(i,[],n,r),o=i.length;while(o--)(a=i[o])&&(p[u[o]]=!(f[u[o]]=a))}if(e){if(y||d){if(y){i=[],o=p.length;while(o--)(a=p[o])&&i.push(f[o]=a);y(null,p=[],i,r)}o=p.length;while(o--)(a=p[o])&&-1<(i=y?P(e,a):s[o])&&(e[i]=!(t[i]=a))}}else p=Te(p===t?p.splice(l,p.length):p),y?y(null,t,p,r):H.apply(t,p)})}function Ee(e){for(var i,t,n,r=e.length,o=b.relative[e[0].type],a=o||b.relative[" "],s=o?1:0,u=be(function(e){return e===i},a,!0),l=be(function(e){return-1<P(i,e)},a,!0),c=[function(e,t,n){var r=!o&&(n||t!==w)||((i=t).nodeType?u(e,t,n):l(e,t,n));return i=null,r}];s<r;s++)if(t=b.relative[e[s].type])c=[be(we(c),t)];else{if((t=b.filter[e[s].type].apply(null,e[s].matches))[k]){for(n=++s;n<r;n++)if(b.relative[e[n].type])break;return Ce(1<s&&we(c),1<s&&xe(e.slice(0,s-1).concat({value:" "===e[s-2].type?"*":""})).replace(B,"$1"),t,s<n&&Ee(e.slice(s,n)),n<r&&Ee(e=e.slice(n)),n<r&&xe(e))}c.push(t)}return we(c)}return me.prototype=b.filters=b.pseudos,b.setFilters=new me,h=se.tokenize=function(e,t){var n,r,i,o,a,s,u,l=x[e+" "];if(l)return t?0:l.slice(0);a=e,s=[],u=b.preFilter;while(a){for(o in n&&!(r=_.exec(a))||(r&&(a=a.slice(r[0].length)||a),s.push(i=[])),n=!1,(r=z.exec(a))&&(n=r.shift(),i.push({value:n,type:r[0].replace(B," ")}),a=a.slice(n.length)),b.filter)!(r=G[o].exec(a))||u[o]&&!(r=u[o](r))||(n=r.shift(),i.push({value:n,type:o,matches:r}),a=a.slice(n.length));if(!n)break}return t?a.length:a?se.error(e):x(e,s).slice(0)},f=se.compile=function(e,t){var n,v,y,m,x,r,i=[],o=[],a=N[e+" "];if(!a){t||(t=h(e)),n=t.length;while(n--)(a=Ee(t[n]))[k]?i.push(a):o.push(a);(a=N(e,(v=o,m=0<(y=i).length,x=0<v.length,r=function(e,t,n,r,i){var o,a,s,u=0,l="0",c=e&&[],f=[],p=w,d=e||x&&b.find.TAG("*",i),h=S+=null==p?1:Math.random()||.1,g=d.length;for(i&&(w=t===C||t||i);l!==g&&null!=(o=d[l]);l++){if(x&&o){a=0,t||o.ownerDocument===C||(T(o),n=!E);while(s=v[a++])if(s(o,t||C,n)){r.push(o);break}i&&(S=h)}m&&((o=!s&&o)&&u--,e&&c.push(o))}if(u+=l,m&&l!==u){a=0;while(s=y[a++])s(c,f,t,n);if(e){if(0<u)while(l--)c[l]||f[l]||(f[l]=q.call(r));f=Te(f)}H.apply(r,f),i&&!e&&0<f.length&&1<u+y.length&&se.uniqueSort(r)}return i&&(S=h,w=p),c},m?le(r):r))).selector=e}return a},g=se.select=function(e,t,n,r){var i,o,a,s,u,l="function"==typeof e&&e,c=!r&&h(e=l.selector||e);if(n=n||[],1===c.length){if(2<(o=c[0]=c[0].slice(0)).length&&"ID"===(a=o[0]).type&&9===t.nodeType&&E&&b.relative[o[1].type]){if(!(t=(b.find.ID(a.matches[0].replace(te,ne),t)||[])[0]))return n;l&&(t=t.parentNode),e=e.slice(o.shift().value.length)}i=G.needsContext.test(e)?0:o.length;while(i--){if(a=o[i],b.relative[s=a.type])break;if((u=b.find[s])&&(r=u(a.matches[0].replace(te,ne),ee.test(o[0].type)&&ye(t.parentNode)||t))){if(o.splice(i,1),!(e=r.length&&xe(o)))return H.apply(n,r),n;break}}}return(l||f(e,c))(r,t,!E,n,!t||ee.test(e)&&ye(t.parentNode)||t),n},d.sortStable=k.split("").sort(D).join("")===k,d.detectDuplicates=!!l,T(),d.sortDetached=ce(function(e){return 1&e.compareDocumentPosition(C.createElement("fieldset"))}),ce(function(e){return e.innerHTML="<a href='#'></a>","#"===e.firstChild.getAttribute("href")})||fe("type|href|height|width",function(e,t,n){if(!n)return e.getAttribute(t,"type"===t.toLowerCase()?1:2)}),d.attributes&&ce(function(e){return e.innerHTML="<input/>",e.firstChild.setAttribute("value",""),""===e.firstChild.getAttribute("value")})||fe("value",function(e,t,n){if(!n&&"input"===e.nodeName.toLowerCase())return e.defaultValue}),ce(function(e){return null==e.getAttribute("disabled")})||fe(R,function(e,t,n){var r;if(!n)return!0===e[t]?t.toLowerCase():(r=e.getAttributeNode(t))&&r.specified?r.value:null}),se}(C);k.find=h,k.expr=h.selectors,k.expr[":"]=k.expr.pseudos,k.uniqueSort=k.unique=h.uniqueSort,k.text=h.getText,k.isXMLDoc=h.isXML,k.contains=h.contains,k.escapeSelector=h.escape;var T=function(e,t,n){var r=[],i=void 0!==n;while((e=e[t])&&9!==e.nodeType)if(1===e.nodeType){if(i&&k(e).is(n))break;r.push(e)}return r},S=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},N=k.expr.match.needsContext;function A(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}var D=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function j(e,n,r){return m(n)?k.grep(e,function(e,t){return!!n.call(e,t,e)!==r}):n.nodeType?k.grep(e,function(e){return e===n!==r}):"string"!=typeof n?k.grep(e,function(e){return-1<i.call(n,e)!==r}):k.filter(n,e,r)}k.filter=function(e,t,n){var r=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType?k.find.matchesSelector(r,e)?[r]:[]:k.find.matches(e,k.grep(t,function(e){return 1===e.nodeType}))},k.fn.extend({find:function(e){var t,n,r=this.length,i=this;if("string"!=typeof e)return this.pushStack(k(e).filter(function(){for(t=0;t<r;t++)if(k.contains(i[t],this))return!0}));for(n=this.pushStack([]),t=0;t<r;t++)k.find(e,i[t],n);return 1<r?k.uniqueSort(n):n},filter:function(e){return this.pushStack(j(this,e||[],!1))},not:function(e){return this.pushStack(j(this,e||[],!0))},is:function(e){return!!j(this,"string"==typeof e&&N.test(e)?k(e):e||[],!1).length}});var q,L=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(k.fn.init=function(e,t,n){var r,i;if(!e)return this;if(n=n||q,"string"==typeof e){if(!(r="<"===e[0]&&">"===e[e.length-1]&&3<=e.length?[null,e,null]:L.exec(e))||!r[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(r[1]){if(t=t instanceof k?t[0]:t,k.merge(this,k.parseHTML(r[1],t&&t.nodeType?t.ownerDocument||t:E,!0)),D.test(r[1])&&k.isPlainObject(t))for(r in t)m(this[r])?this[r](t[r]):this.attr(r,t[r]);return this}return(i=E.getElementById(r[2]))&&(this[0]=i,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):m(e)?void 0!==n.ready?n.ready(e):e(k):k.makeArray(e,this)}).prototype=k.fn,q=k(E);var H=/^(?:parents|prev(?:Until|All))/,O={children:!0,contents:!0,next:!0,prev:!0};function P(e,t){while((e=e[t])&&1!==e.nodeType);return e}k.fn.extend({has:function(e){var t=k(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(k.contains(this,t[e]))return!0})},closest:function(e,t){var n,r=0,i=this.length,o=[],a="string"!=typeof e&&k(e);if(!N.test(e))for(;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?-1<a.index(n):1===n.nodeType&&k.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(1<o.length?k.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?i.call(k(e),this[0]):i.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(k.uniqueSort(k.merge(this.get(),k(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),k.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return T(e,"parentNode")},parentsUntil:function(e,t,n){return T(e,"parentNode",n)},next:function(e){return P(e,"nextSibling")},prev:function(e){return P(e,"previousSibling")},nextAll:function(e){return T(e,"nextSibling")},prevAll:function(e){return T(e,"previousSibling")},nextUntil:function(e,t,n){return T(e,"nextSibling",n)},prevUntil:function(e,t,n){return T(e,"previousSibling",n)},siblings:function(e){return S((e.parentNode||{}).firstChild,e)},children:function(e){return S(e.firstChild)},contents:function(e){return"undefined"!=typeof e.contentDocument?e.contentDocument:(A(e,"template")&&(e=e.content||e),k.merge([],e.childNodes))}},function(r,i){k.fn[r]=function(e,t){var n=k.map(this,i,e);return"Until"!==r.slice(-5)&&(t=e),t&&"string"==typeof t&&(n=k.filter(t,n)),1<this.length&&(O[r]||k.uniqueSort(n),H.test(r)&&n.reverse()),this.pushStack(n)}});var R=/[^\x20\t\r\n\f]+/g;function M(e){return e}function I(e){throw e}function W(e,t,n,r){var i;try{e&&m(i=e.promise)?i.call(e).done(t).fail(n):e&&m(i=e.then)?i.call(e,t,n):t.apply(void 0,[e].slice(r))}catch(e){n.apply(void 0,[e])}}k.Callbacks=function(r){var e,n;r="string"==typeof r?(e=r,n={},k.each(e.match(R)||[],function(e,t){n[t]=!0}),n):k.extend({},r);var i,t,o,a,s=[],u=[],l=-1,c=function(){for(a=a||r.once,o=i=!0;u.length;l=-1){t=u.shift();while(++l<s.length)!1===s[l].apply(t[0],t[1])&&r.stopOnFalse&&(l=s.length,t=!1)}r.memory||(t=!1),i=!1,a&&(s=t?[]:"")},f={add:function(){return s&&(t&&!i&&(l=s.length-1,u.push(t)),function n(e){k.each(e,function(e,t){m(t)?r.unique&&f.has(t)||s.push(t):t&&t.length&&"string"!==w(t)&&n(t)})}(arguments),t&&!i&&c()),this},remove:function(){return k.each(arguments,function(e,t){var n;while(-1<(n=k.inArray(t,s,n)))s.splice(n,1),n<=l&&l--}),this},has:function(e){return e?-1<k.inArray(e,s):0<s.length},empty:function(){return s&&(s=[]),this},disable:function(){return a=u=[],s=t="",this},disabled:function(){return!s},lock:function(){return a=u=[],t||i||(s=t=""),this},locked:function(){return!!a},fireWith:function(e,t){return a||(t=[e,(t=t||[]).slice?t.slice():t],u.push(t),i||c()),this},fire:function(){return f.fireWith(this,arguments),this},fired:function(){return!!o}};return f},k.extend({Deferred:function(e){var o=[["notify","progress",k.Callbacks("memory"),k.Callbacks("memory"),2],["resolve","done",k.Callbacks("once memory"),k.Callbacks("once memory"),0,"resolved"],["reject","fail",k.Callbacks("once memory"),k.Callbacks("once memory"),1,"rejected"]],i="pending",a={state:function(){return i},always:function(){return s.done(arguments).fail(arguments),this},"catch":function(e){return a.then(null,e)},pipe:function(){var i=arguments;return k.Deferred(function(r){k.each(o,function(e,t){var n=m(i[t[4]])&&i[t[4]];s[t[1]](function(){var e=n&&n.apply(this,arguments);e&&m(e.promise)?e.promise().progress(r.notify).done(r.resolve).fail(r.reject):r[t[0]+"With"](this,n?[e]:arguments)})}),i=null}).promise()},then:function(t,n,r){var u=0;function l(i,o,a,s){return function(){var n=this,r=arguments,e=function(){var e,t;if(!(i<u)){if((e=a.apply(n,r))===o.promise())throw new TypeError("Thenable self-resolution");t=e&&("object"==typeof e||"function"==typeof e)&&e.then,m(t)?s?t.call(e,l(u,o,M,s),l(u,o,I,s)):(u++,t.call(e,l(u,o,M,s),l(u,o,I,s),l(u,o,M,o.notifyWith))):(a!==M&&(n=void 0,r=[e]),(s||o.resolveWith)(n,r))}},t=s?e:function(){try{e()}catch(e){k.Deferred.exceptionHook&&k.Deferred.exceptionHook(e,t.stackTrace),u<=i+1&&(a!==I&&(n=void 0,r=[e]),o.rejectWith(n,r))}};i?t():(k.Deferred.getStackHook&&(t.stackTrace=k.Deferred.getStackHook()),C.setTimeout(t))}}return k.Deferred(function(e){o[0][3].add(l(0,e,m(r)?r:M,e.notifyWith)),o[1][3].add(l(0,e,m(t)?t:M)),o[2][3].add(l(0,e,m(n)?n:I))}).promise()},promise:function(e){return null!=e?k.extend(e,a):a}},s={};return k.each(o,function(e,t){var n=t[2],r=t[5];a[t[1]]=n.add,r&&n.add(function(){i=r},o[3-e][2].disable,o[3-e][3].disable,o[0][2].lock,o[0][3].lock),n.add(t[3].fire),s[t[0]]=function(){return s[t[0]+"With"](this===s?void 0:this,arguments),this},s[t[0]+"With"]=n.fireWith}),a.promise(s),e&&e.call(s,s),s},when:function(e){var n=arguments.length,t=n,r=Array(t),i=s.call(arguments),o=k.Deferred(),a=function(t){return function(e){r[t]=this,i[t]=1<arguments.length?s.call(arguments):e,--n||o.resolveWith(r,i)}};if(n<=1&&(W(e,o.done(a(t)).resolve,o.reject,!n),"pending"===o.state()||m(i[t]&&i[t].then)))return o.then();while(t--)W(i[t],a(t),o.reject);return o.promise()}});var $=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;k.Deferred.exceptionHook=function(e,t){C.console&&C.console.warn&&e&&$.test(e.name)&&C.console.warn("jQuery.Deferred exception: "+e.message,e.stack,t)},k.readyException=function(e){C.setTimeout(function(){throw e})};var F=k.Deferred();function B(){E.removeEventListener("DOMContentLoaded",B),C.removeEventListener("load",B),k.ready()}k.fn.ready=function(e){return F.then(e)["catch"](function(e){k.readyException(e)}),this},k.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--k.readyWait:k.isReady)||(k.isReady=!0)!==e&&0<--k.readyWait||F.resolveWith(E,[k])}}),k.ready.then=F.then,"complete"===E.readyState||"loading"!==E.readyState&&!E.documentElement.doScroll?C.setTimeout(k.ready):(E.addEventListener("DOMContentLoaded",B),C.addEventListener("load",B));var _=function(e,t,n,r,i,o,a){var s=0,u=e.length,l=null==n;if("object"===w(n))for(s in i=!0,n)_(e,t,s,n[s],!0,o,a);else if(void 0!==r&&(i=!0,m(r)||(a=!0),l&&(a?(t.call(e,r),t=null):(l=t,t=function(e,t,n){return l.call(k(e),n)})),t))for(;s<u;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:l?t.call(e):u?t(e[0],n):o},z=/^-ms-/,U=/-([a-z])/g;function X(e,t){return t.toUpperCase()}function V(e){return e.replace(z,"ms-").replace(U,X)}var G=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function Y(){this.expando=k.expando+Y.uid++}Y.uid=1,Y.prototype={cache:function(e){var t=e[this.expando];return t||(t={},G(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,i=this.cache(e);if("string"==typeof t)i[V(t)]=n;else for(r in t)i[V(r)]=t[r];return i},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][V(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,r=e[this.expando];if(void 0!==r){if(void 0!==t){n=(t=Array.isArray(t)?t.map(V):(t=V(t))in r?[t]:t.match(R)||[]).length;while(n--)delete r[t[n]]}(void 0===t||k.isEmptyObject(r))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!k.isEmptyObject(t)}};var Q=new Y,J=new Y,K=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,Z=/[A-Z]/g;function ee(e,t,n){var r,i;if(void 0===n&&1===e.nodeType)if(r="data-"+t.replace(Z,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(r))){try{n="true"===(i=n)||"false"!==i&&("null"===i?null:i===+i+""?+i:K.test(i)?JSON.parse(i):i)}catch(e){}J.set(e,t,n)}else n=void 0;return n}k.extend({hasData:function(e){return J.hasData(e)||Q.hasData(e)},data:function(e,t,n){return J.access(e,t,n)},removeData:function(e,t){J.remove(e,t)},_data:function(e,t,n){return Q.access(e,t,n)},_removeData:function(e,t){Q.remove(e,t)}}),k.fn.extend({data:function(n,e){var t,r,i,o=this[0],a=o&&o.attributes;if(void 0===n){if(this.length&&(i=J.get(o),1===o.nodeType&&!Q.get(o,"hasDataAttrs"))){t=a.length;while(t--)a[t]&&0===(r=a[t].name).indexOf("data-")&&(r=V(r.slice(5)),ee(o,r,i[r]));Q.set(o,"hasDataAttrs",!0)}return i}return"object"==typeof n?this.each(function(){J.set(this,n)}):_(this,function(e){var t;if(o&&void 0===e)return void 0!==(t=J.get(o,n))?t:void 0!==(t=ee(o,n))?t:void 0;this.each(function(){J.set(this,n,e)})},null,e,1<arguments.length,null,!0)},removeData:function(e){return this.each(function(){J.remove(this,e)})}}),k.extend({queue:function(e,t,n){var r;if(e)return t=(t||"fx")+"queue",r=Q.get(e,t),n&&(!r||Array.isArray(n)?r=Q.access(e,t,k.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||"fx";var n=k.queue(e,t),r=n.length,i=n.shift(),o=k._queueHooks(e,t);"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,function(){k.dequeue(e,t)},o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return Q.get(e,n)||Q.access(e,n,{empty:k.Callbacks("once memory").add(function(){Q.remove(e,[t+"queue",n])})})}}),k.fn.extend({queue:function(t,n){var e=2;return"string"!=typeof t&&(n=t,t="fx",e--),arguments.length<e?k.queue(this[0],t):void 0===n?this:this.each(function(){var e=k.queue(this,t,n);k._queueHooks(this,t),"fx"===t&&"inprogress"!==e[0]&&k.dequeue(this,t)})},dequeue:function(e){return this.each(function(){k.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,r=1,i=k.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};"string"!=typeof e&&(t=e,e=void 0),e=e||"fx";while(a--)(n=Q.get(o[a],e+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var te=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,ne=new RegExp("^(?:([+-])=|)("+te+")([a-z%]*)$","i"),re=["Top","Right","Bottom","Left"],ie=E.documentElement,oe=function(e){return k.contains(e.ownerDocument,e)},ae={composed:!0};ie.getRootNode&&(oe=function(e){return k.contains(e.ownerDocument,e)||e.getRootNode(ae)===e.ownerDocument});var se=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&oe(e)&&"none"===k.css(e,"display")},ue=function(e,t,n,r){var i,o,a={};for(o in t)a[o]=e.style[o],e.style[o]=t[o];for(o in i=n.apply(e,r||[]),t)e.style[o]=a[o];return i};function le(e,t,n,r){var i,o,a=20,s=r?function(){return r.cur()}:function(){return k.css(e,t,"")},u=s(),l=n&&n[3]||(k.cssNumber[t]?"":"px"),c=e.nodeType&&(k.cssNumber[t]||"px"!==l&&+u)&&ne.exec(k.css(e,t));if(c&&c[3]!==l){u/=2,l=l||c[3],c=+u||1;while(a--)k.style(e,t,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;c*=2,k.style(e,t,c+l),n=n||[]}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=l,r.start=c,r.end=i)),i}var ce={};function fe(e,t){for(var n,r,i,o,a,s,u,l=[],c=0,f=e.length;c<f;c++)(r=e[c]).style&&(n=r.style.display,t?("none"===n&&(l[c]=Q.get(r,"display")||null,l[c]||(r.style.display="")),""===r.style.display&&se(r)&&(l[c]=(u=a=o=void 0,a=(i=r).ownerDocument,s=i.nodeName,(u=ce[s])||(o=a.body.appendChild(a.createElement(s)),u=k.css(o,"display"),o.parentNode.removeChild(o),"none"===u&&(u="block"),ce[s]=u)))):"none"!==n&&(l[c]="none",Q.set(r,"display",n)));for(c=0;c<f;c++)null!=l[c]&&(e[c].style.display=l[c]);return e}k.fn.extend({show:function(){return fe(this,!0)},hide:function(){return fe(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){se(this)?k(this).show():k(this).hide()})}});var pe=/^(?:checkbox|radio)$/i,de=/<([a-z][^\/\0>\x20\t\r\n\f]*)/i,he=/^$|^module$|\/(?:java|ecma)script/i,ge={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};function ve(e,t){var n;return n="undefined"!=typeof e.getElementsByTagName?e.getElementsByTagName(t||"*"):"undefined"!=typeof e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&A(e,t)?k.merge([e],n):n}function ye(e,t){for(var n=0,r=e.length;n<r;n++)Q.set(e[n],"globalEval",!t||Q.get(t[n],"globalEval"))}ge.optgroup=ge.option,ge.tbody=ge.tfoot=ge.colgroup=ge.caption=ge.thead,ge.th=ge.td;var me,xe,be=/<|&#?\w+;/;function we(e,t,n,r,i){for(var o,a,s,u,l,c,f=t.createDocumentFragment(),p=[],d=0,h=e.length;d<h;d++)if((o=e[d])||0===o)if("object"===w(o))k.merge(p,o.nodeType?[o]:o);else if(be.test(o)){a=a||f.appendChild(t.createElement("div")),s=(de.exec(o)||["",""])[1].toLowerCase(),u=ge[s]||ge._default,a.innerHTML=u[1]+k.htmlPrefilter(o)+u[2],c=u[0];while(c--)a=a.lastChild;k.merge(p,a.childNodes),(a=f.firstChild).textContent=""}else p.push(t.createTextNode(o));f.textContent="",d=0;while(o=p[d++])if(r&&-1<k.inArray(o,r))i&&i.push(o);else if(l=oe(o),a=ve(f.appendChild(o),"script"),l&&ye(a),n){c=0;while(o=a[c++])he.test(o.type||"")&&n.push(o)}return f}me=E.createDocumentFragment().appendChild(E.createElement("div")),(xe=E.createElement("input")).setAttribute("type","radio"),xe.setAttribute("checked","checked"),xe.setAttribute("name","t"),me.appendChild(xe),y.checkClone=me.cloneNode(!0).cloneNode(!0).lastChild.checked,me.innerHTML="<textarea>x</textarea>",y.noCloneChecked=!!me.cloneNode(!0).lastChild.defaultValue;var Te=/^key/,Ce=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,Ee=/^([^.]*)(?:\.(.+)|)/;function ke(){return!0}function Se(){return!1}function Ne(e,t){return e===function(){try{return E.activeElement}catch(e){}}()==("focus"===t)}function Ae(e,t,n,r,i,o){var a,s;if("object"==typeof t){for(s in"string"!=typeof n&&(r=r||n,n=void 0),t)Ae(e,s,n,r,t[s],o);return e}if(null==r&&null==i?(i=n,r=n=void 0):null==i&&("string"==typeof n?(i=r,r=void 0):(i=r,r=n,n=void 0)),!1===i)i=Se;else if(!i)return e;return 1===o&&(a=i,(i=function(e){return k().off(e),a.apply(this,arguments)}).guid=a.guid||(a.guid=k.guid++)),e.each(function(){k.event.add(this,t,i,r,n)})}function De(e,i,o){o?(Q.set(e,i,!1),k.event.add(e,i,{namespace:!1,handler:function(e){var t,n,r=Q.get(this,i);if(1&e.isTrigger&&this[i]){if(r.length)(k.event.special[i]||{}).delegateType&&e.stopPropagation();else if(r=s.call(arguments),Q.set(this,i,r),t=o(this,i),this[i](),r!==(n=Q.get(this,i))||t?Q.set(this,i,!1):n={},r!==n)return e.stopImmediatePropagation(),e.preventDefault(),n.value}else r.length&&(Q.set(this,i,{value:k.event.trigger(k.extend(r[0],k.Event.prototype),r.slice(1),this)}),e.stopImmediatePropagation())}})):void 0===Q.get(e,i)&&k.event.add(e,i,ke)}k.event={global:{},add:function(t,e,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=Q.get(t);if(v){n.handler&&(n=(o=n).handler,i=o.selector),i&&k.find.matchesSelector(ie,i),n.guid||(n.guid=k.guid++),(u=v.events)||(u=v.events={}),(a=v.handle)||(a=v.handle=function(e){return"undefined"!=typeof k&&k.event.triggered!==e.type?k.event.dispatch.apply(t,arguments):void 0}),l=(e=(e||"").match(R)||[""]).length;while(l--)d=g=(s=Ee.exec(e[l])||[])[1],h=(s[2]||"").split(".").sort(),d&&(f=k.event.special[d]||{},d=(i?f.delegateType:f.bindType)||d,f=k.event.special[d]||{},c=k.extend({type:d,origType:g,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&k.expr.match.needsContext.test(i),namespace:h.join(".")},o),(p=u[d])||((p=u[d]=[]).delegateCount=0,f.setup&&!1!==f.setup.call(t,r,h,a)||t.addEventListener&&t.addEventListener(d,a)),f.add&&(f.add.call(t,c),c.handler.guid||(c.handler.guid=n.guid)),i?p.splice(p.delegateCount++,0,c):p.push(c),k.event.global[d]=!0)}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=Q.hasData(e)&&Q.get(e);if(v&&(u=v.events)){l=(t=(t||"").match(R)||[""]).length;while(l--)if(d=g=(s=Ee.exec(t[l])||[])[1],h=(s[2]||"").split(".").sort(),d){f=k.event.special[d]||{},p=u[d=(r?f.delegateType:f.bindType)||d]||[],s=s[2]&&new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=o=p.length;while(o--)c=p[o],!i&&g!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&("**"!==r||!c.selector)||(p.splice(o,1),c.selector&&p.delegateCount--,f.remove&&f.remove.call(e,c));a&&!p.length&&(f.teardown&&!1!==f.teardown.call(e,h,v.handle)||k.removeEvent(e,d,v.handle),delete u[d])}else for(d in u)k.event.remove(e,d+t[l],n,r,!0);k.isEmptyObject(u)&&Q.remove(e,"handle events")}},dispatch:function(e){var t,n,r,i,o,a,s=k.event.fix(e),u=new Array(arguments.length),l=(Q.get(this,"events")||{})[s.type]||[],c=k.event.special[s.type]||{};for(u[0]=s,t=1;t<arguments.length;t++)u[t]=arguments[t];if(s.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,s)){a=k.event.handlers.call(this,s,l),t=0;while((i=a[t++])&&!s.isPropagationStopped()){s.currentTarget=i.elem,n=0;while((o=i.handlers[n++])&&!s.isImmediatePropagationStopped())s.rnamespace&&!1!==o.namespace&&!s.rnamespace.test(o.namespace)||(s.handleObj=o,s.data=o.data,void 0!==(r=((k.event.special[o.origType]||{}).handle||o.handler).apply(i.elem,u))&&!1===(s.result=r)&&(s.preventDefault(),s.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,s),s.result}},handlers:function(e,t){var n,r,i,o,a,s=[],u=t.delegateCount,l=e.target;if(u&&l.nodeType&&!("click"===e.type&&1<=e.button))for(;l!==this;l=l.parentNode||this)if(1===l.nodeType&&("click"!==e.type||!0!==l.disabled)){for(o=[],a={},n=0;n<u;n++)void 0===a[i=(r=t[n]).selector+" "]&&(a[i]=r.needsContext?-1<k(i,this).index(l):k.find(i,this,null,[l]).length),a[i]&&o.push(r);o.length&&s.push({elem:l,handlers:o})}return l=this,u<t.length&&s.push({elem:l,handlers:t.slice(u)}),s},addProp:function(t,e){Object.defineProperty(k.Event.prototype,t,{enumerable:!0,configurable:!0,get:m(e)?function(){if(this.originalEvent)return e(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[t]},set:function(e){Object.defineProperty(this,t,{enumerable:!0,configurable:!0,writable:!0,value:e})}})},fix:function(e){return e[k.expando]?e:new k.Event(e)},special:{load:{noBubble:!0},click:{setup:function(e){var t=this||e;return pe.test(t.type)&&t.click&&A(t,"input")&&De(t,"click",ke),!1},trigger:function(e){var t=this||e;return pe.test(t.type)&&t.click&&A(t,"input")&&De(t,"click"),!0},_default:function(e){var t=e.target;return pe.test(t.type)&&t.click&&A(t,"input")&&Q.get(t,"click")||A(t,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},k.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},k.Event=function(e,t){if(!(this instanceof k.Event))return new k.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?ke:Se,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&k.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[k.expando]=!0},k.Event.prototype={constructor:k.Event,isDefaultPrevented:Se,isPropagationStopped:Se,isImmediatePropagationStopped:Se,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=ke,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=ke,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=ke,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},k.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:function(e){var t=e.button;return null==e.which&&Te.test(e.type)?null!=e.charCode?e.charCode:e.keyCode:!e.which&&void 0!==t&&Ce.test(e.type)?1&t?1:2&t?3:4&t?2:0:e.which}},k.event.addProp),k.each({focus:"focusin",blur:"focusout"},function(e,t){k.event.special[e]={setup:function(){return De(this,e,Ne),!1},trigger:function(){return De(this,e),!0},delegateType:t}}),k.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(e,i){k.event.special[e]={delegateType:i,bindType:i,handle:function(e){var t,n=e.relatedTarget,r=e.handleObj;return n&&(n===this||k.contains(this,n))||(e.type=r.origType,t=r.handler.apply(this,arguments),e.type=i),t}}}),k.fn.extend({on:function(e,t,n,r){return Ae(this,e,t,n,r)},one:function(e,t,n,r){return Ae(this,e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,k(e.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler),this;if("object"==typeof e){for(i in e)this.off(i,t,e[i]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=Se),this.each(function(){k.event.remove(this,e,n,t)})}});var je=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,qe=/<script|<style|<link/i,Le=/checked\s*(?:[^=]|=\s*.checked.)/i,He=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function Oe(e,t){return A(e,"table")&&A(11!==t.nodeType?t:t.firstChild,"tr")&&k(e).children("tbody")[0]||e}function Pe(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function Re(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function Me(e,t){var n,r,i,o,a,s,u,l;if(1===t.nodeType){if(Q.hasData(e)&&(o=Q.access(e),a=Q.set(t,o),l=o.events))for(i in delete a.handle,a.events={},l)for(n=0,r=l[i].length;n<r;n++)k.event.add(t,i,l[i][n]);J.hasData(e)&&(s=J.access(e),u=k.extend({},s),J.set(t,u))}}function Ie(n,r,i,o){r=g.apply([],r);var e,t,a,s,u,l,c=0,f=n.length,p=f-1,d=r[0],h=m(d);if(h||1<f&&"string"==typeof d&&!y.checkClone&&Le.test(d))return n.each(function(e){var t=n.eq(e);h&&(r[0]=d.call(this,e,t.html())),Ie(t,r,i,o)});if(f&&(t=(e=we(r,n[0].ownerDocument,!1,n,o)).firstChild,1===e.childNodes.length&&(e=t),t||o)){for(s=(a=k.map(ve(e,"script"),Pe)).length;c<f;c++)u=e,c!==p&&(u=k.clone(u,!0,!0),s&&k.merge(a,ve(u,"script"))),i.call(n[c],u,c);if(s)for(l=a[a.length-1].ownerDocument,k.map(a,Re),c=0;c<s;c++)u=a[c],he.test(u.type||"")&&!Q.access(u,"globalEval")&&k.contains(l,u)&&(u.src&&"module"!==(u.type||"").toLowerCase()?k._evalUrl&&!u.noModule&&k._evalUrl(u.src,{nonce:u.nonce||u.getAttribute("nonce")}):b(u.textContent.replace(He,""),u,l))}return n}function We(e,t,n){for(var r,i=t?k.filter(t,e):e,o=0;null!=(r=i[o]);o++)n||1!==r.nodeType||k.cleanData(ve(r)),r.parentNode&&(n&&oe(r)&&ye(ve(r,"script")),r.parentNode.removeChild(r));return e}k.extend({htmlPrefilter:function(e){return e.replace(je,"<$1></$2>")},clone:function(e,t,n){var r,i,o,a,s,u,l,c=e.cloneNode(!0),f=oe(e);if(!(y.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||k.isXMLDoc(e)))for(a=ve(c),r=0,i=(o=ve(e)).length;r<i;r++)s=o[r],u=a[r],void 0,"input"===(l=u.nodeName.toLowerCase())&&pe.test(s.type)?u.checked=s.checked:"input"!==l&&"textarea"!==l||(u.defaultValue=s.defaultValue);if(t)if(n)for(o=o||ve(e),a=a||ve(c),r=0,i=o.length;r<i;r++)Me(o[r],a[r]);else Me(e,c);return 0<(a=ve(c,"script")).length&&ye(a,!f&&ve(e,"script")),c},cleanData:function(e){for(var t,n,r,i=k.event.special,o=0;void 0!==(n=e[o]);o++)if(G(n)){if(t=n[Q.expando]){if(t.events)for(r in t.events)i[r]?k.event.remove(n,r):k.removeEvent(n,r,t.handle);n[Q.expando]=void 0}n[J.expando]&&(n[J.expando]=void 0)}}}),k.fn.extend({detach:function(e){return We(this,e,!0)},remove:function(e){return We(this,e)},text:function(e){return _(this,function(e){return void 0===e?k.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)})},null,e,arguments.length)},append:function(){return Ie(this,arguments,function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||Oe(this,e).appendChild(e)})},prepend:function(){return Ie(this,arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=Oe(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return Ie(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return Ie(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(k.cleanData(ve(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return k.clone(this,e,t)})},html:function(e){return _(this,function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!qe.test(e)&&!ge[(de.exec(e)||["",""])[1].toLowerCase()]){e=k.htmlPrefilter(e);try{for(;n<r;n++)1===(t=this[n]||{}).nodeType&&(k.cleanData(ve(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var n=[];return Ie(this,arguments,function(e){var t=this.parentNode;k.inArray(this,n)<0&&(k.cleanData(ve(this)),t&&t.replaceChild(e,this))},n)}}),k.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,a){k.fn[e]=function(e){for(var t,n=[],r=k(e),i=r.length-1,o=0;o<=i;o++)t=o===i?this:this.clone(!0),k(r[o])[a](t),u.apply(n,t.get());return this.pushStack(n)}});var $e=new RegExp("^("+te+")(?!px)[a-z%]+$","i"),Fe=function(e){var t=e.ownerDocument.defaultView;return t&&t.opener||(t=C),t.getComputedStyle(e)},Be=new RegExp(re.join("|"),"i");function _e(e,t,n){var r,i,o,a,s=e.style;return(n=n||Fe(e))&&(""!==(a=n.getPropertyValue(t)||n[t])||oe(e)||(a=k.style(e,t)),!y.pixelBoxStyles()&&$e.test(a)&&Be.test(t)&&(r=s.width,i=s.minWidth,o=s.maxWidth,s.minWidth=s.maxWidth=s.width=a,a=n.width,s.width=r,s.minWidth=i,s.maxWidth=o)),void 0!==a?a+"":a}function ze(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}!function(){function e(){if(u){s.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",u.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",ie.appendChild(s).appendChild(u);var e=C.getComputedStyle(u);n="1%"!==e.top,a=12===t(e.marginLeft),u.style.right="60%",o=36===t(e.right),r=36===t(e.width),u.style.position="absolute",i=12===t(u.offsetWidth/3),ie.removeChild(s),u=null}}function t(e){return Math.round(parseFloat(e))}var n,r,i,o,a,s=E.createElement("div"),u=E.createElement("div");u.style&&(u.style.backgroundClip="content-box",u.cloneNode(!0).style.backgroundClip="",y.clearCloneStyle="content-box"===u.style.backgroundClip,k.extend(y,{boxSizingReliable:function(){return e(),r},pixelBoxStyles:function(){return e(),o},pixelPosition:function(){return e(),n},reliableMarginLeft:function(){return e(),a},scrollboxSize:function(){return e(),i}}))}();var Ue=["Webkit","Moz","ms"],Xe=E.createElement("div").style,Ve={};function Ge(e){var t=k.cssProps[e]||Ve[e];return t||(e in Xe?e:Ve[e]=function(e){var t=e[0].toUpperCase()+e.slice(1),n=Ue.length;while(n--)if((e=Ue[n]+t)in Xe)return e}(e)||e)}var Ye=/^(none|table(?!-c[ea]).+)/,Qe=/^--/,Je={position:"absolute",visibility:"hidden",display:"block"},Ke={letterSpacing:"0",fontWeight:"400"};function Ze(e,t,n){var r=ne.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):t}function et(e,t,n,r,i,o){var a="width"===t?1:0,s=0,u=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2)"margin"===n&&(u+=k.css(e,n+re[a],!0,i)),r?("content"===n&&(u-=k.css(e,"padding"+re[a],!0,i)),"margin"!==n&&(u-=k.css(e,"border"+re[a]+"Width",!0,i))):(u+=k.css(e,"padding"+re[a],!0,i),"padding"!==n?u+=k.css(e,"border"+re[a]+"Width",!0,i):s+=k.css(e,"border"+re[a]+"Width",!0,i));return!r&&0<=o&&(u+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-u-s-.5))||0),u}function tt(e,t,n){var r=Fe(e),i=(!y.boxSizingReliable()||n)&&"border-box"===k.css(e,"boxSizing",!1,r),o=i,a=_e(e,t,r),s="offset"+t[0].toUpperCase()+t.slice(1);if($e.test(a)){if(!n)return a;a="auto"}return(!y.boxSizingReliable()&&i||"auto"===a||!parseFloat(a)&&"inline"===k.css(e,"display",!1,r))&&e.getClientRects().length&&(i="border-box"===k.css(e,"boxSizing",!1,r),(o=s in e)&&(a=e[s])),(a=parseFloat(a)||0)+et(e,t,n||(i?"border":"content"),o,r,a)+"px"}function nt(e,t,n,r,i){return new nt.prototype.init(e,t,n,r,i)}k.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=_e(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=V(t),u=Qe.test(t),l=e.style;if(u||(t=Ge(s)),a=k.cssHooks[t]||k.cssHooks[s],void 0===n)return a&&"get"in a&&void 0!==(i=a.get(e,!1,r))?i:l[t];"string"===(o=typeof n)&&(i=ne.exec(n))&&i[1]&&(n=le(e,t,i),o="number"),null!=n&&n==n&&("number"!==o||u||(n+=i&&i[3]||(k.cssNumber[s]?"":"px")),y.clearCloneStyle||""!==n||0!==t.indexOf("background")||(l[t]="inherit"),a&&"set"in a&&void 0===(n=a.set(e,n,r))||(u?l.setProperty(t,n):l[t]=n))}},css:function(e,t,n,r){var i,o,a,s=V(t);return Qe.test(t)||(t=Ge(s)),(a=k.cssHooks[t]||k.cssHooks[s])&&"get"in a&&(i=a.get(e,!0,n)),void 0===i&&(i=_e(e,t,r)),"normal"===i&&t in Ke&&(i=Ke[t]),""===n||n?(o=parseFloat(i),!0===n||isFinite(o)?o||0:i):i}}),k.each(["height","width"],function(e,u){k.cssHooks[u]={get:function(e,t,n){if(t)return!Ye.test(k.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?tt(e,u,n):ue(e,Je,function(){return tt(e,u,n)})},set:function(e,t,n){var r,i=Fe(e),o=!y.scrollboxSize()&&"absolute"===i.position,a=(o||n)&&"border-box"===k.css(e,"boxSizing",!1,i),s=n?et(e,u,n,a,i):0;return a&&o&&(s-=Math.ceil(e["offset"+u[0].toUpperCase()+u.slice(1)]-parseFloat(i[u])-et(e,u,"border",!1,i)-.5)),s&&(r=ne.exec(t))&&"px"!==(r[3]||"px")&&(e.style[u]=t,t=k.css(e,u)),Ze(0,t,s)}}}),k.cssHooks.marginLeft=ze(y.reliableMarginLeft,function(e,t){if(t)return(parseFloat(_e(e,"marginLeft"))||e.getBoundingClientRect().left-ue(e,{marginLeft:0},function(){return e.getBoundingClientRect().left}))+"px"}),k.each({margin:"",padding:"",border:"Width"},function(i,o){k.cssHooks[i+o]={expand:function(e){for(var t=0,n={},r="string"==typeof e?e.split(" "):[e];t<4;t++)n[i+re[t]+o]=r[t]||r[t-2]||r[0];return n}},"margin"!==i&&(k.cssHooks[i+o].set=Ze)}),k.fn.extend({css:function(e,t){return _(this,function(e,t,n){var r,i,o={},a=0;if(Array.isArray(t)){for(r=Fe(e),i=t.length;a<i;a++)o[t[a]]=k.css(e,t[a],!1,r);return o}return void 0!==n?k.style(e,t,n):k.css(e,t)},e,t,1<arguments.length)}}),((k.Tween=nt).prototype={constructor:nt,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||k.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(k.cssNumber[n]?"":"px")},cur:function(){var e=nt.propHooks[this.prop];return e&&e.get?e.get(this):nt.propHooks._default.get(this)},run:function(e){var t,n=nt.propHooks[this.prop];return this.options.duration?this.pos=t=k.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):nt.propHooks._default.set(this),this}}).init.prototype=nt.prototype,(nt.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=k.css(e.elem,e.prop,""))&&"auto"!==t?t:0},set:function(e){k.fx.step[e.prop]?k.fx.step[e.prop](e):1!==e.elem.nodeType||!k.cssHooks[e.prop]&&null==e.elem.style[Ge(e.prop)]?e.elem[e.prop]=e.now:k.style(e.elem,e.prop,e.now+e.unit)}}}).scrollTop=nt.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},k.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:"swing"},k.fx=nt.prototype.init,k.fx.step={};var rt,it,ot,at,st=/^(?:toggle|show|hide)$/,ut=/queueHooks$/;function lt(){it&&(!1===E.hidden&&C.requestAnimationFrame?C.requestAnimationFrame(lt):C.setTimeout(lt,k.fx.interval),k.fx.tick())}function ct(){return C.setTimeout(function(){rt=void 0}),rt=Date.now()}function ft(e,t){var n,r=0,i={height:e};for(t=t?1:0;r<4;r+=2-t)i["margin"+(n=re[r])]=i["padding"+n]=e;return t&&(i.opacity=i.width=e),i}function pt(e,t,n){for(var r,i=(dt.tweeners[t]||[]).concat(dt.tweeners["*"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function dt(o,e,t){var n,a,r=0,i=dt.prefilters.length,s=k.Deferred().always(function(){delete u.elem}),u=function(){if(a)return!1;for(var e=rt||ct(),t=Math.max(0,l.startTime+l.duration-e),n=1-(t/l.duration||0),r=0,i=l.tweens.length;r<i;r++)l.tweens[r].run(n);return s.notifyWith(o,[l,n,t]),n<1&&i?t:(i||s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l]),!1)},l=s.promise({elem:o,props:k.extend({},e),opts:k.extend(!0,{specialEasing:{},easing:k.easing._default},t),originalProperties:e,originalOptions:t,startTime:rt||ct(),duration:t.duration,tweens:[],createTween:function(e,t){var n=k.Tween(o,l.opts,e,t,l.opts.specialEasing[e]||l.opts.easing);return l.tweens.push(n),n},stop:function(e){var t=0,n=e?l.tweens.length:0;if(a)return this;for(a=!0;t<n;t++)l.tweens[t].run(1);return e?(s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l,e])):s.rejectWith(o,[l,e]),this}}),c=l.props;for(!function(e,t){var n,r,i,o,a;for(n in e)if(i=t[r=V(n)],o=e[n],Array.isArray(o)&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),(a=k.cssHooks[r])&&"expand"in a)for(n in o=a.expand(o),delete e[r],o)n in e||(e[n]=o[n],t[n]=i);else t[r]=i}(c,l.opts.specialEasing);r<i;r++)if(n=dt.prefilters[r].call(l,o,c,l.opts))return m(n.stop)&&(k._queueHooks(l.elem,l.opts.queue).stop=n.stop.bind(n)),n;return k.map(c,pt,l),m(l.opts.start)&&l.opts.start.call(o,l),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always),k.fx.timer(k.extend(u,{elem:o,anim:l,queue:l.opts.queue})),l}k.Animation=k.extend(dt,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return le(n.elem,e,ne.exec(t),n),n}]},tweener:function(e,t){m(e)?(t=e,e=["*"]):e=e.match(R);for(var n,r=0,i=e.length;r<i;r++)n=e[r],dt.tweeners[n]=dt.tweeners[n]||[],dt.tweeners[n].unshift(t)},prefilters:[function(e,t,n){var r,i,o,a,s,u,l,c,f="width"in t||"height"in t,p=this,d={},h=e.style,g=e.nodeType&&se(e),v=Q.get(e,"fxshow");for(r in n.queue||(null==(a=k._queueHooks(e,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,p.always(function(){p.always(function(){a.unqueued--,k.queue(e,"fx").length||a.empty.fire()})})),t)if(i=t[r],st.test(i)){if(delete t[r],o=o||"toggle"===i,i===(g?"hide":"show")){if("show"!==i||!v||void 0===v[r])continue;g=!0}d[r]=v&&v[r]||k.style(e,r)}if((u=!k.isEmptyObject(t))||!k.isEmptyObject(d))for(r in f&&1===e.nodeType&&(n.overflow=[h.overflow,h.overflowX,h.overflowY],null==(l=v&&v.display)&&(l=Q.get(e,"display")),"none"===(c=k.css(e,"display"))&&(l?c=l:(fe([e],!0),l=e.style.display||l,c=k.css(e,"display"),fe([e]))),("inline"===c||"inline-block"===c&&null!=l)&&"none"===k.css(e,"float")&&(u||(p.done(function(){h.display=l}),null==l&&(c=h.display,l="none"===c?"":c)),h.display="inline-block")),n.overflow&&(h.overflow="hidden",p.always(function(){h.overflow=n.overflow[0],h.overflowX=n.overflow[1],h.overflowY=n.overflow[2]})),u=!1,d)u||(v?"hidden"in v&&(g=v.hidden):v=Q.access(e,"fxshow",{display:l}),o&&(v.hidden=!g),g&&fe([e],!0),p.done(function(){for(r in g||fe([e]),Q.remove(e,"fxshow"),d)k.style(e,r,d[r])})),u=pt(g?v[r]:0,r,p),r in v||(v[r]=u.start,g&&(u.end=u.start,u.start=0))}],prefilter:function(e,t){t?dt.prefilters.unshift(e):dt.prefilters.push(e)}}),k.speed=function(e,t,n){var r=e&&"object"==typeof e?k.extend({},e):{complete:n||!n&&t||m(e)&&e,duration:e,easing:n&&t||t&&!m(t)&&t};return k.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in k.fx.speeds?r.duration=k.fx.speeds[r.duration]:r.duration=k.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue="fx"),r.old=r.complete,r.complete=function(){m(r.old)&&r.old.call(this),r.queue&&k.dequeue(this,r.queue)},r},k.fn.extend({fadeTo:function(e,t,n,r){return this.filter(se).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(t,e,n,r){var i=k.isEmptyObject(t),o=k.speed(e,n,r),a=function(){var e=dt(this,k.extend({},t),o);(i||Q.get(this,"finish"))&&e.stop(!0)};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a)},stop:function(i,e,o){var a=function(e){var t=e.stop;delete e.stop,t(o)};return"string"!=typeof i&&(o=e,e=i,i=void 0),e&&!1!==i&&this.queue(i||"fx",[]),this.each(function(){var e=!0,t=null!=i&&i+"queueHooks",n=k.timers,r=Q.get(this);if(t)r[t]&&r[t].stop&&a(r[t]);else for(t in r)r[t]&&r[t].stop&&ut.test(t)&&a(r[t]);for(t=n.length;t--;)n[t].elem!==this||null!=i&&n[t].queue!==i||(n[t].anim.stop(o),e=!1,n.splice(t,1));!e&&o||k.dequeue(this,i)})},finish:function(a){return!1!==a&&(a=a||"fx"),this.each(function(){var e,t=Q.get(this),n=t[a+"queue"],r=t[a+"queueHooks"],i=k.timers,o=n?n.length:0;for(t.finish=!0,k.queue(this,a,[]),r&&r.stop&&r.stop.call(this,!0),e=i.length;e--;)i[e].elem===this&&i[e].queue===a&&(i[e].anim.stop(!0),i.splice(e,1));for(e=0;e<o;e++)n[e]&&n[e].finish&&n[e].finish.call(this);delete t.finish})}}),k.each(["toggle","show","hide"],function(e,r){var i=k.fn[r];k.fn[r]=function(e,t,n){return null==e||"boolean"==typeof e?i.apply(this,arguments):this.animate(ft(r,!0),e,t,n)}}),k.each({slideDown:ft("show"),slideUp:ft("hide"),slideToggle:ft("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,r){k.fn[e]=function(e,t,n){return this.animate(r,e,t,n)}}),k.timers=[],k.fx.tick=function(){var e,t=0,n=k.timers;for(rt=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||k.fx.stop(),rt=void 0},k.fx.timer=function(e){k.timers.push(e),k.fx.start()},k.fx.interval=13,k.fx.start=function(){it||(it=!0,lt())},k.fx.stop=function(){it=null},k.fx.speeds={slow:600,fast:200,_default:400},k.fn.delay=function(r,e){return r=k.fx&&k.fx.speeds[r]||r,e=e||"fx",this.queue(e,function(e,t){var n=C.setTimeout(e,r);t.stop=function(){C.clearTimeout(n)}})},ot=E.createElement("input"),at=E.createElement("select").appendChild(E.createElement("option")),ot.type="checkbox",y.checkOn=""!==ot.value,y.optSelected=at.selected,(ot=E.createElement("input")).value="t",ot.type="radio",y.radioValue="t"===ot.value;var ht,gt=k.expr.attrHandle;k.fn.extend({attr:function(e,t){return _(this,k.attr,e,t,1<arguments.length)},removeAttr:function(e){return this.each(function(){k.removeAttr(this,e)})}}),k.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return"undefined"==typeof e.getAttribute?k.prop(e,t,n):(1===o&&k.isXMLDoc(e)||(i=k.attrHooks[t.toLowerCase()]||(k.expr.match.bool.test(t)?ht:void 0)),void 0!==n?null===n?void k.removeAttr(e,t):i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:(e.setAttribute(t,n+""),n):i&&"get"in i&&null!==(r=i.get(e,t))?r:null==(r=k.find.attr(e,t))?void 0:r)},attrHooks:{type:{set:function(e,t){if(!y.radioValue&&"radio"===t&&A(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,r=0,i=t&&t.match(R);if(i&&1===e.nodeType)while(n=i[r++])e.removeAttribute(n)}}),ht={set:function(e,t,n){return!1===t?k.removeAttr(e,n):e.setAttribute(n,n),n}},k.each(k.expr.match.bool.source.match(/\w+/g),function(e,t){var a=gt[t]||k.find.attr;gt[t]=function(e,t,n){var r,i,o=t.toLowerCase();return n||(i=gt[o],gt[o]=r,r=null!=a(e,t,n)?o:null,gt[o]=i),r}});var vt=/^(?:input|select|textarea|button)$/i,yt=/^(?:a|area)$/i;function mt(e){return(e.match(R)||[]).join(" ")}function xt(e){return e.getAttribute&&e.getAttribute("class")||""}function bt(e){return Array.isArray(e)?e:"string"==typeof e&&e.match(R)||[]}k.fn.extend({prop:function(e,t){return _(this,k.prop,e,t,1<arguments.length)},removeProp:function(e){return this.each(function(){delete this[k.propFix[e]||e]})}}),k.extend({prop:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&k.isXMLDoc(e)||(t=k.propFix[t]||t,i=k.propHooks[t]),void 0!==n?i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:e[t]=n:i&&"get"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=k.find.attr(e,"tabindex");return t?parseInt(t,10):vt.test(e.nodeName)||yt.test(e.nodeName)&&e.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),y.optSelected||(k.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),k.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){k.propFix[this.toLowerCase()]=this}),k.fn.extend({addClass:function(t){var e,n,r,i,o,a,s,u=0;if(m(t))return this.each(function(e){k(this).addClass(t.call(this,e,xt(this)))});if((e=bt(t)).length)while(n=this[u++])if(i=xt(n),r=1===n.nodeType&&" "+mt(i)+" "){a=0;while(o=e[a++])r.indexOf(" "+o+" ")<0&&(r+=o+" ");i!==(s=mt(r))&&n.setAttribute("class",s)}return this},removeClass:function(t){var e,n,r,i,o,a,s,u=0;if(m(t))return this.each(function(e){k(this).removeClass(t.call(this,e,xt(this)))});if(!arguments.length)return this.attr("class","");if((e=bt(t)).length)while(n=this[u++])if(i=xt(n),r=1===n.nodeType&&" "+mt(i)+" "){a=0;while(o=e[a++])while(-1<r.indexOf(" "+o+" "))r=r.replace(" "+o+" "," ");i!==(s=mt(r))&&n.setAttribute("class",s)}return this},toggleClass:function(i,t){var o=typeof i,a="string"===o||Array.isArray(i);return"boolean"==typeof t&&a?t?this.addClass(i):this.removeClass(i):m(i)?this.each(function(e){k(this).toggleClass(i.call(this,e,xt(this),t),t)}):this.each(function(){var e,t,n,r;if(a){t=0,n=k(this),r=bt(i);while(e=r[t++])n.hasClass(e)?n.removeClass(e):n.addClass(e)}else void 0!==i&&"boolean"!==o||((e=xt(this))&&Q.set(this,"__className__",e),this.setAttribute&&this.setAttribute("class",e||!1===i?"":Q.get(this,"__className__")||""))})},hasClass:function(e){var t,n,r=0;t=" "+e+" ";while(n=this[r++])if(1===n.nodeType&&-1<(" "+mt(xt(n))+" ").indexOf(t))return!0;return!1}});var wt=/\r/g;k.fn.extend({val:function(n){var r,e,i,t=this[0];return arguments.length?(i=m(n),this.each(function(e){var t;1===this.nodeType&&(null==(t=i?n.call(this,e,k(this).val()):n)?t="":"number"==typeof t?t+="":Array.isArray(t)&&(t=k.map(t,function(e){return null==e?"":e+""})),(r=k.valHooks[this.type]||k.valHooks[this.nodeName.toLowerCase()])&&"set"in r&&void 0!==r.set(this,t,"value")||(this.value=t))})):t?(r=k.valHooks[t.type]||k.valHooks[t.nodeName.toLowerCase()])&&"get"in r&&void 0!==(e=r.get(t,"value"))?e:"string"==typeof(e=t.value)?e.replace(wt,""):null==e?"":e:void 0}}),k.extend({valHooks:{option:{get:function(e){var t=k.find.attr(e,"value");return null!=t?t:mt(k.text(e))}},select:{get:function(e){var t,n,r,i=e.options,o=e.selectedIndex,a="select-one"===e.type,s=a?null:[],u=a?o+1:i.length;for(r=o<0?u:a?o:0;r<u;r++)if(((n=i[r]).selected||r===o)&&!n.disabled&&(!n.parentNode.disabled||!A(n.parentNode,"optgroup"))){if(t=k(n).val(),a)return t;s.push(t)}return s},set:function(e,t){var n,r,i=e.options,o=k.makeArray(t),a=i.length;while(a--)((r=i[a]).selected=-1<k.inArray(k.valHooks.option.get(r),o))&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),k.each(["radio","checkbox"],function(){k.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=-1<k.inArray(k(e).val(),t)}},y.checkOn||(k.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})}),y.focusin="onfocusin"in C;var Tt=/^(?:focusinfocus|focusoutblur)$/,Ct=function(e){e.stopPropagation()};k.extend(k.event,{trigger:function(e,t,n,r){var i,o,a,s,u,l,c,f,p=[n||E],d=v.call(e,"type")?e.type:e,h=v.call(e,"namespace")?e.namespace.split("."):[];if(o=f=a=n=n||E,3!==n.nodeType&&8!==n.nodeType&&!Tt.test(d+k.event.triggered)&&(-1<d.indexOf(".")&&(d=(h=d.split(".")).shift(),h.sort()),u=d.indexOf(":")<0&&"on"+d,(e=e[k.expando]?e:new k.Event(d,"object"==typeof e&&e)).isTrigger=r?2:3,e.namespace=h.join("."),e.rnamespace=e.namespace?new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,e.result=void 0,e.target||(e.target=n),t=null==t?[e]:k.makeArray(t,[e]),c=k.event.special[d]||{},r||!c.trigger||!1!==c.trigger.apply(n,t))){if(!r&&!c.noBubble&&!x(n)){for(s=c.delegateType||d,Tt.test(s+d)||(o=o.parentNode);o;o=o.parentNode)p.push(o),a=o;a===(n.ownerDocument||E)&&p.push(a.defaultView||a.parentWindow||C)}i=0;while((o=p[i++])&&!e.isPropagationStopped())f=o,e.type=1<i?s:c.bindType||d,(l=(Q.get(o,"events")||{})[e.type]&&Q.get(o,"handle"))&&l.apply(o,t),(l=u&&o[u])&&l.apply&&G(o)&&(e.result=l.apply(o,t),!1===e.result&&e.preventDefault());return e.type=d,r||e.isDefaultPrevented()||c._default&&!1!==c._default.apply(p.pop(),t)||!G(n)||u&&m(n[d])&&!x(n)&&((a=n[u])&&(n[u]=null),k.event.triggered=d,e.isPropagationStopped()&&f.addEventListener(d,Ct),n[d](),e.isPropagationStopped()&&f.removeEventListener(d,Ct),k.event.triggered=void 0,a&&(n[u]=a)),e.result}},simulate:function(e,t,n){var r=k.extend(new k.Event,n,{type:e,isSimulated:!0});k.event.trigger(r,null,t)}}),k.fn.extend({trigger:function(e,t){return this.each(function(){k.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return k.event.trigger(e,t,n,!0)}}),y.focusin||k.each({focus:"focusin",blur:"focusout"},function(n,r){var i=function(e){k.event.simulate(r,e.target,k.event.fix(e))};k.event.special[r]={setup:function(){var e=this.ownerDocument||this,t=Q.access(e,r);t||e.addEventListener(n,i,!0),Q.access(e,r,(t||0)+1)},teardown:function(){var e=this.ownerDocument||this,t=Q.access(e,r)-1;t?Q.access(e,r,t):(e.removeEventListener(n,i,!0),Q.remove(e,r))}}});var Et=C.location,kt=Date.now(),St=/\?/;k.parseXML=function(e){var t;if(!e||"string"!=typeof e)return null;try{t=(new C.DOMParser).parseFromString(e,"text/xml")}catch(e){t=void 0}return t&&!t.getElementsByTagName("parsererror").length||k.error("Invalid XML: "+e),t};var Nt=/\[\]$/,At=/\r?\n/g,Dt=/^(?:submit|button|image|reset|file)$/i,jt=/^(?:input|select|textarea|keygen)/i;function qt(n,e,r,i){var t;if(Array.isArray(e))k.each(e,function(e,t){r||Nt.test(n)?i(n,t):qt(n+"["+("object"==typeof t&&null!=t?e:"")+"]",t,r,i)});else if(r||"object"!==w(e))i(n,e);else for(t in e)qt(n+"["+t+"]",e[t],r,i)}k.param=function(e,t){var n,r=[],i=function(e,t){var n=m(t)?t():t;r[r.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(null==e)return"";if(Array.isArray(e)||e.jquery&&!k.isPlainObject(e))k.each(e,function(){i(this.name,this.value)});else for(n in e)qt(n,e[n],t,i);return r.join("&")},k.fn.extend({serialize:function(){return k.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=k.prop(this,"elements");return e?k.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!k(this).is(":disabled")&&jt.test(this.nodeName)&&!Dt.test(e)&&(this.checked||!pe.test(e))}).map(function(e,t){var n=k(this).val();return null==n?null:Array.isArray(n)?k.map(n,function(e){return{name:t.name,value:e.replace(At,"\r\n")}}):{name:t.name,value:n.replace(At,"\r\n")}}).get()}});var Lt=/%20/g,Ht=/#.*$/,Ot=/([?&])_=[^&]*/,Pt=/^(.*?):[ \t]*([^\r\n]*)$/gm,Rt=/^(?:GET|HEAD)$/,Mt=/^\/\//,It={},Wt={},$t="*/".concat("*"),Ft=E.createElement("a");function Bt(o){return function(e,t){"string"!=typeof e&&(t=e,e="*");var n,r=0,i=e.toLowerCase().match(R)||[];if(m(t))while(n=i[r++])"+"===n[0]?(n=n.slice(1)||"*",(o[n]=o[n]||[]).unshift(t)):(o[n]=o[n]||[]).push(t)}}function _t(t,i,o,a){var s={},u=t===Wt;function l(e){var r;return s[e]=!0,k.each(t[e]||[],function(e,t){var n=t(i,o,a);return"string"!=typeof n||u||s[n]?u?!(r=n):void 0:(i.dataTypes.unshift(n),l(n),!1)}),r}return l(i.dataTypes[0])||!s["*"]&&l("*")}function zt(e,t){var n,r,i=k.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((i[n]?e:r||(r={}))[n]=t[n]);return r&&k.extend(!0,e,r),e}Ft.href=Et.href,k.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Et.href,type:"GET",isLocal:/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Et.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":$t,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":k.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?zt(zt(e,k.ajaxSettings),t):zt(k.ajaxSettings,e)},ajaxPrefilter:Bt(It),ajaxTransport:Bt(Wt),ajax:function(e,t){"object"==typeof e&&(t=e,e=void 0),t=t||{};var c,f,p,n,d,r,h,g,i,o,v=k.ajaxSetup({},t),y=v.context||v,m=v.context&&(y.nodeType||y.jquery)?k(y):k.event,x=k.Deferred(),b=k.Callbacks("once memory"),w=v.statusCode||{},a={},s={},u="canceled",T={readyState:0,getResponseHeader:function(e){var t;if(h){if(!n){n={};while(t=Pt.exec(p))n[t[1].toLowerCase()+" "]=(n[t[1].toLowerCase()+" "]||[]).concat(t[2])}t=n[e.toLowerCase()+" "]}return null==t?null:t.join(", ")},getAllResponseHeaders:function(){return h?p:null},setRequestHeader:function(e,t){return null==h&&(e=s[e.toLowerCase()]=s[e.toLowerCase()]||e,a[e]=t),this},overrideMimeType:function(e){return null==h&&(v.mimeType=e),this},statusCode:function(e){var t;if(e)if(h)T.always(e[T.status]);else for(t in e)w[t]=[w[t],e[t]];return this},abort:function(e){var t=e||u;return c&&c.abort(t),l(0,t),this}};if(x.promise(T),v.url=((e||v.url||Et.href)+"").replace(Mt,Et.protocol+"//"),v.type=t.method||t.type||v.method||v.type,v.dataTypes=(v.dataType||"*").toLowerCase().match(R)||[""],null==v.crossDomain){r=E.createElement("a");try{r.href=v.url,r.href=r.href,v.crossDomain=Ft.protocol+"//"+Ft.host!=r.protocol+"//"+r.host}catch(e){v.crossDomain=!0}}if(v.data&&v.processData&&"string"!=typeof v.data&&(v.data=k.param(v.data,v.traditional)),_t(It,v,t,T),h)return T;for(i in(g=k.event&&v.global)&&0==k.active++&&k.event.trigger("ajaxStart"),v.type=v.type.toUpperCase(),v.hasContent=!Rt.test(v.type),f=v.url.replace(Ht,""),v.hasContent?v.data&&v.processData&&0===(v.contentType||"").indexOf("application/x-www-form-urlencoded")&&(v.data=v.data.replace(Lt,"+")):(o=v.url.slice(f.length),v.data&&(v.processData||"string"==typeof v.data)&&(f+=(St.test(f)?"&":"?")+v.data,delete v.data),!1===v.cache&&(f=f.replace(Ot,"$1"),o=(St.test(f)?"&":"?")+"_="+kt+++o),v.url=f+o),v.ifModified&&(k.lastModified[f]&&T.setRequestHeader("If-Modified-Since",k.lastModified[f]),k.etag[f]&&T.setRequestHeader("If-None-Match",k.etag[f])),(v.data&&v.hasContent&&!1!==v.contentType||t.contentType)&&T.setRequestHeader("Content-Type",v.contentType),T.setRequestHeader("Accept",v.dataTypes[0]&&v.accepts[v.dataTypes[0]]?v.accepts[v.dataTypes[0]]+("*"!==v.dataTypes[0]?", "+$t+"; q=0.01":""):v.accepts["*"]),v.headers)T.setRequestHeader(i,v.headers[i]);if(v.beforeSend&&(!1===v.beforeSend.call(y,T,v)||h))return T.abort();if(u="abort",b.add(v.complete),T.done(v.success),T.fail(v.error),c=_t(Wt,v,t,T)){if(T.readyState=1,g&&m.trigger("ajaxSend",[T,v]),h)return T;v.async&&0<v.timeout&&(d=C.setTimeout(function(){T.abort("timeout")},v.timeout));try{h=!1,c.send(a,l)}catch(e){if(h)throw e;l(-1,e)}}else l(-1,"No Transport");function l(e,t,n,r){var i,o,a,s,u,l=t;h||(h=!0,d&&C.clearTimeout(d),c=void 0,p=r||"",T.readyState=0<e?4:0,i=200<=e&&e<300||304===e,n&&(s=function(e,t,n){var r,i,o,a,s=e.contents,u=e.dataTypes;while("*"===u[0])u.shift(),void 0===r&&(r=e.mimeType||t.getResponseHeader("Content-Type"));if(r)for(i in s)if(s[i]&&s[i].test(r)){u.unshift(i);break}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||e.converters[i+" "+u[0]]){o=i;break}a||(a=i)}o=o||a}if(o)return o!==u[0]&&u.unshift(o),n[o]}(v,T,n)),s=function(e,t,n,r){var i,o,a,s,u,l={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)l[a.toLowerCase()]=e.converters[a];o=c.shift();while(o)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!u&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u=o,o=c.shift())if("*"===o)o=u;else if("*"!==u&&u!==o){if(!(a=l[u+" "+o]||l["* "+o]))for(i in l)if((s=i.split(" "))[1]===o&&(a=l[u+" "+s[0]]||l["* "+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e["throws"])t=a(t);else try{t=a(t)}catch(e){return{state:"parsererror",error:a?e:"No conversion from "+u+" to "+o}}}return{state:"success",data:t}}(v,s,T,i),i?(v.ifModified&&((u=T.getResponseHeader("Last-Modified"))&&(k.lastModified[f]=u),(u=T.getResponseHeader("etag"))&&(k.etag[f]=u)),204===e||"HEAD"===v.type?l="nocontent":304===e?l="notmodified":(l=s.state,o=s.data,i=!(a=s.error))):(a=l,!e&&l||(l="error",e<0&&(e=0))),T.status=e,T.statusText=(t||l)+"",i?x.resolveWith(y,[o,l,T]):x.rejectWith(y,[T,l,a]),T.statusCode(w),w=void 0,g&&m.trigger(i?"ajaxSuccess":"ajaxError",[T,v,i?o:a]),b.fireWith(y,[T,l]),g&&(m.trigger("ajaxComplete",[T,v]),--k.active||k.event.trigger("ajaxStop")))}return T},getJSON:function(e,t,n){return k.get(e,t,n,"json")},getScript:function(e,t){return k.get(e,void 0,t,"script")}}),k.each(["get","post"],function(e,i){k[i]=function(e,t,n,r){return m(t)&&(r=r||n,n=t,t=void 0),k.ajax(k.extend({url:e,type:i,dataType:r,data:t,success:n},k.isPlainObject(e)&&e))}}),k._evalUrl=function(e,t){return k.ajax({url:e,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,converters:{"text script":function(){}},dataFilter:function(e){k.globalEval(e,t)}})},k.fn.extend({wrapAll:function(e){var t;return this[0]&&(m(e)&&(e=e.call(this[0])),t=k(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstElementChild)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(n){return m(n)?this.each(function(e){k(this).wrapInner(n.call(this,e))}):this.each(function(){var e=k(this),t=e.contents();t.length?t.wrapAll(n):e.append(n)})},wrap:function(t){var n=m(t);return this.each(function(e){k(this).wrapAll(n?t.call(this,e):t)})},unwrap:function(e){return this.parent(e).not("body").each(function(){k(this).replaceWith(this.childNodes)}),this}}),k.expr.pseudos.hidden=function(e){return!k.expr.pseudos.visible(e)},k.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},k.ajaxSettings.xhr=function(){try{return new C.XMLHttpRequest}catch(e){}};var Ut={0:200,1223:204},Xt=k.ajaxSettings.xhr();y.cors=!!Xt&&"withCredentials"in Xt,y.ajax=Xt=!!Xt,k.ajaxTransport(function(i){var o,a;if(y.cors||Xt&&!i.crossDomain)return{send:function(e,t){var n,r=i.xhr();if(r.open(i.type,i.url,i.async,i.username,i.password),i.xhrFields)for(n in i.xhrFields)r[n]=i.xhrFields[n];for(n in i.mimeType&&r.overrideMimeType&&r.overrideMimeType(i.mimeType),i.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest"),e)r.setRequestHeader(n,e[n]);o=function(e){return function(){o&&(o=a=r.onload=r.onerror=r.onabort=r.ontimeout=r.onreadystatechange=null,"abort"===e?r.abort():"error"===e?"number"!=typeof r.status?t(0,"error"):t(r.status,r.statusText):t(Ut[r.status]||r.status,r.statusText,"text"!==(r.responseType||"text")||"string"!=typeof r.responseText?{binary:r.response}:{text:r.responseText},r.getAllResponseHeaders()))}},r.onload=o(),a=r.onerror=r.ontimeout=o("error"),void 0!==r.onabort?r.onabort=a:r.onreadystatechange=function(){4===r.readyState&&C.setTimeout(function(){o&&a()})},o=o("abort");try{r.send(i.hasContent&&i.data||null)}catch(e){if(o)throw e}},abort:function(){o&&o()}}}),k.ajaxPrefilter(function(e){e.crossDomain&&(e.contents.script=!1)}),k.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(e){return k.globalEval(e),e}}}),k.ajaxPrefilter("script",function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type="GET")}),k.ajaxTransport("script",function(n){var r,i;if(n.crossDomain||n.scriptAttrs)return{send:function(e,t){r=k("<script>").attr(n.scriptAttrs||{}).prop({charset:n.scriptCharset,src:n.url}).on("load error",i=function(e){r.remove(),i=null,e&&t("error"===e.type?404:200,e.type)}),E.head.appendChild(r[0])},abort:function(){i&&i()}}});var Vt,Gt=[],Yt=/(=)\?(?=&|$)|\?\?/;k.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=Gt.pop()||k.expando+"_"+kt++;return this[e]=!0,e}}),k.ajaxPrefilter("json jsonp",function(e,t,n){var r,i,o,a=!1!==e.jsonp&&(Yt.test(e.url)?"url":"string"==typeof e.data&&0===(e.contentType||"").indexOf("application/x-www-form-urlencoded")&&Yt.test(e.data)&&"data");if(a||"jsonp"===e.dataTypes[0])return r=e.jsonpCallback=m(e.jsonpCallback)?e.jsonpCallback():e.jsonpCallback,a?e[a]=e[a].replace(Yt,"$1"+r):!1!==e.jsonp&&(e.url+=(St.test(e.url)?"&":"?")+e.jsonp+"="+r),e.converters["script json"]=function(){return o||k.error(r+" was not called"),o[0]},e.dataTypes[0]="json",i=C[r],C[r]=function(){o=arguments},n.always(function(){void 0===i?k(C).removeProp(r):C[r]=i,e[r]&&(e.jsonpCallback=t.jsonpCallback,Gt.push(r)),o&&m(i)&&i(o[0]),o=i=void 0}),"script"}),y.createHTMLDocument=((Vt=E.implementation.createHTMLDocument("").body).innerHTML="<form></form><form></form>",2===Vt.childNodes.length),k.parseHTML=function(e,t,n){return"string"!=typeof e?[]:("boolean"==typeof t&&(n=t,t=!1),t||(y.createHTMLDocument?((r=(t=E.implementation.createHTMLDocument("")).createElement("base")).href=E.location.href,t.head.appendChild(r)):t=E),o=!n&&[],(i=D.exec(e))?[t.createElement(i[1])]:(i=we([e],t,o),o&&o.length&&k(o).remove(),k.merge([],i.childNodes)));var r,i,o},k.fn.load=function(e,t,n){var r,i,o,a=this,s=e.indexOf(" ");return-1<s&&(r=mt(e.slice(s)),e=e.slice(0,s)),m(t)?(n=t,t=void 0):t&&"object"==typeof t&&(i="POST"),0<a.length&&k.ajax({url:e,type:i||"GET",dataType:"html",data:t}).done(function(e){o=arguments,a.html(r?k("<div>").append(k.parseHTML(e)).find(r):e)}).always(n&&function(e,t){a.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},k.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){k.fn[t]=function(e){return this.on(t,e)}}),k.expr.pseudos.animated=function(t){return k.grep(k.timers,function(e){return t===e.elem}).length},k.offset={setOffset:function(e,t,n){var r,i,o,a,s,u,l=k.css(e,"position"),c=k(e),f={};"static"===l&&(e.style.position="relative"),s=c.offset(),o=k.css(e,"top"),u=k.css(e,"left"),("absolute"===l||"fixed"===l)&&-1<(o+u).indexOf("auto")?(a=(r=c.position()).top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(u)||0),m(t)&&(t=t.call(e,n,k.extend({},s))),null!=t.top&&(f.top=t.top-s.top+a),null!=t.left&&(f.left=t.left-s.left+i),"using"in t?t.using.call(e,f):c.css(f)}},k.fn.extend({offset:function(t){if(arguments.length)return void 0===t?this:this.each(function(e){k.offset.setOffset(this,t,e)});var e,n,r=this[0];return r?r.getClientRects().length?(e=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:e.top+n.pageYOffset,left:e.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var e,t,n,r=this[0],i={top:0,left:0};if("fixed"===k.css(r,"position"))t=r.getBoundingClientRect();else{t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;while(e&&(e===n.body||e===n.documentElement)&&"static"===k.css(e,"position"))e=e.parentNode;e&&e!==r&&1===e.nodeType&&((i=k(e).offset()).top+=k.css(e,"borderTopWidth",!0),i.left+=k.css(e,"borderLeftWidth",!0))}return{top:t.top-i.top-k.css(r,"marginTop",!0),left:t.left-i.left-k.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent;while(e&&"static"===k.css(e,"position"))e=e.offsetParent;return e||ie})}}),k.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(t,i){var o="pageYOffset"===i;k.fn[t]=function(e){return _(this,function(e,t,n){var r;if(x(e)?r=e:9===e.nodeType&&(r=e.defaultView),void 0===n)return r?r[i]:e[t];r?r.scrollTo(o?r.pageXOffset:n,o?n:r.pageYOffset):e[t]=n},t,e,arguments.length)}}),k.each(["top","left"],function(e,n){k.cssHooks[n]=ze(y.pixelPosition,function(e,t){if(t)return t=_e(e,n),$e.test(t)?k(e).position()[n]+"px":t})}),k.each({Height:"height",Width:"width"},function(a,s){k.each({padding:"inner"+a,content:s,"":"outer"+a},function(r,o){k.fn[o]=function(e,t){var n=arguments.length&&(r||"boolean"!=typeof e),i=r||(!0===e||!0===t?"margin":"border");return _(this,function(e,t,n){var r;return x(e)?0===o.indexOf("outer")?e["inner"+a]:e.document.documentElement["client"+a]:9===e.nodeType?(r=e.documentElement,Math.max(e.body["scroll"+a],r["scroll"+a],e.body["offset"+a],r["offset"+a],r["client"+a])):void 0===n?k.css(e,t,i):k.style(e,t,n,i)},s,n?e:void 0,n)}})}),k.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(e,n){k.fn[n]=function(e,t){return 0<arguments.length?this.on(n,null,e,t):this.trigger(n)}}),k.fn.extend({hover:function(e,t){return this.mouseenter(e).mouseleave(t||e)}}),k.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)}}),k.proxy=function(e,t){var n,r,i;if("string"==typeof t&&(n=e[t],t=e,e=n),m(e))return r=s.call(arguments,2),(i=function(){return e.apply(t||this,r.concat(s.call(arguments)))}).guid=e.guid=e.guid||k.guid++,i},k.holdReady=function(e){e?k.readyWait++:k.ready(!0)},k.isArray=Array.isArray,k.parseJSON=JSON.parse,k.nodeName=A,k.isFunction=m,k.isWindow=x,k.camelCase=V,k.type=w,k.now=Date.now,k.isNumeric=function(e){var t=k.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},"function"==typeof define&&define.amd&&define("jquery",[],function(){return k});var Qt=C.jQuery,Jt=C.$;return k.noConflict=function(e){return C.$===k&&(C.$=Jt),e&&C.jQuery===k&&(C.jQuery=Qt),k},e||(C.jQuery=C.$=k),k});
/*!
 * jQuery Browser Plugin 0.1.0
 * https://github.com/gabceb/jquery-browser-plugin
 *
 * Original jquery-browser code Copyright 2005, 2015 jQuery Foundation, Inc. and other contributors
 * http://jquery.org/license
 *
 * Modifications Copyright 2015 Gabriel Cebrian
 * https://github.com/gabceb
 *
 * Released under the MIT license
 *
 * Date: 23-11-2015
 */!function(a){"function"==typeof define&&define.amd?define(["jquery"],function(b){return a(b)}):"object"==typeof module&&"object"==typeof module.exports?module.exports=a(require("jquery")):a(window.jQuery)}(function(a){"use strict";function b(a){void 0===a&&(a=window.navigator.userAgent),a=a.toLowerCase();var b=/(edge)\/([\w.]+)/.exec(a)||/(opr)[\/]([\w.]+)/.exec(a)||/(chrome)[ \/]([\w.]+)/.exec(a)||/(iemobile)[\/]([\w.]+)/.exec(a)||/(version)(applewebkit)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec(a)||/(webkit)[ \/]([\w.]+).*(version)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec(a)||/(webkit)[ \/]([\w.]+)/.exec(a)||/(opera)(?:.*version|)[ \/]([\w.]+)/.exec(a)||/(msie) ([\w.]+)/.exec(a)||a.indexOf("trident")>=0&&/(rv)(?::| )([\w.]+)/.exec(a)||a.indexOf("compatible")<0&&/(mozilla)(?:.*? rv:([\w.]+)|)/.exec(a)||[],c=/(ipad)/.exec(a)||/(ipod)/.exec(a)||/(windows phone)/.exec(a)||/(iphone)/.exec(a)||/(kindle)/.exec(a)||/(silk)/.exec(a)||/(android)/.exec(a)||/(win)/.exec(a)||/(mac)/.exec(a)||/(linux)/.exec(a)||/(cros)/.exec(a)||/(playbook)/.exec(a)||/(bb)/.exec(a)||/(blackberry)/.exec(a)||[],d={},e={browser:b[5]||b[3]||b[1]||"",version:b[2]||b[4]||"0",versionNumber:b[4]||b[2]||"0",platform:c[0]||""};if(e.browser&&(d[e.browser]=!0,d.version=e.version,d.versionNumber=parseInt(e.versionNumber,10)),e.platform&&(d[e.platform]=!0),(d.android||d.bb||d.blackberry||d.ipad||d.iphone||d.ipod||d.kindle||d.playbook||d.silk||d["windows phone"])&&(d.mobile=!0),(d.cros||d.mac||d.linux||d.win)&&(d.desktop=!0),(d.chrome||d.opr||d.safari)&&(d.webkit=!0),d.rv||d.iemobile){var f="msie";e.browser=f,d[f]=!0}if(d.edge){delete d.edge;var g="msedge";e.browser=g,d[g]=!0}if(d.safari&&d.blackberry){var h="blackberry";e.browser=h,d[h]=!0}if(d.safari&&d.playbook){var i="playbook";e.browser=i,d[i]=!0}if(d.bb){var j="blackberry";e.browser=j,d[j]=!0}if(d.opr){var k="opera";e.browser=k,d[k]=!0}if(d.safari&&d.android){var l="android";e.browser=l,d[l]=!0}if(d.safari&&d.kindle){var m="kindle";e.browser=m,d[m]=!0}if(d.safari&&d.silk){var n="silk";e.browser=n,d[n]=!0}return d.name=e.browser,d.platform=e.platform,d}return window.jQBrowser=b(window.navigator.userAgent),window.jQBrowser.uaMatch=b,a&&(a.browser=window.jQBrowser),window.jQBrowser});
/*! device.js 0.1.61 */
(function(){var a,b,c,d,e,f,g,h,i,j;a=window.device,window.device={},c=window.document.documentElement,j=window.navigator.userAgent.toLowerCase(),device.ios=function(){return device.iphone()||device.ipod()||device.ipad()},device.iphone=function(){return d("iphone")},device.ipod=function(){return d("ipod")},device.ipad=function(){return d("ipad")},device.android=function(){return d("android")},device.androidPhone=function(){return device.android()&&d("mobile")},device.androidTablet=function(){return device.android()&&!d("mobile")},device.blackberry=function(){return d("blackberry")||d("bb10")||d("rim")},device.blackberryPhone=function(){return device.blackberry()&&!d("tablet")},device.blackberryTablet=function(){return device.blackberry()&&d("tablet")},device.windows=function(){return d("windows")},device.windowsPhone=function(){return device.windows()&&d("phone")},device.windowsTablet=function(){return device.windows()&&d("touch")&&!device.windowsPhone()},device.fxos=function(){return(d("(mobile;")||d("(tablet;"))&&d("; rv:")},device.fxosPhone=function(){return device.fxos()&&d("mobile")},device.fxosTablet=function(){return device.fxos()&&d("tablet")},device.meego=function(){return d("meego")},device.cordova=function(){return window.cordova&&"file:"===location.protocol},device.nodeWebkit=function(){return"object"==typeof window.process},device.mobile=function(){return device.androidPhone()||device.iphone()||device.ipod()||device.windowsPhone()||device.blackberryPhone()||device.fxosPhone()||device.meego()},device.tablet=function(){return device.ipad()||device.androidTablet()||device.blackberryTablet()||device.windowsTablet()||device.fxosTablet()},device.desktop=function(){return!device.tablet()&&!device.mobile()},device.portrait=function(){return window.innerHeight/window.innerWidth>1},device.landscape=function(){return window.innerHeight/window.innerWidth<1},device.noConflict=function(){return window.device=a,this},d=function(a){return-1!==j.indexOf(a)},f=function(a){var b;return b=new RegExp(a,"i"),c.className.match(b)},b=function(a){return f(a)?void 0:c.className+=" "+a},h=function(a){return f(a)?c.className=c.className.replace(a,""):void 0},device.ios()?device.ipad()?b("ios ipad tablet"):device.iphone()?b("ios iphone mobile"):device.ipod()&&b("ios ipod mobile"):b(device.android()?device.androidTablet()?"android tablet":"android mobile":device.blackberry()?device.blackberryTablet()?"blackberry tablet":"blackberry mobile":device.windows()?device.windowsTablet()?"windows tablet":device.windowsPhone()?"windows mobile":"desktop":device.fxos()?device.fxosTablet()?"fxos tablet":"fxos mobile":device.meego()?"meego mobile":device.nodeWebkit()?"node-webkit":"desktop"),device.cordova()&&b("cordova"),e=function(){return device.landscape()?(h("portrait"),b("landscape")):(h("landscape"),b("portrait"))},i="onorientationchange"in window,g=i?"orientationchange":"resize",window.addEventListener?window.addEventListener(g,e,!1):window.attachEvent?window.attachEvent(g,e):window[g]=e,e()}).call(this);
// Unobtrusive Ajax support library for jQuery
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// @version v3.2.6
// 
// Microsoft grants you the right to use these script files for the sole
// purpose of either: (i) interacting through your browser with the Microsoft
// website or online service, subject to the applicable licensing or use
// terms; or (ii) using the files as included with a Microsoft product subject
// to that product's license terms. Microsoft reserves all other rights to the
// files not expressly granted by Microsoft, whether by implication, estoppel
// or otherwise. Insofar as a script file is dual licensed under GPL,
// Microsoft neither took the code under GPL nor distributes it thereunder but
// under the terms set out in this paragraph. All notices and licenses
// below are for informational purposes only.
!function(t){function a(t,a){for(var e=window,r=(t||"").split(".");e&&r.length;)e=e[r.shift()];return"function"==typeof e?e:(a.push(t),Function.constructor.apply(null,a))}function e(t){return"GET"===t||"POST"===t}function r(t,a){e(a)||t.setRequestHeader("X-HTTP-Method-Override",a)}function n(a,e,r){var n;r.indexOf("application/x-javascript")===-1&&(n=(a.getAttribute("data-ajax-mode")||"").toUpperCase(),t(a.getAttribute("data-ajax-update")).each(function(a,r){switch(n){case"BEFORE":t(r).prepend(e);break;case"AFTER":t(r).append(e);break;case"REPLACE-WITH":t(r).replaceWith(e);break;default:t(r).html(e)}}))}function i(i,u){var o,c,d,s;if(o=i.getAttribute("data-ajax-confirm"),!o||window.confirm(o)){c=t(i.getAttribute("data-ajax-loading")),s=parseInt(i.getAttribute("data-ajax-loading-duration"),10)||0,t.extend(u,{type:i.getAttribute("data-ajax-method")||void 0,url:i.getAttribute("data-ajax-url")||void 0,cache:"true"===(i.getAttribute("data-ajax-cache")||"").toLowerCase(),beforeSend:function(t){var e;return r(t,d),e=a(i.getAttribute("data-ajax-begin"),["xhr"]).apply(i,arguments),e!==!1&&c.show(s),e},complete:function(){c.hide(s),a(i.getAttribute("data-ajax-complete"),["xhr","status"]).apply(i,arguments)},success:function(t,e,r){n(i,t,r.getResponseHeader("Content-Type")||"text/html"),a(i.getAttribute("data-ajax-success"),["data","status","xhr"]).apply(i,arguments)},error:function(){a(i.getAttribute("data-ajax-failure"),["xhr","status","error"]).apply(i,arguments)}}),u.data.push({name:"X-Requested-With",value:"XMLHttpRequest"}),d=u.type.toUpperCase(),e(d)||(u.type="POST",u.data.push({name:"X-HTTP-Method-Override",value:d}));var p=t(i);if(p.is("form")&&"multipart/form-data"==p.attr("enctype")){var f=new FormData;t.each(u.data,function(t,a){f.append(a.name,a.value)}),t("input[type=file]",p).each(function(){var a=this;t.each(a.files,function(t,e){f.append(a.name,e)})}),t.extend(u,{processData:!1,contentType:!1,data:f})}t.ajax(u)}}function u(a){var e=t(a).data(d);return!e||!e.validate||e.validate()}var o="unobtrusiveAjaxClick",c="unobtrusiveAjaxClickTarget",d="unobtrusiveValidation";t(document).on("click","a[data-ajax=true]",function(t){t.preventDefault(),i(this,{url:this.href,type:"GET",data:[]})}),t(document).on("click","form[data-ajax=true] input[type=image]",function(a){var e=a.target.name,r=t(a.target),n=t(r.parents("form")[0]),i=r.offset();n.data(o,[{name:e+".x",value:Math.round(a.pageX-i.left)},{name:e+".y",value:Math.round(a.pageY-i.top)}]),setTimeout(function(){n.removeData(o)},0)}),t(document).on("click","form[data-ajax=true] :submit",function(a){var e=a.currentTarget.name,r=t(a.target),n=t(r.parents("form")[0]);n.data(o,e?[{name:e,value:a.currentTarget.value}]:[]),n.data(c,r),setTimeout(function(){n.removeData(o),n.removeData(c)},0)}),t(document).on("submit","form[data-ajax=true]",function(a){var e=t(this).data(o)||[],r=t(this).data(c),n=r&&(r.hasClass("cancel")||void 0!==r.attr("formnovalidate"));a.preventDefault(),(n||u(this))&&i(this,{url:this.action,type:this.method||"GET",data:e.concat(t(this).serializeArray())})})}(jQuery);
var AjaxCall = function () {};

AjaxCall.responseIsRequested = false;
AjaxCall.requestCount = 0;
window.onbeforeunload = function (e) {
    if (AjaxCall.responseIsRequested) {
        e.returnValue = 'Are you sure you want to leave?';
    }
}
AjaxCall.bindLoader = function () {
    AjaxCall.responseIsRequested = true;
    AjaxCall.requestCount += 1;
    $('.loader').trigger('custom_show');

    clearTimeout(AjaxCall.timeout);
    AjaxCall.timeout = setTimeout(function () {
        AjaxCall.requestCount = 0;
        AjaxCall.possiblyUnbindLoader();
    }, 2000);
}
AjaxCall.possiblyUnbindLoader = function () {
    AjaxCall.requestCount -= 1;
    if (AjaxCall.requestCount < 0) {
        AjaxCall.requestCount = 0;
    }

    if (AjaxCall.requestCount == 0) {
        AjaxCall.responseIsRequested = false;
        $('.loader').trigger('custom_hide');
    }
}

AjaxCall.send = function (path, request, success) {
    AjaxCall.bindLoader();

    var data = request ? JSON.stringify(request) : null;
    var type = request ? 'POST' : 'GET';

    return $.ajax({
        type: type,
        contentType: 'application/json; charset=utf-8',
        url: path,
        data: data,
        success: function (result, textStatus, xhr) {
            AjaxCall.success(result, xhr, success);
            AjaxCall.possiblyUnbindLoader();
        },
        error: function (xhr) {
            AjaxCall.possiblyUnbindLoader();
            if (xhr.responseText) {
                var errorObject = JSON.parse(xhr.responseText);
                alert('An error has occurred: ' + errorObject.Message);
            }
        },
        async: window.async
    });

};

AjaxCall.getHtml = function (path, request, success) {
    AjaxCall.bindLoader();

    var data = request ? JSON.stringify(request) : null;

    return $.ajax({
        type: 'GET',
        contentType: 'application/json; charset=utf-8',
        dataType: 'html',
        url: path,
        data: data,
        success: function (result, textStatus, xhr) {
            AjaxCall.success(result, xhr, success);
            AjaxCall.possiblyUnbindLoader();
        },
        error: function (xhr) {
            AjaxCall.possiblyUnbindLoader();
            var errorObject = JSON.parse(xhr.responseText);
            alert('An error has occurred: ' + errorObject.Message);
        },
        async: window.async
    });
};

AjaxCall.success = function (result, xhr, success) {
    var dataType = xhr.getResponseHeader("Content-Type");

    if ((dataType != null && dataType.indexOf('text/html') === 0)
        && (result != null && result.indexOf("<html>") === 0)) {
        window.location = '/';
    } else if (success) {
        success(result);
    }
};
if (!String.prototype.startsWith) {
  Object.defineProperty(String.prototype, "startsWith", {
    value: function(search, rawPos) {
      var pos = rawPos > 0 ? rawPos | 0 : 0;
      return this.substring(pos, pos + search.length) === search;
    },
  });
}

; (function (window, document, undefined) {

    'use strict';

    // Make sure that ValidityState is supported in full (all features)
    var supported = function () {
        var input = document.createElement('input');
        return ('validity' in input && 'badInput' in input.validity && 'patternMismatch' in input.validity && 'rangeOverflow' in input.validity && 'rangeUnderflow' in input.validity && 'stepMismatch' in input.validity && 'tooLong' in input.validity && 'tooShort' in input.validity && 'typeMismatch' in input.validity && 'valid' in input.validity && 'valueMissing' in input.validity);
    };

    /**
     * Generate the field validity object
     * @param  {Node]} field The field to validate
     * @return {Object}      The validity object
     */
    var getValidityState = function (field) {

        // Variables
        var type = field.getAttribute('type') || input.nodeName.toLowerCase();
        var isNum = type === 'number' || type === 'range';
        var length = field.value.length;
        var valid = true;

        // Run validity checks
        var checkValidity = {
            badInput: (isNum && length > 0 && !/[-+]?[0-9]/.test(field.value)), // value of a number field is not a number
            patternMismatch: (field.hasAttribute('pattern') && length > 0 && new RegExp(field.getAttribute('pattern')).test(field.value) === false), // value does not conform to the pattern
            rangeOverflow: (field.hasAttribute('max') && isNum && field.value > 1 && parseInt(field.value, 10) > parseInt(field.getAttribute('max'), 10)), // value of a number field is higher than the max attribute
            rangeUnderflow: (field.hasAttribute('min') && isNum && field.value > 1 && parseInt(field.value, 10) < parseInt(field.getAttribute('min'), 10)), // value of a number field is lower than the min attribute
            stepMismatch: (field.hasAttribute('step') && field.getAttribute('step') !== 'any' && isNum && Number(field.value) % parseFloat(field.getAttribute('step')) !== 0), // value of a number field does not conform to the stepattribute
            tooLong: (field.hasAttribute('maxLength') && field.getAttribute('maxLength') > 0 && length > parseInt(field.getAttribute('maxLength'), 10)), // the user has edited a too-long value in a field with maxlength
            tooShort: (field.hasAttribute('minLength') && field.getAttribute('minLength') > 0 && length > 0 && length < parseInt(field.getAttribute('minLength'), 10)), // the user has edited a too-short value in a field with minlength
            typeMismatch: (length > 0 && ((type === 'email' && !/^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/.test(field.value)) || (type === 'url' && !/^(?:(?:https?|HTTPS?|ftp|FTP):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)*)(?::\d{2,5})?(?:[\/?#]\S*)?$/.test(field.value)))), // value of a email or URL field is not an email address or URL
            valueMissing: (field.hasAttribute('required') && (((type === 'checkbox' || type === 'radio') && !field.checked) || (type === 'select' && field.options[field.selectedIndex].value < 1) || (type !== 'checkbox' && type !== 'radio' && type !== 'select' && length < 1))) // required field without a value
        };

        // Check if any errors
        for (var key in checkValidity) {
            if (checkValidity.hasOwnProperty(key)) {
                // If there's an error, change valid value
                if (checkValidity[key]) {
                    valid = false;
                    break;
                }
            }
        }

        // Add valid property to validity object
        checkValidity.valid = valid;

        // Return object
        return checkValidity;

    };

    // If the full set of ValidityState features aren't supported, polyfill
    if (!supported()) {
        Object.defineProperty(HTMLInputElement.prototype, 'validity', {
            get: function ValidityState() {
                return getValidityState(this);
            },
            configurable: true,
        });
    }

})(window, document);
/*!
 * jQuery Globalization Plugin
 * http://github.com/jquery/jquery-global
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 */
(function() {

var Globalization = {}, localized = { en: {} };
localized["default"] = localized.en;

Globalization.extend = function( deep ) {
    var target = arguments[ 1 ] || {};
    for ( var i = 2, l = arguments.length; i < l; i++ ) {
        var source = arguments[ i ];
        if ( source ) {
            for ( var field in source ) {
                var sourceVal = source[ field ];
                if ( typeof sourceVal !== "undefined" ) {
                    if ( deep && (isObject( sourceVal ) || isArray( sourceVal )) ) {
                        var targetVal = target[ field ];
                        // extend onto the existing value, or create a new one
                        targetVal = targetVal && (isObject( targetVal ) || isArray( targetVal ))
                            ? targetVal
                            : (isArray( sourceVal ) ? [] : {});
                        target[ field ] = this.extend( true, targetVal, sourceVal );
                    }
                    else {
                        target[ field ] = sourceVal;
                    }
                }
            }
        }
    }
    return target;
}

Globalization.findClosestCulture = function(name) {
    var match;
    if ( !name ) {
        return this.culture || this.cultures["default"];
    }
    if ( isString( name ) ) {
        name = name.split( ',' );
    }
    if ( isArray( name ) ) {
        var lang,
            cultures = this.cultures,
            list = name,
            i, l = list.length,
            prioritized = [];
        for ( i = 0; i < l; i++ ) {
            name = trim( list[ i ] );
            var pri, parts = name.split( ';' );
            lang = trim( parts[ 0 ] );
            if ( parts.length === 1 ) {
                pri = 1;
            }
            else {
                name = trim( parts[ 1 ] );
                if ( name.indexOf("q=") === 0 ) {
                    name = name.substr( 2 );
                    pri = parseFloat( name, 10 );
                    pri = isNaN( pri ) ? 0 : pri;
                }
                else {
                    pri = 1;
                }
            }
            prioritized.push( { lang: lang, pri: pri } );
        }
        prioritized.sort(function(a, b) {
            return a.pri < b.pri ? 1 : -1;
        });

        // exact match
        for ( i = 0; i < l; i++ ) {
            lang = prioritized[ i ].lang;
            match = cultures[ lang ];
            if ( match ) {
                return match;
            }
        }

        // neutral language match
        for ( i = 0; i < l; i++ ) {
            lang = prioritized[ i ].lang;
            do {
                var index = lang.lastIndexOf( "-" );
                if ( index === -1 ) {
                    break;
                }
                // strip off the last part. e.g. en-US => en
                lang = lang.substr( 0, index );
                match = cultures[ lang ];
                if ( match ) {
                    return match;
                }
            }
            while ( 1 );
        }

        // last resort: match first culture using that language
		for ( i = 0; i < l; i++ ) {
            lang = prioritized[ i ].lang;
			for ( var cultureKey in cultures ) {
				var culture = cultures[ cultureKey ];
                if ( culture.language == lang ) {
                    return culture;
                }
			}
        }
    }
    else if ( typeof name === 'object' ) {
        return name;
    }
    return match || null;
}
Globalization.preferCulture = function(name) {
    this.culture = this.findClosestCulture( name ) || this.cultures["default"];
}
Globalization.localize = function(key, culture, value) {
    // usign default culture in case culture is not provided
    if (typeof culture !== 'string') {
        culture = this.culture.name || this.culture || "default";
    }
    culture = this.cultures[ culture ] || { name: culture };

    var local = localized[ culture.name ];
    if ( arguments.length === 3 ) {
        if ( !local) {
            local = localized[ culture.name ] = {};
        }
        local[ key ] = value;
    }
    else {
        if ( local ) {
            value = local[ key ];
        }
        if ( typeof value === 'undefined' ) {
            var language = localized[ culture.language ];
            if ( language ) {
                value = language[ key ];
            }
            if ( typeof value === 'undefined' ) {
                value = localized["default"][ key ];
            }
        }
    }
    return typeof value === "undefined" ? null : value;
}
Globalization.format = function(value, format, culture) {
    culture = this.findClosestCulture( culture );
    if ( typeof value === "number" ) {
        value = formatNumber( value, format, culture );
    }
    else if ( value instanceof Date ) {
        value = formatDate( value, format, culture );
    }
    return value;
}
Globalization.parseInt = function(value, radix, culture) {
    return Math.floor( this.parseFloat( value, radix, culture ) );
}
Globalization.parseFloat = function(value, radix, culture) {
	// make radix optional
	if (typeof radix === "string") {
		culture = radix;
		radix = 10;
	}

    culture = this.findClosestCulture( culture );
    var ret = NaN,
        nf = culture.numberFormat;

	if (value.indexOf(culture.numberFormat.currency.symbol) > -1) {
		// remove currency symbol
		value = value.replace(culture.numberFormat.currency.symbol, "");
		// replace decimal seperator
		value = value.replace(culture.numberFormat.currency["."], culture.numberFormat["."]);
	}

    // trim leading and trailing whitespace
    value = trim( value );

    // allow infinity or hexidecimal
    if (regexInfinity.test(value)) {
        ret = parseFloat(value, radix);
    }
    else if (!radix && regexHex.test(value)) {
        ret = parseInt(value, 16);
    }
    else {
        var signInfo = parseNegativePattern( value, nf, nf.pattern[0] ),
            sign = signInfo[0],
            num = signInfo[1];
        // determine sign and number
        if ( sign === "" && nf.pattern[0] !== "-n" ) {
            signInfo = parseNegativePattern( value, nf, "-n" );
            sign = signInfo[0];
            num = signInfo[1];
        }
        sign = sign || "+";
        // determine exponent and number
        var exponent,
            intAndFraction,
            exponentPos = num.indexOf( 'e' );
        if ( exponentPos < 0 ) exponentPos = num.indexOf( 'E' );
        if ( exponentPos < 0 ) {
            intAndFraction = num;
            exponent = null;
        }
        else {
            intAndFraction = num.substr( 0, exponentPos );
            exponent = num.substr( exponentPos + 1 );
        }
        // determine decimal position
        var integer,
            fraction,
            decSep = nf['.'],
            decimalPos = intAndFraction.indexOf( decSep );
        if ( decimalPos < 0 ) {
            integer = intAndFraction;
            fraction = null;
        }
        else {
            integer = intAndFraction.substr( 0, decimalPos );
            fraction = intAndFraction.substr( decimalPos + decSep.length );
        }
        // handle groups (e.g. 1,000,000)
        var groupSep = nf[","];
        integer = integer.split(groupSep).join('');
        var altGroupSep = groupSep.replace(/\u00A0/g, " ");
        if ( groupSep !== altGroupSep ) {
            integer = integer.split(altGroupSep).join('');
        }
        // build a natively parsable number string
        var p = sign + integer;
        if ( fraction !== null ) {
            p += '.' + fraction;
        }
        if ( exponent !== null ) {
            // exponent itself may have a number patternd
            var expSignInfo = parseNegativePattern( exponent, nf, "-n" );
            p += 'e' + (expSignInfo[0] || "+") + expSignInfo[1];
        }
        if ( regexParseFloat.test( p ) ) {
            ret = parseFloat( p );
        }
    }
    return ret;
}
Globalization.parseDate = function(value, formats, culture) {
    culture = this.findClosestCulture( culture );

    var date, prop, patterns;
    if ( formats ) {
        if ( typeof formats === "string" ) {
            formats = [ formats ];
        }
        if ( formats.length ) {
            for ( var i = 0, l = formats.length; i < l; i++ ) {
                var format = formats[ i ];
                if ( format ) {
                    date = parseExact( value, format, culture );
                    if ( date ) {
                        break;
                    }
                }
            }
        }
    }
    else {
        patterns = culture.calendar.patterns;
        for ( prop in patterns ) {
            date = parseExact( value, patterns[prop], culture );
            if ( date ) {
                break;
            }
        }
    }
    return date || null;
}

// 1.    When defining a culture, all fields are required except the ones stated as optional.
// 2.    You can use Globalization.extend to copy an existing culture and provide only the differing values,
//       a good practice since most cultures do not differ too much from the 'default' culture.
//       DO use the 'default' culture if you do this, as it is the only one that definitely
//       exists.
// 3.    Other plugins may add to the culture information provided by extending it. However,
//       that plugin may extend it prior to the culture being defined, or after. Therefore,
//       do not overwrite values that already exist when defining the baseline for a culture,
//       by extending your culture object with the existing one.
// 4.    Each culture should have a ".calendars" object with at least one calendar named "standard"
//       which serves as the default calendar in use by that culture.
// 5.    Each culture should have a ".calendar" object which is the current calendar being used,
//       it may be dynamically changed at any time to one of the calendars in ".calendars".

// To define a culture, use the following pattern, which handles defining the culture based
// on the 'default culture, extending it with the existing culture if it exists, and defining
// it if it does not exist.
// Globalization.cultures.foo = Globalization.extend(true, Globalization.extend(true, {}, Globalization.cultures['default'], fooCulture), Globalization.cultures.foo)

var cultures = Globalization.cultures = Globalization.cultures || {};
var en = cultures["default"] = cultures.en = Globalization.extend(true, {
    // A unique name for the culture in the form <language code>-<country/region code>
    name: "en",
    // the name of the culture in the english language
    englishName: "English",
    // the name of the culture in its own language
    nativeName: "English",
    // whether the culture uses right-to-left text
    isRTL: false,
    // 'language' is used for so-called "specific" cultures.
    // For example, the culture "es-CL" means "Spanish, in Chili".
    // It represents the Spanish-speaking culture as it is in Chili,
    // which might have different formatting rules or even translations
    // than Spanish in Spain. A "neutral" culture is one that is not
    // specific to a region. For example, the culture "es" is the generic
    // Spanish culture, which may be a more generalized version of the language
    // that may or may not be what a specific culture expects.
    // For a specific culture like "es-CL", the 'language' field refers to the
    // neutral, generic culture information for the language it is using.
    // This is not always a simple matter of the string before the dash.
    // For example, the "zh-Hans" culture is netural (Simplified Chinese).
    // And the 'zh-SG' culture is Simplified Chinese in Singapore, whose lanugage
    // field is "zh-CHS", not "zh".
    // This field should be used to navigate from a specific culture to it's
    // more general, neutral culture. If a culture is already as general as it
    // can get, the language may refer to itself.
    language: "en",
    // numberFormat defines general number formatting rules, like the digits in
    // each grouping, the group separator, and how negative numbers are displayed.
    numberFormat: {
        // [negativePattern]
        // Note, numberFormat.pattern has no 'positivePattern' unlike percent and currency,
        // but is still defined as an array for consistency with them.
        //  negativePattern: one of "(n)|-n|- n|n-|n -"
        pattern: ["-n"],
        // number of decimal places normally shown
        decimals: 2,
        // string that separates number groups, as in 1,000,000
        ',': ",",
        // string that separates a number from the fractional portion, as in 1.99
        '.': ".",
        // array of numbers indicating the size of each number group.
        // TODO: more detailed description and example
        groupSizes: [3],
        // symbol used for positive numbers
        '+': "+",
        // symbol used for negative numbers
        '-': "-",
        percent: {
            // [negativePattern, positivePattern]
            //     negativePattern: one of "-n %|-n%|-%n|%-n|%n-|n-%|n%-|-% n|n %-|% n-|% -n|n- %"
            //     positivePattern: one of "n %|n%|%n|% n"
            pattern: ["-n %","n %"],
            // number of decimal places normally shown
            decimals: 2,
            // array of numbers indicating the size of each number group.
            // TODO: more detailed description and example
            groupSizes: [3],
            // string that separates number groups, as in 1,000,000
            ',': ",",
            // string that separates a number from the fractional portion, as in 1.99
            '.': ".",
            // symbol used to represent a percentage
            symbol: "%"
        },
        currency: {
            // [negativePattern, positivePattern]
            //     negativePattern: one of "($n)|-$n|$-n|$n-|(n$)|-n$|n-$|n$-|-n $|-$ n|n $-|$ n-|$ -n|n- $|($ n)|(n $)"
            //     positivePattern: one of "$n|n$|$ n|n $"
            pattern: ["($n)","$n"],
            // number of decimal places normally shown
            decimals: 2,
            // array of numbers indicating the size of each number group.
            // TODO: more detailed description and example
            groupSizes: [3],
            // string that separates number groups, as in 1,000,000
            ',': ",",
            // string that separates a number from the fractional portion, as in 1.99
            '.': ".",
            // symbol used to represent currency
            symbol: "$"
        }
    },
    // calendars defines all the possible calendars used by this culture.
    // There should be at least one defined with name 'standard', and is the default
    // calendar used by the culture.
    // A calendar contains information about how dates are formatted, information about
    // the calendar's eras, a standard set of the date formats,
    // translations for day and month names, and if the calendar is not based on the Gregorian
    // calendar, conversion functions to and from the Gregorian calendar.
    calendars: {
        standard: {
            // name that identifies the type of calendar this is
            name: "Gregorian_USEnglish",
            // separator of parts of a date (e.g. '/' in 11/05/1955)
            '/': "/",
            // separator of parts of a time (e.g. ':' in 05:44 PM)
            ':': ":",
            // the first day of the week (0 = Sunday, 1 = Monday, etc)
            firstDay: 0,
            days: {
                // full day names
                names: ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
                // abbreviated day names
                namesAbbr: ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],
                // shortest day names
                namesShort: ["Su","Mo","Tu","We","Th","Fr","Sa"]
            },
            months: {
                // full month names (13 months for lunar calendards -- 13th month should be "" if not lunar)
                names: ["January","February","March","April","May","June","July","August","September","October","November","December",""],
                // abbreviated month names
                namesAbbr: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec",""]
            },
            // AM and PM designators in one of these forms:
            // The usual view, and the upper and lower case versions
            //      [standard,lowercase,uppercase]
            // The culture does not use AM or PM (likely all standard date formats use 24 hour time)
            //      null
            AM: ["AM", "am", "AM"],
            PM: ["PM", "pm", "PM"],
            eras: [
                // eras in reverse chronological order.
                // name: the name of the era in this culture (e.g. A.D., C.E.)
                // start: when the era starts in ticks (gregorian, gmt), null if it is the earliest supported era.
                // offset: offset in years from gregorian calendar
                { "name": "A.D.", "start": null, "offset": 0 }
            ],
            // when a two digit year is given, it will never be parsed as a four digit
            // year greater than this year (in the appropriate era for the culture)
            // Set it as a full year (e.g. 2029) or use an offset format starting from
            // the current year: "+19" would correspond to 2029 if the current year 2010.
            twoDigitYearMax: 2029,
            // set of predefined date and time patterns used by the culture
            // these represent the format someone in this culture would expect
            // to see given the portions of the date that are shown.
            patterns: {
                // short date pattern
                d: "M/d/yyyy",
                // long date pattern
                D: "dddd, MMMM dd, yyyy",
                // short time pattern
                t: "h:mm tt",
                // long time pattern
                T: "h:mm:ss tt",
                // long date, short time pattern
                f: "dddd, MMMM dd, yyyy h:mm tt",
                // long date, long time pattern
                F: "dddd, MMMM dd, yyyy h:mm:ss tt",
                // month/day pattern
                M: "MMMM dd",
                // month/year pattern
                Y: "yyyy MMMM",
                // S is a sortable format that does not vary by culture
                S: "yyyy\u0027-\u0027MM\u0027-\u0027dd\u0027T\u0027HH\u0027:\u0027mm\u0027:\u0027ss"
            }
            // optional fields for each calendar:
            /*
            monthsGenitive:
                Same as months but used when the day preceeds the month.
                Omit if the culture has no genitive distinction in month names.
                For an explaination of genitive months, see http://blogs.msdn.com/michkap/archive/2004/12/25/332259.aspx
            convert:
                Allows for the support of non-gregorian based calendars. This convert object is used to
                to convert a date to and from a gregorian calendar date to handle parsing and formatting.
                The two functions:
                    fromGregorian(date)
                        Given the date as a parameter, return an array with parts [year, month, day]
                        corresponding to the non-gregorian based year, month, and day for the calendar.
                    toGregorian(year, month, day)
                        Given the non-gregorian year, month, and day, return a new Date() object
                        set to the corresponding date in the gregorian calendar.
            */
        }
    }
}, cultures.en);
en.calendar = en.calendar || en.calendars.standard;

var regexTrim = /^\s+|\s+$/g,
    regexInfinity = /^[+-]?infinity$/i,
    regexHex = /^0x[a-f0-9]+$/i,
    regexParseFloat = /^[+-]?\d*\.?\d*(e[+-]?\d+)?$/,
    toString = Object.prototype.toString;

function startsWith(value, pattern) {
    return value.indexOf( pattern ) === 0;
}

function endsWith(value, pattern) {
    return value.substr( value.length - pattern.length ) === pattern;
}

function trim(value) {
    return (value+"").replace( regexTrim, "" );
}

function zeroPad(str, count, left) {
    for (var l=str.length; l < count; l++) {
        str = (left ? ('0' + str) : (str + '0'));
    }
    return str;
}

function isArray(obj) {
    return toString.call(obj) === "[object Array]";
}

function isString(obj) {
    return toString.call(obj) === "[object String]";
}

function isObject(obj) {
    return toString.call(obj) === "[object Object]";
}

function arrayIndexOf( array, item ) {
    if ( array.indexOf ) {
        return array.indexOf( item );
    }
    for ( var i = 0, length = array.length; i < length; i++ ) {
        if ( array[ i ] === item ) {
            return i;
        }
    }
    return -1;
}

// *************************************** Numbers ***************************************

function expandNumber(number, precision, formatInfo) {
    var groupSizes = formatInfo.groupSizes,
        curSize = groupSizes[ 0 ],
        curGroupIndex = 1,
        factor = Math.pow( 10, precision ),
        rounded = Math.round( number * factor ) / factor;
    if ( !isFinite(rounded) ) {
        rounded = number;
    }
    number = rounded;

    var numberString = number+"",
        right = "",
        split = numberString.split(/e/i),
        exponent = split.length > 1 ? parseInt( split[ 1 ], 10 ) : 0;
    numberString = split[ 0 ];
    split = numberString.split( "." );
    numberString = split[ 0 ];
    right = split.length > 1 ? split[ 1 ] : "";

    var l;
    if ( exponent > 0 ) {
        right = zeroPad( right, exponent, false );
        numberString += right.slice( 0, exponent );
        right = right.substr( exponent );
    }
    else if ( exponent < 0 ) {
        exponent = -exponent;
        numberString = zeroPad( numberString, exponent + 1 );
        right = numberString.slice( -exponent, numberString.length ) + right;
        numberString = numberString.slice( 0, -exponent );
    }

    if ( precision > 0 ) {
        right = formatInfo['.'] +
            ((right.length > precision) ? right.slice( 0, precision ) : zeroPad( right, precision ));
    }
    else {
        right = "";
    }

    var stringIndex = numberString.length - 1,
        sep = formatInfo[","],
        ret = "";

    while ( stringIndex >= 0 ) {
        if ( curSize === 0 || curSize > stringIndex ) {
            return numberString.slice( 0, stringIndex + 1 ) + ( ret.length ? ( sep + ret + right ) : right );
        }
        ret = numberString.slice( stringIndex - curSize + 1, stringIndex + 1 ) + ( ret.length ? ( sep + ret ) : "" );

        stringIndex -= curSize;

        if ( curGroupIndex < groupSizes.length ) {
            curSize = groupSizes[ curGroupIndex ];
            curGroupIndex++;
        }
    }
    return numberString.slice( 0, stringIndex + 1 ) + sep + ret + right;
}


function parseNegativePattern(value, nf, negativePattern) {
    var neg = nf["-"],
        pos = nf["+"],
        ret;
    switch (negativePattern) {
        case "n -":
            neg = ' ' + neg;
            pos = ' ' + pos;
            // fall through
        case "n-":
            if ( endsWith( value, neg ) ) {
                ret = [ '-', value.substr( 0, value.length - neg.length ) ];
            }
            else if ( endsWith( value, pos ) ) {
                ret = [ '+', value.substr( 0, value.length - pos.length ) ];
            }
            break;
        case "- n":
            neg += ' ';
            pos += ' ';
            // fall through
        case "-n":
            if ( startsWith( value, neg ) ) {
                ret = [ '-', value.substr( neg.length ) ];
            }
            else if ( startsWith(value, pos) ) {
                ret = [ '+', value.substr( pos.length ) ];
            }
            break;
        case "(n)":
            if ( startsWith( value, '(' ) && endsWith( value, ')' ) ) {
                ret = [ '-', value.substr( 1, value.length - 2 ) ];
            }
            break;
    }
    return ret || [ '', value ];
}

function formatNumber(value, format, culture) {
    if ( !format || format === 'i' ) {
        return culture.name.length ? value.toLocaleString() : value.toString();
    }
    format = format || "D";

    var nf = culture.numberFormat,
        number = Math.abs(value),
        precision = -1,
        pattern;
    if (format.length > 1) precision = parseInt( format.slice( 1 ), 10 );

    var current = format.charAt( 0 ).toUpperCase(),
        formatInfo;

    switch (current) {
        case "D":
            pattern = 'n';
            if (precision !== -1) {
                number = zeroPad( ""+number, precision, true );
            }
            if (value < 0) number = -number;
            break;
        case "N":
            formatInfo = nf;
            // fall through
        case "C":
            formatInfo = formatInfo || nf.currency;
            // fall through
        case "P":
            formatInfo = formatInfo || nf.percent;
            pattern = value < 0 ? formatInfo.pattern[0] : (formatInfo.pattern[1] || "n");
            if (precision === -1) precision = formatInfo.decimals;
            number = expandNumber( number * (current === "P" ? 100 : 1), precision, formatInfo );
            break;
        default:
            throw "Bad number format specifier: " + current;
    }

    var patternParts = /n|\$|-|%/g,
        ret = "";
    for (;;) {
        var index = patternParts.lastIndex,
            ar = patternParts.exec(pattern);

        ret += pattern.slice( index, ar ? ar.index : pattern.length );

        if (!ar) {
            break;
        }

        switch (ar[0]) {
            case "n":
                ret += number;
                break;
            case "$":
                ret += nf.currency.symbol;
                break;
            case "-":
                // don't make 0 negative
                if ( /[1-9]/.test( number ) ) {
                    ret += nf["-"];
                }
                break;
            case "%":
                ret += nf.percent.symbol;
                break;
        }
    }

    return ret;
}

// *************************************** Dates ***************************************

function outOfRange(value, low, high) {
    return value < low || value > high;
}

function expandYear(cal, year) {
    // expands 2-digit year into 4 digits.
    var now = new Date(),
        era = getEra(now);
    if ( year < 100 ) {
        var twoDigitYearMax = cal.twoDigitYearMax;
        twoDigitYearMax = typeof twoDigitYearMax === 'string' ? new Date().getFullYear() % 100 + parseInt( twoDigitYearMax, 10 ) : twoDigitYearMax;
        var curr = getEraYear( now, cal, era );
        year += curr - ( curr % 100 );
        if ( year > twoDigitYearMax ) {
            year -= 100;
        }
    }
    return year;
}

function getEra(date, eras) {
    if ( !eras ) return 0;
    var start, ticks = date.getTime();
    for ( var i = 0, l = eras.length; i < l; i++ ) {
        start = eras[ i ].start;
        if ( start === null || ticks >= start ) {
            return i;
        }
    }
    return 0;
}

function toUpper(value) {
    // 'he-IL' has non-breaking space in weekday names.
    return value.split( "\u00A0" ).join(' ').toUpperCase();
}

function toUpperArray(arr) {
    var results = [];
    for ( var i = 0, l = arr.length; i < l; i++ ) {
        results[i] = toUpper(arr[i]);
    }
    return results;
}

function getEraYear(date, cal, era, sortable) {
    var year = date.getFullYear();
    if ( !sortable && cal.eras ) {
        // convert normal gregorian year to era-shifted gregorian
        // year by subtracting the era offset
        year -= cal.eras[ era ].offset;
    }
    return year;
}

function getDayIndex(cal, value, abbr) {
    var ret,
        days = cal.days,
        upperDays = cal._upperDays;
    if ( !upperDays ) {
        cal._upperDays = upperDays = [
            toUpperArray( days.names ),
            toUpperArray( days.namesAbbr ),
            toUpperArray( days.namesShort )
        ];
    }
    value = toUpper( value );
    if ( abbr ) {
        ret = arrayIndexOf( upperDays[ 1 ], value );
        if ( ret === -1 ) {
            ret = arrayIndexOf( upperDays[ 2 ], value );
        }
    }
    else {
        ret = arrayIndexOf( upperDays[ 0 ], value );
    }
    return ret;
}

function getMonthIndex(cal, value, abbr) {
    var months = cal.months,
        monthsGen = cal.monthsGenitive || cal.months,
        upperMonths = cal._upperMonths,
        upperMonthsGen = cal._upperMonthsGen;
    if ( !upperMonths ) {
        cal._upperMonths = upperMonths = [
            toUpperArray( months.names ),
            toUpperArray( months.namesAbbr )
        ];
        cal._upperMonthsGen = upperMonthsGen = [
            toUpperArray( monthsGen.names ),
            toUpperArray( monthsGen.namesAbbr )
        ];
    }
    value = toUpper( value );
    var i = arrayIndexOf( abbr ? upperMonths[ 1 ] : upperMonths[ 0 ], value );
    if ( i < 0 ) {
        i = arrayIndexOf( abbr ? upperMonthsGen[ 1 ] : upperMonthsGen[ 0 ], value );
    }
    return i;
}

function appendPreOrPostMatch(preMatch, strings) {
    // appends pre- and post- token match strings while removing escaped characters.
    // Returns a single quote count which is used to determine if the token occurs
    // in a string literal.
    var quoteCount = 0,
        escaped = false;
    for ( var i = 0, il = preMatch.length; i < il; i++ ) {
        var c = preMatch.charAt( i );
        switch ( c ) {
            case '\'':
                if ( escaped ) {
                    strings.push( "'" );
                }
                else {
                    quoteCount++;
                }
                escaped = false;
                break;
            case '\\':
                if ( escaped ) {
                    strings.push( "\\" );
                }
                escaped = !escaped;
                break;
            default:
                strings.push( c );
                escaped = false;
                break;
        }
    }
    return quoteCount;
}

function expandFormat(cal, format) {
    // expands unspecified or single character date formats into the full pattern.
    format = format || "F";
    var pattern,
        patterns = cal.patterns,
        len = format.length;
    if ( len === 1 ) {
        pattern = patterns[ format ];
        if ( !pattern ) {
            throw "Invalid date format string '" + format + "'.";
        }
        format = pattern;
    }
    else if ( len === 2  && format.charAt(0) === "%" ) {
        // %X escape format -- intended as a custom format string that is only one character, not a built-in format.
        format = format.charAt( 1 );
    }
    return format;
}

function getParseRegExp(cal, format) {
    // converts a format string into a regular expression with groups that
    // can be used to extract date fields from a date string.
    // check for a cached parse regex.
    var re = cal._parseRegExp;
    if ( !re ) {
        cal._parseRegExp = re = {};
    }
    else {
        var reFormat = re[ format ];
        if ( reFormat ) {
            return reFormat;
        }
    }

    // expand single digit formats, then escape regular expression characters.
    var expFormat = expandFormat( cal, format ).replace( /([\^\$\.\*\+\?\|\[\]\(\)\{\}])/g, "\\\\$1" ),
        regexp = ["^"],
        groups = [],
        index = 0,
        quoteCount = 0,
        tokenRegExp = getTokenRegExp(),
        match;

    // iterate through each date token found.
    while ( (match = tokenRegExp.exec( expFormat )) !== null ) {
        var preMatch = expFormat.slice( index, match.index );
        index = tokenRegExp.lastIndex;

        // don't replace any matches that occur inside a string literal.
        quoteCount += appendPreOrPostMatch( preMatch, regexp );
        if ( quoteCount % 2 ) {
            regexp.push( match[ 0 ] );
            continue;
        }

        // add a regex group for the token.
        var m = match[ 0 ],
            len = m.length,
            add;
        switch ( m ) {
            case 'dddd': case 'ddd':
            case 'MMMM': case 'MMM':
            case 'gg': case 'g':
                add = "(\\D+)";
                break;
            case 'tt': case 't':
                add = "(\\D*)";
                break;
            case 'yyyy':
            case 'fff':
            case 'ff':
            case 'f':
                add = "(\\d{" + len + "})";
                break;
            case 'dd': case 'd':
            case 'MM': case 'M':
            case 'yy': case 'y':
            case 'HH': case 'H':
            case 'hh': case 'h':
            case 'mm': case 'm':
            case 'ss': case 's':
                add = "(\\d\\d?)";
                break;
            case 'zzz':
                add = "([+-]?\\d\\d?:\\d{2})";
                break;
            case 'zz': case 'z':
                add = "([+-]?\\d\\d?)";
                break;
            case '/':
                add = "(\\" + cal["/"] + ")";
                break;
            default:
                throw "Invalid date format pattern '" + m + "'.";
                break;
        }
        if ( add ) {
            regexp.push( add );
        }
        groups.push( match[ 0 ] );
    }
    appendPreOrPostMatch( expFormat.slice( index ), regexp );
    regexp.push( "$" );

    // allow whitespace to differ when matching formats.
    var regexpStr = regexp.join( '' ).replace( /\s+/g, "\\s+" ),
        parseRegExp = {'regExp': regexpStr, 'groups': groups};

    // cache the regex for this format.
    return re[ format ] = parseRegExp;
}

function getTokenRegExp() {
    // regular expression for matching date and time tokens in format strings.
    return /\/|dddd|ddd|dd|d|MMMM|MMM|MM|M|yyyy|yy|y|hh|h|HH|H|mm|m|ss|s|tt|t|fff|ff|f|zzz|zz|z|gg|g/g;
}

function parseExact(value, format, culture) {
    // try to parse the date string by matching against the format string
    // while using the specified culture for date field names.
    value = trim( value );
    var cal = culture.calendar,
        // convert date formats into regular expressions with groupings.
        // use the regexp to determine the input format and extract the date fields.
        parseInfo = getParseRegExp(cal, format),
        match = new RegExp(parseInfo.regExp).exec(value);
    if (match === null) {
        return null;
    }
    // found a date format that matches the input.
    var groups = parseInfo.groups,
        era = null, year = null, month = null, date = null, weekDay = null,
        hour = 0, hourOffset, min = 0, sec = 0, msec = 0, tzMinOffset = null,
        pmHour = false;
    // iterate the format groups to extract and set the date fields.
    for ( var j = 0, jl = groups.length; j < jl; j++ ) {
        var matchGroup = match[ j + 1 ];
        if ( matchGroup ) {
            var current = groups[ j ],
                clength = current.length,
                matchInt = parseInt( matchGroup, 10 );
            switch ( current ) {
                case 'dd': case 'd':
                    // Day of month.
                    date = matchInt;
                    // check that date is generally in valid range, also checking overflow below.
                    if ( outOfRange( date, 1, 31 ) ) return null;
                    break;
                case 'MMM':
                case 'MMMM':
                    month = getMonthIndex( cal, matchGroup, clength === 3 );
                    if ( outOfRange( month, 0, 11 ) ) return null;
                    break;
                case 'M': case 'MM':
                    // Month.
                    month = matchInt - 1;
                    if ( outOfRange( month, 0, 11 ) ) return null;
                    break;
                case 'y': case 'yy':
                case 'yyyy':
                    year = clength < 4 ? expandYear( cal, matchInt ) : matchInt;
                    if ( outOfRange( year, 0, 9999 ) ) return null;
                    break;
                case 'h': case 'hh':
                    // Hours (12-hour clock).
                    hour = matchInt;
                    if ( hour === 12 ) hour = 0;
                    if ( outOfRange( hour, 0, 11 ) ) return null;
                    break;
                case 'H': case 'HH':
                    // Hours (24-hour clock).
                    hour = matchInt;
                    if ( outOfRange( hour, 0, 23 ) ) return null;
                    break;
                case 'm': case 'mm':
                    // Minutes.
                    min = matchInt;
                    if ( outOfRange( min, 0, 59 ) ) return null;
                    break;
                case 's': case 'ss':
                    // Seconds.
                    sec = matchInt;
                    if ( outOfRange( sec, 0, 59 ) ) return null;
                    break;
                case 'tt': case 't':
                    // AM/PM designator.
                    // see if it is standard, upper, or lower case PM. If not, ensure it is at least one of
                    // the AM tokens. If not, fail the parse for this format.
                    pmHour = cal.PM && ( matchGroup === cal.PM[0] || matchGroup === cal.PM[1] || matchGroup === cal.PM[2] );
                    if ( !pmHour && ( !cal.AM || (matchGroup !== cal.AM[0] && matchGroup !== cal.AM[1] && matchGroup !== cal.AM[2]) ) ) return null;
                    break;
                case 'f':
                    // Deciseconds.
                case 'ff':
                    // Centiseconds.
                case 'fff':
                    // Milliseconds.
                    msec = matchInt * Math.pow( 10, 3-clength );
                    if ( outOfRange( msec, 0, 999 ) ) return null;
                    break;
                case 'ddd':
                    // Day of week.
                case 'dddd':
                    // Day of week.
                    weekDay = getDayIndex( cal, matchGroup, clength === 3 );
                    if ( outOfRange( weekDay, 0, 6 ) ) return null;
                    break;
                case 'zzz':
                    // Time zone offset in +/- hours:min.
                    var offsets = matchGroup.split( /:/ );
                    if ( offsets.length !== 2 ) return null;
                    hourOffset = parseInt( offsets[ 0 ], 10 );
                    if ( outOfRange( hourOffset, -12, 13 ) ) return null;
                    var minOffset = parseInt( offsets[ 1 ], 10 );
                    if ( outOfRange( minOffset, 0, 59 ) ) return null;
                    tzMinOffset = (hourOffset * 60) + (startsWith( matchGroup, '-' ) ? -minOffset : minOffset);
                    break;
                case 'z': case 'zz':
                    // Time zone offset in +/- hours.
                    hourOffset = matchInt;
                    if ( outOfRange( hourOffset, -12, 13 ) ) return null;
                    tzMinOffset = hourOffset * 60;
                    break;
                case 'g': case 'gg':
                    var eraName = matchGroup;
                    if ( !eraName || !cal.eras ) return null;
                    eraName = trim( eraName.toLowerCase() );
                    for ( var i = 0, l = cal.eras.length; i < l; i++ ) {
                        if ( eraName === cal.eras[ i ].name.toLowerCase() ) {
                            era = i;
                            break;
                        }
                    }
                    // could not find an era with that name
                    if ( era === null ) return null;
                    break;
            }
        }
    }
    var result = new Date(), defaultYear, convert = cal.convert;
    defaultYear = convert ? convert.fromGregorian( result )[ 0 ] : result.getFullYear();
    if ( year === null ) {
        year = defaultYear;
    }
    else if ( cal.eras ) {
        // year must be shifted to normal gregorian year
        // but not if year was not specified, its already normal gregorian
        // per the main if clause above.
        year += cal.eras[ (era || 0) ].offset;
    }
    // set default day and month to 1 and January, so if unspecified, these are the defaults
    // instead of the current day/month.
    if ( month === null ) {
        month = 0;
    }
    if ( date === null ) {
        date = 1;
    }
    // now have year, month, and date, but in the culture's calendar.
    // convert to gregorian if necessary
    if ( convert ) {
        result = convert.toGregorian( year, month, date );
        // conversion failed, must be an invalid match
        if ( result === null ) return null;
    }
    else {
        // have to set year, month and date together to avoid overflow based on current date.
        result.setFullYear( year, month, date );
        // check to see if date overflowed for specified month (only checked 1-31 above).
        if ( result.getDate() !== date ) return null;
        // invalid day of week.
        if ( weekDay !== null && result.getDay() !== weekDay ) {
            return null;
        }
    }
    // if pm designator token was found make sure the hours fit the 24-hour clock.
    if ( pmHour && hour < 12 ) {
        hour += 12;
    }
    result.setHours( hour, min, sec, msec );
    if ( tzMinOffset !== null ) {
        // adjust timezone to utc before applying local offset.
        var adjustedMin = result.getMinutes() - ( tzMinOffset + result.getTimezoneOffset() );
        // Safari limits hours and minutes to the range of -127 to 127.  We need to use setHours
        // to ensure both these fields will not exceed this range.  adjustedMin will range
        // somewhere between -1440 and 1500, so we only need to split this into hours.
        result.setHours( result.getHours() + parseInt( adjustedMin / 60, 10 ), adjustedMin % 60 );
    }
    return result;
}

function formatDate(value, format, culture) {
    var cal = culture.calendar,
        convert = cal.convert;
    if ( !format || !format.length || format === 'i' ) {
        var ret;
        if ( culture && culture.name.length ) {
            if ( convert ) {
                // non-gregorian calendar, so we cannot use built-in toLocaleString()
                ret = formatDate( value, cal.patterns.F, culture );
            }
            else {
                var eraDate = new Date( value.getTime() ),
                    era = getEra( value, cal.eras );
                eraDate.setFullYear( getEraYear( value, cal, era ) );
                ret = eraDate.toLocaleString();
            }
        }
        else {
            ret = value.toString();
        }
        return ret;
    }

    var eras = cal.eras,
        sortable = format === "s";
    format = expandFormat( cal, format );

    // Start with an empty string
    ret = [];
    var hour,
        zeros = ['0','00','000'],
        foundDay,
        checkedDay,
        dayPartRegExp = /([^d]|^)(d|dd)([^d]|$)/g,
        quoteCount = 0,
        tokenRegExp = getTokenRegExp(),
        converted;

    function padZeros(num, c) {
        var r, s = num+'';
        if ( c > 1 && s.length < c ) {
            r = ( zeros[ c - 2 ] + s);
            return r.substr( r.length - c, c );
        }
        else {
            r = s;
        }
        return r;
    }

    function hasDay() {
        if ( foundDay || checkedDay ) {
            return foundDay;
        }
        foundDay = dayPartRegExp.test( format );
        checkedDay = true;
        return foundDay;
    }

    function getPart( date, part ) {
        if ( converted ) {
            return converted[ part ];
        }
        switch ( part ) {
            case 0: return date.getFullYear();
            case 1: return date.getMonth();
            case 2: return date.getDate();
        }
    }

    if ( !sortable && convert ) {
        converted = convert.fromGregorian( value );
    }

    for (;;) {
        // Save the current index
        var index = tokenRegExp.lastIndex,
            // Look for the next pattern
            ar = tokenRegExp.exec( format );

        // Append the text before the pattern (or the end of the string if not found)
        var preMatch = format.slice( index, ar ? ar.index : format.length );
        quoteCount += appendPreOrPostMatch( preMatch, ret );

        if ( !ar ) {
            break;
        }

        // do not replace any matches that occur inside a string literal.
        if ( quoteCount % 2 ) {
            ret.push( ar[ 0 ] );
            continue;
        }

        var current = ar[ 0 ],
            clength = current.length;

        switch ( current ) {
            case "ddd":
                //Day of the week, as a three-letter abbreviation
            case "dddd":
                // Day of the week, using the full name
                var names = (clength === 3) ? cal.days.namesAbbr : cal.days.names;
                ret.push( names[ value.getDay() ] );
                break;
            case "d":
                // Day of month, without leading zero for single-digit days
            case "dd":
                // Day of month, with leading zero for single-digit days
                foundDay = true;
                ret.push( padZeros( getPart( value, 2 ), clength ) );
                break;
            case "MMM":
                // Month, as a three-letter abbreviation
            case "MMMM":
                // Month, using the full name
                var part = getPart( value, 1 );
                ret.push( (cal.monthsGenitive && hasDay())
                    ? cal.monthsGenitive[ clength === 3 ? "namesAbbr" : "names" ][ part ]
                    : cal.months[ clength === 3 ? "namesAbbr" : "names" ][ part ] );
                break;
            case "M":
                // Month, as digits, with no leading zero for single-digit months
            case "MM":
                // Month, as digits, with leading zero for single-digit months
                ret.push( padZeros( getPart( value, 1 ) + 1, clength ) );
                break;
            case "y":
                // Year, as two digits, but with no leading zero for years less than 10
            case "yy":
                // Year, as two digits, with leading zero for years less than 10
            case "yyyy":
                // Year represented by four full digits
                part = converted ? converted[ 0 ] : getEraYear( value, cal, getEra( value, eras ), sortable );
                if ( clength < 4 ) {
                    part = part % 100;
                }
                ret.push( padZeros( part, clength ) );
                break;
            case "h":
                // Hours with no leading zero for single-digit hours, using 12-hour clock
            case "hh":
                // Hours with leading zero for single-digit hours, using 12-hour clock
                hour = value.getHours() % 12;
                if ( hour === 0 ) hour = 12;
                ret.push( padZeros( hour, clength ) );
                break;
            case "H":
                // Hours with no leading zero for single-digit hours, using 24-hour clock
            case "HH":
                // Hours with leading zero for single-digit hours, using 24-hour clock
                ret.push( padZeros( value.getHours(), clength ) );
                break;
            case "m":
                // Minutes with no leading zero  for single-digit minutes
            case "mm":
                // Minutes with leading zero  for single-digit minutes
                ret.push( padZeros( value.getMinutes(), clength ) );
                break;
            case "s":
                // Seconds with no leading zero for single-digit seconds
            case "ss":
                // Seconds with leading zero for single-digit seconds
                ret.push( padZeros(value .getSeconds(), clength ) );
                break;
            case "t":
                // One character am/pm indicator ("a" or "p")
            case "tt":
                // Multicharacter am/pm indicator
                part = value.getHours() < 12 ? (cal.AM ? cal.AM[0] : " ") : (cal.PM ? cal.PM[0] : " ");
                ret.push( clength === 1 ? part.charAt( 0 ) : part );
                break;
            case "f":
                // Deciseconds
            case "ff":
                // Centiseconds
            case "fff":
                // Milliseconds
                ret.push( padZeros( value.getMilliseconds(), 3 ).substr( 0, clength ) );
                break;
            case "z":
                // Time zone offset, no leading zero
            case "zz":
                // Time zone offset with leading zero
                hour = value.getTimezoneOffset() / 60;
                ret.push( (hour <= 0 ? '+' : '-') + padZeros( Math.floor( Math.abs( hour ) ), clength ) );
                break;
            case "zzz":
                // Time zone offset with leading zero
                hour = value.getTimezoneOffset() / 60;
                ret.push( (hour <= 0 ? '+' : '-') + padZeros( Math.floor( Math.abs( hour ) ), 2 ) +
                    // Hard coded ":" separator, rather than using cal.TimeSeparator
                    // Repeated here for consistency, plus ":" was already assumed in date parsing.
                    ":" + padZeros( Math.abs( value.getTimezoneOffset() % 60 ), 2 ) );
                break;
            case "g":
            case "gg":
                if ( cal.eras ) {
                    ret.push( cal.eras[ getEra(value, eras) ].name );
                }
                break;
        case "/":
            ret.push( cal["/"] );
            break;
        default:
            throw "Invalid date format pattern '" + current + "'.";
            break;
        }
    }
    return ret.join( '' );
}

// EXPORTS
jQuery.global = Globalization;

})();


/*
 * Globalize Culture bg
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalization;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalization = require("globalize");
  } else {
    // Global variable
    Globalization = $.global;
  }

  Globalization.cultures["bg"] = Globalization.extend(
    true,
    Globalization.extend(true, {}, Globalization.cultures["default"], {
      name: "bg",
      englishName: "Bulgarian",
      nativeName: "български",
      language: "bg",
      numberFormat: {
        ",": " ",
        ".": ",",
        negativeInfinity: "- безкрайност",
        positiveInfinity: "+ безкрайност",
        percent: {
          ",": " ",
          ".": ","
        },
        currency: {
          pattern: ["-n $", "n $"],
          ",": " ",
          ".": ",",
          symbol: "лв."
        }
      },
      calendars: {
        standard: {
          "/": ".",
          firstDay: 1,
          days: {
            names: [
              "неделя",
              "понеделник",
              "вторник",
              "сряда",
              "четвъртък",
              "петък",
              "събота"
            ],
            namesAbbr: ["нед", "пон", "вт", "ср", "четв", "пет", "съб"],
            namesShort: ["н", "п", "в", "с", "ч", "п", "с"]
          },
          months: {
            names: [
              "януари",
              "февруари",
              "март",
              "април",
              "май",
              "юни",
              "юли",
              "август",
              "септември",
              "октомври",
              "ноември",
              "декември",
              ""
            ],
            namesAbbr: [
              "ян",
              "февр",
              "март",
              "апр",
              "май",
              "юни",
              "юли",
              "авг",
              "септ",
              "окт",
              "ноември",
              "дек",
              ""
            ]
          },
          AM: null,
          PM: null,
          eras: [{ name: "след новата ера", start: null, offset: 0 }],
          patterns: {
            d: "d.M.yyyy 'г.'",
            D: "dd MMMM yyyy 'г.'",
            t: "HH:mm 'ч.'",
            T: "HH:mm:ss 'ч.'",
            f: "dd MMMM yyyy 'г.' HH:mm 'ч.'",
            F: "dd MMMM yyyy 'г.' HH:mm:ss 'ч.'",
            M: "dd MMMM",
            Y: "MMMM yyyy 'г.'"
          }
        }
      }
    }),
    Globalization.cultures["bg"]
  );
})(this);

/*
 * Globalize Culture cs
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalization;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalization = require("globalize");
  } else {
    // Global variable
    Globalization = $.global;
  }

  Globalization.cultures["cs"] = Globalization.extend(
    true,
    Globalization.extend(true, {}, Globalization.cultures["default"], {
      name: "cs",
      englishName: "Czech",
      nativeName: "čeština",
      language: "cs",
      numberFormat: {
        ",": " ",
        ".": ",",
        NaN: "Není číslo",
        negativeInfinity: "-nekonečno",
        positiveInfinity: "+nekonečno",
        percent: {
          pattern: ["-n%", "n%"],
          ",": " ",
          ".": ","
        },
        currency: {
          pattern: ["-n $", "n $"],
          ",": " ",
          ".": ",",
          symbol: "Kč"
        }
      },
      calendars: {
        standard: {
          "/": ".",
          firstDay: 1,
          days: {
            names: [
              "neděle",
              "pondělí",
              "úterý",
              "středa",
              "čtvrtek",
              "pátek",
              "sobota"
            ],
            namesAbbr: ["ne", "po", "út", "st", "čt", "pá", "so"],
            namesShort: ["ne", "po", "út", "st", "čt", "pá", "so"]
          },
          months: {
            names: [
              "leden",
              "únor",
              "březen",
              "duben",
              "květen",
              "červen",
              "červenec",
              "srpen",
              "září",
              "říjen",
              "listopad",
              "prosinec",
              ""
            ],
            namesAbbr: [
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12",
              ""
            ]
          },
          monthsGenitive: {
            names: [
              "ledna",
              "února",
              "března",
              "dubna",
              "května",
              "června",
              "července",
              "srpna",
              "září",
              "října",
              "listopadu",
              "prosince",
              ""
            ],
            namesAbbr: [
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12",
              ""
            ]
          },
          AM: ["dop.", "dop.", "DOP."],
          PM: ["odp.", "odp.", "ODP."],
          eras: [{ name: "n. l.", start: null, offset: 0 }],
          patterns: {
            d: "d.M.yyyy",
            D: "d. MMMM yyyy",
            t: "H:mm",
            T: "H:mm:ss",
            f: "d. MMMM yyyy H:mm",
            F: "d. MMMM yyyy H:mm:ss",
            M: "dd MMMM",
            Y: "MMMM yyyy"
          }
        }
      }
    }),
    Globalization.cultures["cs"]
  );
})(this);

/*
 * Globalize Culture da
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalization;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalization = require("globalize");
  } else {
    // Global variable
    Globalization = $.global;
  }

  Globalization.cultures["da"] = Globalization.extend(
    true,
    Globalization.extend(true, {}, Globalization.cultures["default"], {
      name: "da",
      englishName: "Danish",
      nativeName: "dansk",
      language: "da",
      numberFormat: {
        ",": ".",
        ".": ",",
        negativeInfinity: "-INF",
        positiveInfinity: "INF",
        percent: {
          ",": ".",
          ".": ","
        },
        currency: {
          pattern: ["$ -n", "$ n"],
          ",": ".",
          ".": ",",
          symbol: "kr."
        }
      },
      calendars: {
        standard: {
          "/": "-",
          firstDay: 1,
          days: {
            names: [
              "søndag",
              "mandag",
              "tirsdag",
              "onsdag",
              "torsdag",
              "fredag",
              "lørdag"
            ],
            namesAbbr: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
            namesShort: ["sø", "ma", "ti", "on", "to", "fr", "lø"]
          },
          months: {
            names: [
              "januar",
              "februar",
              "marts",
              "april",
              "maj",
              "juni",
              "juli",
              "august",
              "september",
              "oktober",
              "november",
              "december",
              ""
            ],
            namesAbbr: [
              "jan",
              "feb",
              "mar",
              "apr",
              "maj",
              "jun",
              "jul",
              "aug",
              "sep",
              "okt",
              "nov",
              "dec",
              ""
            ]
          },
          AM: null,
          PM: null,
          patterns: {
            d: "dd-MM-yyyy",
            D: "d. MMMM yyyy",
            t: "HH:mm",
            T: "HH:mm:ss",
            f: "d. MMMM yyyy HH:mm",
            F: "d. MMMM yyyy HH:mm:ss",
            M: "d. MMMM",
            Y: "MMMM yyyy"
          }
        }
      }
    }),
    Globalization.cultures["da"]
  );
})(this);

/*
 * Globalize Culture de
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalization;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalization = require("globalize");
  } else {
    // Global variable
    Globalization = $.global;
  }

  Globalization.cultures["de"] = Globalization.extend(
    true,
    Globalization.extend(true, {}, Globalization.cultures["default"], {
      name: "de",
      englishName: "German",
      nativeName: "Deutsch",
      language: "de",
      numberFormat: {
        ",": ".",
        ".": ",",
        NaN: "n. def.",
        negativeInfinity: "-unendlich",
        positiveInfinity: "+unendlich",
        percent: {
          pattern: ["-n%", "n%"],
          ",": ".",
          ".": ","
        },
        currency: {
          pattern: ["-n $", "n $"],
          ",": ".",
          ".": ",",
          symbol: "€"
        }
      },
      calendars: {
        standard: {
          "/": ".",
          firstDay: 1,
          days: {
            names: [
              "Sonntag",
              "Montag",
              "Dienstag",
              "Mittwoch",
              "Donnerstag",
              "Freitag",
              "Samstag"
            ],
            namesAbbr: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
            namesShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"]
          },
          months: {
            names: [
              "Januar",
              "Februar",
              "März",
              "April",
              "Mai",
              "Juni",
              "Juli",
              "August",
              "September",
              "Oktober",
              "November",
              "Dezember",
              ""
            ],
            namesAbbr: [
              "Jan",
              "Feb",
              "Mrz",
              "Apr",
              "Mai",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Okt",
              "Nov",
              "Dez",
              ""
            ]
          },
          AM: null,
          PM: null,
          eras: [{ name: "n. Chr.", start: null, offset: 0 }],
          patterns: {
            d: "dd.MM.yyyy",
            D: "dddd, d. MMMM yyyy",
            t: "HH:mm",
            T: "HH:mm:ss",
            f: "dddd, d. MMMM yyyy HH:mm",
            F: "dddd, d. MMMM yyyy HH:mm:ss",
            M: "dd MMMM",
            Y: "MMMM yyyy"
          }
        }
      }
    }),
    Globalization.cultures["de"]
  );
})(this);

/*
 * Globalize Culture el
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalization;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalization = require("globalize");
  } else {
    // Global variable
    Globalization = $.global;
  }

  Globalization.cultures["el"] = Globalization.extend(
    true,
    Globalization.extend(true, {}, Globalization.cultures["default"], {
      name: "el",
      englishName: "Greek",
      nativeName: "Ελληνικά",
      language: "el",
      numberFormat: {
        ",": ".",
        ".": ",",
        NaN: "μη αριθμός",
        negativeInfinity: "-Άπειρο",
        positiveInfinity: "Άπειρο",
        percent: {
          pattern: ["-n%", "n%"],
          ",": ".",
          ".": ","
        },
        currency: {
          pattern: ["-n $", "n $"],
          ",": ".",
          ".": ",",
          symbol: "€"
        }
      },
      calendars: {
        standard: {
          firstDay: 1,
          days: {
            names: [
              "Κυριακή",
              "Δευτέρα",
              "Τρίτη",
              "Τετάρτη",
              "Πέμπτη",
              "Παρασκευή",
              "Σάββατο"
            ],
            namesAbbr: ["Κυρ", "Δευ", "Τρι", "Τετ", "Πεμ", "Παρ", "Σαβ"],
            namesShort: ["Κυ", "Δε", "Τρ", "Τε", "Πε", "Πα", "Σά"]
          },
          months: {
            names: [
              "Ιανουάριος",
              "Φεβρουάριος",
              "Μάρτιος",
              "Απρίλιος",
              "Μάιος",
              "Ιούνιος",
              "Ιούλιος",
              "Αύγουστος",
              "Σεπτέμβριος",
              "Οκτώβριος",
              "Νοέμβριος",
              "Δεκέμβριος",
              ""
            ],
            namesAbbr: [
              "Ιαν",
              "Φεβ",
              "Μαρ",
              "Απρ",
              "Μαϊ",
              "Ιουν",
              "Ιουλ",
              "Αυγ",
              "Σεπ",
              "Οκτ",
              "Νοε",
              "Δεκ",
              ""
            ]
          },
          monthsGenitive: {
            names: [
              "Ιανουαρίου",
              "Φεβρουαρίου",
              "Μαρτίου",
              "Απριλίου",
              "Μαΐου",
              "Ιουνίου",
              "Ιουλίου",
              "Αυγούστου",
              "Σεπτεμβρίου",
              "Οκτωβρίου",
              "Νοεμβρίου",
              "Δεκεμβρίου",
              ""
            ],
            namesAbbr: [
              "Ιαν",
              "Φεβ",
              "Μαρ",
              "Απρ",
              "Μαϊ",
              "Ιουν",
              "Ιουλ",
              "Αυγ",
              "Σεπ",
              "Οκτ",
              "Νοε",
              "Δεκ",
              ""
            ]
          },
          AM: ["πμ", "πμ", "ΠΜ"],
          PM: ["μμ", "μμ", "ΜΜ"],
          eras: [{ name: "μ.Χ.", start: null, offset: 0 }],
          patterns: {
            d: "d/M/yyyy",
            D: "dddd, d MMMM yyyy",
            f: "dddd, d MMMM yyyy h:mm tt",
            F: "dddd, d MMMM yyyy h:mm:ss tt",
            M: "dd MMMM",
            Y: "MMMM yyyy"
          }
        }
      }
    }),
    Globalization.cultures["el"]
  );
})(this);

/*
 * Globalize Culture es
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalization;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalization = require("globalize");
  } else {
    // Global variable
    Globalization = $.global;
  }

  Globalization.cultures["es"] = Globalization.extend(
    true,
    Globalization.extend(true, {}, Globalization.cultures["default"], {
      name: "es",
      englishName: "Spanish",
      nativeName: "español",
      language: "es",
      numberFormat: {
        ",": ".",
        ".": ",",
        NaN: "NeuN",
        negativeInfinity: "-Infinito",
        positiveInfinity: "Infinito",
        percent: {
          ",": ".",
          ".": ","
        },
        currency: {
          pattern: ["-n $", "n $"],
          ",": ".",
          ".": ",",
          symbol: "€"
        }
      },
      calendars: {
        standard: {
          firstDay: 1,
          days: {
            names: [
              "domingo",
              "lunes",
              "martes",
              "miércoles",
              "jueves",
              "viernes",
              "sábado"
            ],
            namesAbbr: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
            namesShort: ["do", "lu", "ma", "mi", "ju", "vi", "sá"]
          },
          months: {
            names: [
              "enero",
              "febrero",
              "marzo",
              "abril",
              "mayo",
              "junio",
              "julio",
              "agosto",
              "septiembre",
              "octubre",
              "noviembre",
              "diciembre",
              ""
            ],
            namesAbbr: [
              "ene",
              "feb",
              "mar",
              "abr",
              "may",
              "jun",
              "jul",
              "ago",
              "sep",
              "oct",
              "nov",
              "dic",
              ""
            ]
          },
          AM: null,
          PM: null,
          eras: [{ name: "d.C.", start: null, offset: 0 }],
          patterns: {
            d: "dd/MM/yyyy",
            D: "dddd, dd' de 'MMMM' de 'yyyy",
            t: "H:mm",
            T: "H:mm:ss",
            f: "dddd, dd' de 'MMMM' de 'yyyy H:mm",
            F: "dddd, dd' de 'MMMM' de 'yyyy H:mm:ss",
            M: "dd MMMM",
            Y: "MMMM' de 'yyyy"
          }
        }
      }
    }),
    Globalization.cultures["es"]
  );
})(this);

/*
 * Globalize Culture fi
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalization;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalization = require("globalize");
  } else {
    // Global variable
    Globalization = $.global;
  }

  Globalization.cultures["fi"] = Globalization.extend(
    true,
    Globalization.extend(true, {}, Globalization.cultures["default"], {
      name: "fi",
      englishName: "Finnish",
      nativeName: "suomi",
      language: "fi",
      numberFormat: {
        ",": " ",
        ".": ",",
        negativeInfinity: "-INF",
        positiveInfinity: "INF",
        percent: {
          ",": " ",
          ".": ","
        },
        currency: {
          pattern: ["-n $", "n $"],
          ",": " ",
          ".": ",",
          symbol: "€"
        }
      },
      calendars: {
        standard: {
          "/": ".",
          firstDay: 1,
          days: {
            names: [
              "sunnuntai",
              "maanantai",
              "tiistai",
              "keskiviikko",
              "torstai",
              "perjantai",
              "lauantai"
            ],
            namesAbbr: ["su", "ma", "ti", "ke", "to", "pe", "la"],
            namesShort: ["su", "ma", "ti", "ke", "to", "pe", "la"]
          },
          months: {
            names: [
              "tammikuu",
              "helmikuu",
              "maaliskuu",
              "huhtikuu",
              "toukokuu",
              "kesäkuu",
              "heinäkuu",
              "elokuu",
              "syyskuu",
              "lokakuu",
              "marraskuu",
              "joulukuu",
              ""
            ],
            namesAbbr: [
              "tammi",
              "helmi",
              "maalis",
              "huhti",
              "touko",
              "kesä",
              "heinä",
              "elo",
              "syys",
              "loka",
              "marras",
              "joulu",
              ""
            ]
          },
          AM: null,
          PM: null,
          patterns: {
            d: "d.M.yyyy",
            D: "d. MMMM'ta 'yyyy",
            t: "H:mm",
            T: "H:mm:ss",
            f: "d. MMMM'ta 'yyyy H:mm",
            F: "d. MMMM'ta 'yyyy H:mm:ss",
            M: "d. MMMM'ta'",
            Y: "MMMM yyyy"
          }
        }
      }
    }),
    Globalization.cultures["fi"]
  );
})(this);

/*
 * Globalize Culture fr
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalization;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalization = require("globalize");
  } else {
    // Global variable
    Globalization = $.global;
  }

  Globalization.cultures["fr"] = Globalization.extend(
    true,
    Globalization.extend(true, {}, Globalization.cultures["default"], {
      name: "fr",
      englishName: "French",
      nativeName: "français",
      language: "fr",
      numberFormat: {
        ",": " ",
        ".": ",",
        NaN: "Non Numérique",
        negativeInfinity: "-Infini",
        positiveInfinity: "+Infini",
        percent: {
          ",": " ",
          ".": ","
        },
        currency: {
          pattern: ["-n $", "n $"],
          ",": " ",
          ".": ",",
          symbol: "€"
        }
      },
      calendars: {
        standard: {
          firstDay: 1,
          days: {
            names: [
              "dimanche",
              "lundi",
              "mardi",
              "mercredi",
              "jeudi",
              "vendredi",
              "samedi"
            ],
            namesAbbr: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
            namesShort: ["di", "lu", "ma", "me", "je", "ve", "sa"]
          },
          months: {
            names: [
              "janvier",
              "février",
              "mars",
              "avril",
              "mai",
              "juin",
              "juillet",
              "août",
              "septembre",
              "octobre",
              "novembre",
              "décembre",
              ""
            ],
            namesAbbr: [
              "janv.",
              "févr.",
              "mars",
              "avr.",
              "mai",
              "juin",
              "juil.",
              "août",
              "sept.",
              "oct.",
              "nov.",
              "déc.",
              ""
            ]
          },
          AM: null,
          PM: null,
          eras: [{ name: "ap. J.-C.", start: null, offset: 0 }],
          patterns: {
            d: "dd/MM/yyyy",
            D: "dddd d MMMM yyyy",
            t: "HH:mm",
            T: "HH:mm:ss",
            f: "dddd d MMMM yyyy HH:mm",
            F: "dddd d MMMM yyyy HH:mm:ss",
            M: "d MMMM",
            Y: "MMMM yyyy"
          }
        }
      }
    }),
    Globalization.cultures["fr"]
  );
})(this);

/*
 * Globalize Culture hr
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalization;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalization = require("globalize");
  } else {
    // Global variable
    Globalization = $.global;
  }

  Globalization.cultures["hr"] = Globalization.extend(
    true,
    Globalization.extend(true, {}, Globalization.cultures["default"], {
      name: "hr",
      englishName: "Croatian",
      nativeName: "hrvatski",
      language: "hr",
      numberFormat: {
        pattern: ["- n"],
        ",": ".",
        ".": ",",
        percent: {
          pattern: ["-n%", "n%"],
          ",": ".",
          ".": ","
        },
        currency: {
          pattern: ["-n $", "n $"],
          ",": ".",
          ".": ",",
          symbol: "kn"
        }
      },
      calendars: {
        standard: {
          "/": ".",
          firstDay: 1,
          days: {
            names: [
              "nedjelja",
              "ponedjeljak",
              "utorak",
              "srijeda",
              "četvrtak",
              "petak",
              "subota"
            ],
            namesAbbr: ["ned", "pon", "uto", "sri", "čet", "pet", "sub"],
            namesShort: ["ne", "po", "ut", "sr", "če", "pe", "su"]
          },
          months: {
            names: [
              "siječanj",
              "veljača",
              "ožujak",
              "travanj",
              "svibanj",
              "lipanj",
              "srpanj",
              "kolovoz",
              "rujan",
              "listopad",
              "studeni",
              "prosinac",
              ""
            ],
            namesAbbr: [
              "sij",
              "vlj",
              "ožu",
              "tra",
              "svi",
              "lip",
              "srp",
              "kol",
              "ruj",
              "lis",
              "stu",
              "pro",
              ""
            ]
          },
          monthsGenitive: {
            names: [
              "siječnja",
              "veljače",
              "ožujka",
              "travnja",
              "svibnja",
              "lipnja",
              "srpnja",
              "kolovoza",
              "rujna",
              "listopada",
              "studenog",
              "prosinca",
              ""
            ],
            namesAbbr: [
              "sij",
              "vlj",
              "ožu",
              "tra",
              "svi",
              "lip",
              "srp",
              "kol",
              "ruj",
              "lis",
              "stu",
              "pro",
              ""
            ]
          },
          AM: null,
          PM: null,
          patterns: {
            d: "d.M.yyyy.",
            D: "d. MMMM yyyy.",
            t: "H:mm",
            T: "H:mm:ss",
            f: "d. MMMM yyyy. H:mm",
            F: "d. MMMM yyyy. H:mm:ss",
            M: "d. MMMM"
          }
        }
      }
    }),
    Globalization.cultures["hr"]
  );
})(this);

/*
 * Globalize Culture hu
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalization;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalization = require("globalize");
  } else {
    // Global variable
    Globalization = $.global;
  }

  Globalization.cultures["hu"] = Globalization.extend(
    true,
    Globalization.extend(true, {}, Globalization.cultures["default"], {
      name: "hu",
      englishName: "Hungarian",
      nativeName: "magyar",
      language: "hu",
      numberFormat: {
        ",": " ",
        ".": ",",
        NaN: "nem szám",
        negativeInfinity: "negatív végtelen",
        positiveInfinity: "végtelen",
        percent: {
          ",": " ",
          ".": ","
        },
        currency: {
          pattern: ["-n $", "n $"],
          ",": " ",
          ".": ",",
          symbol: "Ft"
        }
      },
      calendars: {
        standard: {
          "/": ".",
          firstDay: 1,
          days: {
            names: [
              "vasárnap",
              "hétfő",
              "kedd",
              "szerda",
              "csütörtök",
              "péntek",
              "szombat"
            ],
            namesAbbr: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
            namesShort: ["V", "H", "K", "Sze", "Cs", "P", "Szo"]
          },
          months: {
            names: [
              "január",
              "február",
              "március",
              "április",
              "május",
              "június",
              "július",
              "augusztus",
              "szeptember",
              "október",
              "november",
              "december",
              ""
            ],
            namesAbbr: [
              "jan.",
              "febr.",
              "márc.",
              "ápr.",
              "máj.",
              "jún.",
              "júl.",
              "aug.",
              "szept.",
              "okt.",
              "nov.",
              "dec.",
              ""
            ]
          },
          AM: ["de.", "de.", "DE."],
          PM: ["du.", "du.", "DU."],
          eras: [{ name: "i.sz.", start: null, offset: 0 }],
          patterns: {
            d: "yyyy.MM.dd.",
            D: "yyyy. MMMM d.",
            t: "H:mm",
            T: "H:mm:ss",
            f: "yyyy. MMMM d. H:mm",
            F: "yyyy. MMMM d. H:mm:ss",
            M: "MMMM d.",
            Y: "yyyy. MMMM"
          }
        }
      }
    }),
    Globalization.cultures["hu"]
  );
})(this);

/*
 * Globalize Culture it
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalization;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalization = require("globalize");
  } else {
    // Global variable
    Globalization = $.global;
  }

  Globalization.cultures["it"] = Globalization.extend(
    true,
    Globalization.extend(true, {}, Globalization.cultures["default"], {
      name: "it",
      englishName: "Italian",
      nativeName: "italiano",
      language: "it",
      numberFormat: {
        ",": ".",
        ".": ",",
        NaN: "Non un numero reale",
        negativeInfinity: "-Infinito",
        positiveInfinity: "+Infinito",
        percent: {
          pattern: ["-n%", "n%"],
          ",": ".",
          ".": ","
        },
        currency: {
          pattern: ["-$ n", "$ n"],
          ",": ".",
          ".": ",",
          symbol: "€"
        }
      },
      calendars: {
        standard: {
          firstDay: 1,
          days: {
            names: [
              "domenica",
              "lunedì",
              "martedì",
              "mercoledì",
              "giovedì",
              "venerdì",
              "sabato"
            ],
            namesAbbr: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
            namesShort: ["do", "lu", "ma", "me", "gi", "ve", "sa"]
          },
          months: {
            names: [
              "gennaio",
              "febbraio",
              "marzo",
              "aprile",
              "maggio",
              "giugno",
              "luglio",
              "agosto",
              "settembre",
              "ottobre",
              "novembre",
              "dicembre",
              ""
            ],
            namesAbbr: [
              "gen",
              "feb",
              "mar",
              "apr",
              "mag",
              "giu",
              "lug",
              "ago",
              "set",
              "ott",
              "nov",
              "dic",
              ""
            ]
          },
          AM: null,
          PM: null,
          eras: [{ name: "d.C.", start: null, offset: 0 }],
          patterns: {
            d: "dd/MM/yyyy",
            D: "dddd d MMMM yyyy",
            t: "HH:mm",
            T: "HH:mm:ss",
            f: "dddd d MMMM yyyy HH:mm",
            F: "dddd d MMMM yyyy HH:mm:ss",
            M: "dd MMMM",
            Y: "MMMM yyyy"
          }
        }
      }
    }),
    Globalization.cultures["it"]
  );
})(this);

/*
 * Globalize Culture nl
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalization;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalization = require("globalize");
  } else {
    // Global variable
    Globalization = $.global;
  }

  Globalization.cultures["nl"] = Globalization.extend(
    true,
    Globalization.extend(true, {}, Globalization.cultures["default"], {
      name: "nl",
      englishName: "Dutch",
      nativeName: "Nederlands",
      language: "nl",
      numberFormat: {
        ",": ".",
        ".": ",",
        percent: {
          ",": ".",
          ".": ","
        },
        currency: {
          pattern: ["$ -n", "$ n"],
          ",": ".",
          ".": ",",
          symbol: "€"
        }
      },
      calendars: {
        standard: {
          "/": "-",
          firstDay: 1,
          days: {
            names: [
              "zondag",
              "maandag",
              "dinsdag",
              "woensdag",
              "donderdag",
              "vrijdag",
              "zaterdag"
            ],
            namesAbbr: ["zo", "ma", "di", "wo", "do", "vr", "za"],
            namesShort: ["zo", "ma", "di", "wo", "do", "vr", "za"]
          },
          months: {
            names: [
              "januari",
              "februari",
              "maart",
              "april",
              "mei",
              "juni",
              "juli",
              "augustus",
              "september",
              "oktober",
              "november",
              "december",
              ""
            ],
            namesAbbr: [
              "jan",
              "feb",
              "mrt",
              "apr",
              "mei",
              "jun",
              "jul",
              "aug",
              "sep",
              "okt",
              "nov",
              "dec",
              ""
            ]
          },
          AM: null,
          PM: null,
          patterns: {
            d: "d-M-yyyy",
            D: "dddd d MMMM yyyy",
            t: "H:mm",
            T: "H:mm:ss",
            f: "dddd d MMMM yyyy H:mm",
            F: "dddd d MMMM yyyy H:mm:ss",
            M: "dd MMMM",
            Y: "MMMM yyyy"
          }
        }
      }
    }),
    Globalization.cultures["nl"]
  );
})(this);

/*
 * Globalize Culture no
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalization;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalization = require("globalize");
  } else {
    // Global variable
    Globalization = $.global;
  }

  Globalization.cultures["no"] = Globalization.extend(
    true,
    Globalization.extend(true, {}, Globalization.cultures["default"], {
      name: "no",
      englishName: "Norwegian",
      nativeName: "norsk",
      language: "no",
      numberFormat: {
        ",": " ",
        ".": ",",
        negativeInfinity: "-INF",
        positiveInfinity: "INF",
        percent: {
          ",": " ",
          ".": ","
        },
        currency: {
          pattern: ["$ -n", "$ n"],
          ",": " ",
          ".": ",",
          symbol: "kr"
        }
      },
      calendars: {
        standard: {
          "/": ".",
          firstDay: 1,
          days: {
            names: [
              "søndag",
              "mandag",
              "tirsdag",
              "onsdag",
              "torsdag",
              "fredag",
              "lørdag"
            ],
            namesAbbr: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
            namesShort: ["sø", "ma", "ti", "on", "to", "fr", "lø"]
          },
          months: {
            names: [
              "januar",
              "februar",
              "mars",
              "april",
              "mai",
              "juni",
              "juli",
              "august",
              "september",
              "oktober",
              "november",
              "desember",
              ""
            ],
            namesAbbr: [
              "jan",
              "feb",
              "mar",
              "apr",
              "mai",
              "jun",
              "jul",
              "aug",
              "sep",
              "okt",
              "nov",
              "des",
              ""
            ]
          },
          AM: null,
          PM: null,
          patterns: {
            d: "dd.MM.yyyy",
            D: "d. MMMM yyyy",
            t: "HH:mm",
            T: "HH:mm:ss",
            f: "d. MMMM yyyy HH:mm",
            F: "d. MMMM yyyy HH:mm:ss",
            M: "d. MMMM",
            Y: "MMMM yyyy"
          }
        }
      }
    }),
    Globalization.cultures["no"]
  );
})(this);

/*
 * Globalize Culture pl
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalization;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalization = require("globalize");
  } else {
    // Global variable
    Globalization = $.global;
  }

  Globalization.cultures["pl"] = Globalization.extend(
    true,
    Globalization.extend(true, {}, Globalization.cultures["default"], {
      name: "pl",
      englishName: "Polish",
      nativeName: "polski",
      language: "pl",
      numberFormat: {
        ",": " ",
        ".": ",",
        NaN: "nie jest liczbą",
        negativeInfinity: "-nieskończoność",
        positiveInfinity: "+nieskończoność",
        percent: {
          pattern: ["-n%", "n%"],
          ",": " ",
          ".": ","
        },
        currency: {
          pattern: ["-n $", "n $"],
          ",": " ",
          ".": ",",
          symbol: "zł"
        }
      },
      calendars: {
        standard: {
          "/": "-",
          firstDay: 1,
          days: {
            names: [
              "niedziela",
              "poniedziałek",
              "wtorek",
              "środa",
              "czwartek",
              "piątek",
              "sobota"
            ],
            namesAbbr: ["niedz.", "pon.", "wt.", "śr.", "czw.", "pt.", "sob."],
            namesShort: ["N", "Pn", "Wt", "Śr", "Cz", "Pt", "So"]
          },
          months: {
            names: [
              "styczeń",
              "luty",
              "marzec",
              "kwiecień",
              "maj",
              "czerwiec",
              "lipiec",
              "sierpień",
              "wrzesień",
              "październik",
              "listopad",
              "grudzień",
              ""
            ],
            namesAbbr: [
              "sty",
              "lut",
              "mar",
              "kwi",
              "maj",
              "cze",
              "lip",
              "sie",
              "wrz",
              "paź",
              "lis",
              "gru",
              ""
            ]
          },
          monthsGenitive: {
            names: [
              "stycznia",
              "lutego",
              "marca",
              "kwietnia",
              "maja",
              "czerwca",
              "lipca",
              "sierpnia",
              "września",
              "października",
              "listopada",
              "grudnia",
              ""
            ],
            namesAbbr: [
              "sty",
              "lut",
              "mar",
              "kwi",
              "maj",
              "cze",
              "lip",
              "sie",
              "wrz",
              "paź",
              "lis",
              "gru",
              ""
            ]
          },
          AM: null,
          PM: null,
          patterns: {
            d: "yyyy-MM-dd",
            D: "d MMMM yyyy",
            t: "HH:mm",
            T: "HH:mm:ss",
            f: "d MMMM yyyy HH:mm",
            F: "d MMMM yyyy HH:mm:ss",
            M: "d MMMM",
            Y: "MMMM yyyy"
          }
        }
      }
    }),
    Globalization.cultures["pl"]
  );
})(this);

/*
 * Globalize Culture pt
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalization;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalization = require("globalize");
  } else {
    // Global variable
    Globalization = $.global;
  }

  Globalization.cultures["pt"] = Globalization.extend(
    true,
    Globalization.extend(true, {}, Globalization.cultures["default"], {
      name: "pt",
      englishName: "Portuguese",
      nativeName: "Português",
      language: "pt",
      numberFormat: {
        ",": ".",
        ".": ",",
        NaN: "NaN (Não é um número)",
        negativeInfinity: "-Infinito",
        positiveInfinity: "+Infinito",
        percent: {
          pattern: ["-n%", "n%"],
          ",": ".",
          ".": ","
        },
        currency: {
          pattern: ["-$ n", "$ n"],
          ",": ".",
          ".": ",",
          symbol: "R$"
        }
      },
      calendars: {
        standard: {
          days: {
            names: [
              "domingo",
              "segunda-feira",
              "terça-feira",
              "quarta-feira",
              "quinta-feira",
              "sexta-feira",
              "sábado"
            ],
            namesAbbr: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
            namesShort: ["D", "S", "T", "Q", "Q", "S", "S"]
          },
          months: {
            names: [
              "janeiro",
              "fevereiro",
              "março",
              "abril",
              "maio",
              "junho",
              "julho",
              "agosto",
              "setembro",
              "outubro",
              "novembro",
              "dezembro",
              ""
            ],
            namesAbbr: [
              "jan",
              "fev",
              "mar",
              "abr",
              "mai",
              "jun",
              "jul",
              "ago",
              "set",
              "out",
              "nov",
              "dez",
              ""
            ]
          },
          AM: null,
          PM: null,
          eras: [{ name: "d.C.", start: null, offset: 0 }],
          patterns: {
            d: "dd/MM/yyyy",
            D: "dddd, d' de 'MMMM' de 'yyyy",
            t: "HH:mm",
            T: "HH:mm:ss",
            f: "dddd, d' de 'MMMM' de 'yyyy HH:mm",
            F: "dddd, d' de 'MMMM' de 'yyyy HH:mm:ss",
            M: "dd' de 'MMMM",
            Y: "MMMM' de 'yyyy"
          }
        }
      }
    }),
    Globalization.cultures["pt"]
  );
})(this);

/*
 * Globalize Culture ro
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalization;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalization = require("globalize");
  } else {
    // Global variable
    Globalization = $.global;
  }

  Globalization.cultures["ro"] = Globalization.extend(
    true,
    Globalization.extend(true, {}, Globalization.cultures["default"], {
      name: "ro",
      englishName: "Romanian",
      nativeName: "română",
      language: "ro",
      numberFormat: {
        ",": ".",
        ".": ",",
        percent: {
          pattern: ["-n%", "n%"],
          ",": ".",
          ".": ","
        },
        currency: {
          pattern: ["-n $", "n $"],
          ",": ".",
          ".": ",",
          symbol: "lei"
        }
      },
      calendars: {
        standard: {
          "/": ".",
          firstDay: 1,
          days: {
            names: [
              "duminică",
              "luni",
              "marţi",
              "miercuri",
              "joi",
              "vineri",
              "sâmbătă"
            ],
            namesAbbr: ["D", "L", "Ma", "Mi", "J", "V", "S"],
            namesShort: ["D", "L", "Ma", "Mi", "J", "V", "S"]
          },
          months: {
            names: [
              "ianuarie",
              "februarie",
              "martie",
              "aprilie",
              "mai",
              "iunie",
              "iulie",
              "august",
              "septembrie",
              "octombrie",
              "noiembrie",
              "decembrie",
              ""
            ],
            namesAbbr: [
              "ian.",
              "feb.",
              "mar.",
              "apr.",
              "mai.",
              "iun.",
              "iul.",
              "aug.",
              "sep.",
              "oct.",
              "nov.",
              "dec.",
              ""
            ]
          },
          AM: null,
          PM: null,
          patterns: {
            d: "dd.MM.yyyy",
            D: "d MMMM yyyy",
            t: "HH:mm",
            T: "HH:mm:ss",
            f: "d MMMM yyyy HH:mm",
            F: "d MMMM yyyy HH:mm:ss",
            M: "d MMMM",
            Y: "MMMM yyyy"
          }
        }
      }
    }),
    Globalization.cultures["ro"]
  );
})(this);

/*
 * Globalize Culture sk
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalization;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalization = require("globalize");
  } else {
    // Global variable
    Globalization = $.global;
  }

  Globalization.cultures["sk"] = Globalization.extend(
    true,
    Globalization.extend(true, {}, Globalization.cultures["default"], {
      name: "sk",
      englishName: "Slovak",
      nativeName: "slovenčina",
      language: "sk",
      numberFormat: {
        ",": " ",
        ".": ",",
        NaN: "Nie je číslo",
        negativeInfinity: "-nekonečno",
        positiveInfinity: "+nekonečno",
        percent: {
          pattern: ["-n%", "n%"],
          ",": " ",
          ".": ","
        },
        currency: {
          pattern: ["-n $", "n $"],
          ",": " ",
          ".": ",",
          symbol: "€"
        }
      },
      calendars: {
        standard: {
          "/": ". ",
          firstDay: 1,
          days: {
            names: [
              "nedeľa",
              "pondelok",
              "utorok",
              "streda",
              "štvrtok",
              "piatok",
              "sobota"
            ],
            namesAbbr: ["ne", "po", "ut", "st", "št", "pi", "so"],
            namesShort: ["ne", "po", "ut", "st", "št", "pi", "so"]
          },
          months: {
            names: [
              "január",
              "február",
              "marec",
              "apríl",
              "máj",
              "jún",
              "júl",
              "august",
              "september",
              "október",
              "november",
              "december",
              ""
            ],
            namesAbbr: [
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12",
              ""
            ]
          },
          monthsGenitive: {
            names: [
              "januára",
              "februára",
              "marca",
              "apríla",
              "mája",
              "júna",
              "júla",
              "augusta",
              "septembra",
              "októbra",
              "novembra",
              "decembra",
              ""
            ],
            namesAbbr: [
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12",
              ""
            ]
          },
          AM: null,
          PM: null,
          eras: [{ name: "n. l.", start: null, offset: 0 }],
          patterns: {
            d: "d. M. yyyy",
            D: "d. MMMM yyyy",
            t: "H:mm",
            T: "H:mm:ss",
            f: "d. MMMM yyyy H:mm",
            F: "d. MMMM yyyy H:mm:ss",
            M: "dd MMMM",
            Y: "MMMM yyyy"
          }
        }
      }
    }),
    Globalization.cultures["sk"]
  );
})(this);

/*
 * Globalize Culture sl
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalization;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalization = require("globalize");
  } else {
    // Global variable
    Globalization = $.global;
  }

  Globalization.cultures["sl"] = Globalization.extend(
    true,
    Globalization.extend(true, {}, Globalization.cultures["default"], {
      name: "sl",
      englishName: "Slovenian",
      nativeName: "slovenski",
      language: "sl",
      numberFormat: {
        ",": ".",
        ".": ",",
        negativeInfinity: "-neskončnost",
        positiveInfinity: "neskončnost",
        percent: {
          pattern: ["-n%", "n%"],
          ",": ".",
          ".": ","
        },
        currency: {
          pattern: ["-n $", "n $"],
          ",": ".",
          ".": ",",
          symbol: "€"
        }
      },
      calendars: {
        standard: {
          "/": ".",
          firstDay: 1,
          days: {
            names: [
              "nedelja",
              "ponedeljek",
              "torek",
              "sreda",
              "četrtek",
              "petek",
              "sobota"
            ],
            namesAbbr: ["ned", "pon", "tor", "sre", "čet", "pet", "sob"],
            namesShort: ["ne", "po", "to", "sr", "če", "pe", "so"]
          },
          months: {
            names: [
              "januar",
              "februar",
              "marec",
              "april",
              "maj",
              "junij",
              "julij",
              "avgust",
              "september",
              "oktober",
              "november",
              "december",
              ""
            ],
            namesAbbr: [
              "jan",
              "feb",
              "mar",
              "apr",
              "maj",
              "jun",
              "jul",
              "avg",
              "sep",
              "okt",
              "nov",
              "dec",
              ""
            ]
          },
          AM: null,
          PM: null,
          patterns: {
            d: "d.M.yyyy",
            D: "d. MMMM yyyy",
            t: "H:mm",
            T: "H:mm:ss",
            f: "d. MMMM yyyy H:mm",
            F: "d. MMMM yyyy H:mm:ss",
            M: "d. MMMM",
            Y: "MMMM yyyy"
          }
        }
      }
    }),
    Globalization.cultures["sl"]
  );
})(this);

/*
 * Globalize Culture sr
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalization;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalization = require("globalize");
  } else {
    // Global variable
    Globalization = $.global;
  }

  Globalization.cultures["sr"] = Globalization.extend(
    true,
    Globalization.extend(true, {}, Globalization.cultures["default"], {
      name: "sr",
      englishName: "Serbian",
      nativeName: "srpski",
      language: "sr",
      numberFormat: {
        ",": ".",
        ".": ",",
        negativeInfinity: "-beskonačnost",
        positiveInfinity: "+beskonačnost",
        percent: {
          pattern: ["-n%","n%"],
          ",": ".",
          ".": ","
        },
        currency: {
          pattern: ["-n $","n $"],
          ",": ".",
          ".": ",",
          symbol: "Din."
        }
      },
      calendars: {
        standard: {
          "/": ".",
          firstDay: 1,
          days: {
            names: ["nedelja","ponedeljak","utorak","sreda","četvrtak","petak","subota"],
            namesAbbr: ["ned","pon","uto","sre","čet","pet","sub"],
            namesShort: ["ne","po","ut","sr","če","pe","su"]
          },
          months: {
            names: ["januar","februar","mart","april","maj","jun","jul","avgust","septembar","oktobar","novembar","decembar",""],
            namesAbbr: ["jan","feb","mar","apr","maj","jun","jul","avg","sep","okt","nov","dec",""]
          },
          AM: null,
          PM: null,
          eras: [{"name":"n.e.","start":null,"offset":0}],
          patterns: {
            d: "d.M.yyyy",
            D: "d. MMMM yyyy",
            t: "H:mm",
            T: "H:mm:ss",
            f: "d. MMMM yyyy H:mm",
            F: "d. MMMM yyyy H:mm:ss",
            M: "d. MMMM",
            Y: "MMMM yyyy"
          }
        }
      }
    }),
    Globalization.cultures["sr"]
  );
})(this);

/*
 * Globalize Culture sv
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalization;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalization = require("globalize");
  } else {
    // Global variable
    Globalization = $.global;
  }

  Globalization.cultures["sv"] = Globalization.extend(
    true,
    Globalization.extend(true, {}, Globalization.cultures["default"], {
      name: "sv",
      englishName: "Swedish",
      nativeName: "svenska",
      language: "sv",
      numberFormat: {
        ",": " ",
        ".": ",",
        negativeInfinity: "-INF",
        positiveInfinity: "INF",
        percent: {
          ",": " ",
          ".": ","
        },
        currency: {
          pattern: ["-n $", "n $"],
          ",": ".",
          ".": ",",
          symbol: "kr"
        }
      },
      calendars: {
        standard: {
          "/": "-",
          firstDay: 1,
          days: {
            names: [
              "söndag",
              "måndag",
              "tisdag",
              "onsdag",
              "torsdag",
              "fredag",
              "lördag"
            ],
            namesAbbr: ["sö", "må", "ti", "on", "to", "fr", "lö"],
            namesShort: ["sö", "må", "ti", "on", "to", "fr", "lö"]
          },
          months: {
            names: [
              "januari",
              "februari",
              "mars",
              "april",
              "maj",
              "juni",
              "juli",
              "augusti",
              "september",
              "oktober",
              "november",
              "december",
              ""
            ],
            namesAbbr: [
              "jan",
              "feb",
              "mar",
              "apr",
              "maj",
              "jun",
              "jul",
              "aug",
              "sep",
              "okt",
              "nov",
              "dec",
              ""
            ]
          },
          AM: null,
          PM: null,
          patterns: {
            d: "yyyy-MM-dd",
            D: "'den 'd MMMM yyyy",
            t: "HH:mm",
            T: "HH:mm:ss",
            f: "'den 'd MMMM yyyy HH:mm",
            F: "'den 'd MMMM yyyy HH:mm:ss",
            M: "'den 'd MMMM",
            Y: "MMMM yyyy"
          }
        }
      }
    }),
    Globalization.cultures["sv"]
  );
})(this);

/*
 * Globalize Culture tr
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalization;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalization = require("globalize");
  } else {
    // Global variable
    Globalization = $.global;
  }

  Globalization.cultures["tr"] = Globalization.extend(
    true,
    Globalization.extend(true, {}, Globalization.cultures["default"], {
      name: "tr",
      englishName: "Turkish",
      nativeName: "Türkçe",
      language: "tr",
      numberFormat: {
        ",": ".",
        ".": ",",
        percent: {
          pattern: ["-%n", "%n"],
          ",": ".",
          ".": ","
        },
        currency: {
          pattern: ["-n $", "n $"],
          ",": ".",
          ".": ",",
          symbol: "TL"
        }
      },
      calendars: {
        standard: {
          "/": ".",
          firstDay: 1,
          days: {
            names: [
              "Pazar",
              "Pazartesi",
              "Salı",
              "Çarşamba",
              "Perşembe",
              "Cuma",
              "Cumartesi"
            ],
            namesAbbr: ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"],
            namesShort: ["Pz", "Pt", "Sa", "Ça", "Pe", "Cu", "Ct"]
          },
          months: {
            names: [
              "Ocak",
              "Şubat",
              "Mart",
              "Nisan",
              "Mayıs",
              "Haziran",
              "Temmuz",
              "Ağustos",
              "Eylül",
              "Ekim",
              "Kasım",
              "Aralık",
              ""
            ],
            namesAbbr: [
              "Oca",
              "Şub",
              "Mar",
              "Nis",
              "May",
              "Haz",
              "Tem",
              "Ağu",
              "Eyl",
              "Eki",
              "Kas",
              "Ara",
              ""
            ]
          },
          AM: null,
          PM: null,
          patterns: {
            d: "dd.MM.yyyy",
            D: "dd MMMM yyyy dddd",
            t: "HH:mm",
            T: "HH:mm:ss",
            f: "dd MMMM yyyy dddd HH:mm",
            F: "dd MMMM yyyy dddd HH:mm:ss",
            M: "dd MMMM",
            Y: "MMMM yyyy"
          }
        }
      }
    }),
    Globalization.cultures["tr"]
  );
})(this);

$(document).ready(function() {
  new AdvancedProperty().init();
});

var AdvancedProperty = function() {};

AdvancedProperty.SELECTOR_GROUP = ".advanced-property-group";
AdvancedProperty.SELECTOR_ANCHOR = ".advanced-property-group .advanced";
AdvancedProperty.SELECTOR_CANCEL = ".button.cancel";
AdvancedProperty.CLASS_SHOW = "show-advanced-properties";

AdvancedProperty.prototype = {
  /* INIT */
  init: function() {
    this.setEvents();
  },

  showOrHideElement: function() {
    var $body = $("body");

    if ($body.hasClass("hideheader") || $body.hasClass("hideroomheader")) {
      if ($body.hasClass(AdvancedProperty.CLASS_SHOW)) {
        $(".room section.result").css("top", 0);
      } else {
        $(".room section.result").css("top", this.calculateTop());
      }
    }
    $("body").toggleClass(AdvancedProperty.CLASS_SHOW);
  },

  closeElement: function() {
    $("body").removeClass(AdvancedProperty.CLASS_SHOW);
    $(".room section.result").css("top", 0);
  },

  calculateTop: function() {
    //calc(80px + 370px + 85px - 20px - 30px)
    var advancedPropertyHeatingHeight = 290;
    var advancedPropertyCoolingHeight = 80;
    var advancedPropertyErrorHeight = 55;

    var advancedPropertyGroupHeight = advancedPropertyHeatingHeight;
    if ($(".advanced-property-group.has-cooling-controls").length > 0) {
      advancedPropertyGroupHeight += advancedPropertyCoolingHeight;
    }
    if ($(".advanced-property-group.has-error").length > 0) {
      advancedPropertyGroupHeight += advancedPropertyErrorHeight;
    }

    var roomHeaderHeight = 80;
    var spaceBetweenSubHeaderAndRoomHeader = 20;
    var extra = $("body").hasClass("hideheader") ? 30 : 0;
    var scrollTop = $("html")[0].scrollTop;

    return (
      roomHeaderHeight +
      advancedPropertyGroupHeight +
      scrollTop -
      spaceBetweenSubHeaderAndRoomHeader -
      extra
    );
  },

  /* EVENTS */
  setEvents: function() {
    $(AdvancedProperty.SELECTOR_ANCHOR).click(this.anchorClicked.bind(this));
    $(AdvancedProperty.SELECTOR_CANCEL, this.$el).click(
      this.closeElement.bind(this)
    );
  },

  anchorClicked: function(evt) {
    evt.stopPropagation();
    this.showOrHideElement();
  },
};

$(document).ready(function() {
    new CapacityBarController().init();
});

var CapacityBarController = function() {};
CapacityBarController.prototype = {
    init: function($container) {
        $('.capacity-bar', $container).each(function(i, bar) {
            new CapacityBar().init($(bar));
        });
    }
};

var CapacityBar = (function() {
    var _ = {
        SELECTOR: {
            current: '.current',
            maximum: '.maximum',
            progress: '.progressbar-progress',
            LABEL: {
                current: '.current-formatted',
                maximum: '.maximum-formatted'
            }
        },

        calculateCurrentPercentage: function($element) {
            var current = parseFloat($(_.SELECTOR.current, $element).val());
            var maximum = parseFloat($(_.SELECTOR.maximum, $element).val());

            if (isNaN(current) || isNaN(maximum)) {
                return 0;
            }

            var maxPercent = 100;
            var percent = (maxPercent / maximum) * current;

            return Math.ceil(percent);
        }
    };

    function capacityBar() {}

    capacityBar.prototype = {
        init: function($element) {
            if (!$element || !$element.length) {
                return;
            }

            $element[0].CapacityBar = this;
            this.$element = $element;

            var percentage = _.calculateCurrentPercentage($element);
            $(_.SELECTOR.progress, $element).width(percentage + '%');
        },

        refresh: function(current, currentFormatted) {
            var $element = this.$element;

            $(_.SELECTOR.current, $element).val(current);
            $(_.SELECTOR.LABEL.current, $element).text(currentFormatted);

            var percentage = _.calculateCurrentPercentage($element);
            $(_.SELECTOR.progress, $element).width(percentage + '%');
        }
    };

    return capacityBar;
})();

///<reference path="../../Libraries/js/01-jquery-3.1.1.min.js"/>
///<reference path="../../../Js/Application/Common/AjaxCall.js"/>

var DataHrefAttribute = (function() {
    function dataHrefAttribute() { }
    dataHrefAttribute.prototype = {
        init: function($container) {
            $('[data-href]',$container).on('click', function () {
                if (!!$(this).data('ajax')) {
                    var success = null;
                    if ($(this).data('ajax-success')) {
                        success = eval($(this).data('ajax-success')).bind(this);
                    }

                    AjaxCall.send($(this).data('href'), {}, success);
                    return false;
                }

                if (!$(this).data('popup-target')) {
                    window.location = $(this).data('href');
                    return false;
                }
            });
        }
    }

    return dataHrefAttribute;
}());

/// <reference path="../_shared/js/01-jquery-3.1.1.min.js" />
/// <reference path="../_shared/js/03-device.min.js" />

$(document).ready(function() {
    new DropdownGroupController().init();
});

var DropdownGroupController = (function () {
    var _ = {
        DROPDOWN_SELECTOR: '.dropdown-group .dropdown'
    };

    function dropdownGroupController() { }

    dropdownGroupController.prototype = {
        init: function () {
            $(_.DROPDOWN_SELECTOR).each(function (i, dropdown) {
                new Dropdown().init($(dropdown));
            });
        }
    };

    return dropdownGroupController;
}());

$(window).click(function() {
    new Dropdown().closeAllDropdowns();
});

var Dropdown = function() {};

Dropdown.SELECTOR_CONTENT = '.dropdown-content';
Dropdown.SELECTOR_GROUP = '.dropdown-group';
Dropdown.SELECTOR_DROPDOWN = '.dropdown';

Dropdown.prototype = {
    SELECTOR_OPTIONS: 'select:not(.hide) option',
    SELECTOR_CUSTOM_OPTIONS: '.dropdown-content div',
    SELECTOR_UNIT: '.dropdown-unit',
    SELECTOR_SELECT: 'select:not(.hide)',
    CLASS_SELECTED: 'active',
    CLASS_READ_ONLY:'read-only',
    /* INIT */
    init: function($element, options) {
        if (!$element || !$element.length)
            return;

        this.$el = $element;
        this.options = options;
        $element[0].Dropdown = this;

        this.$content = $(Dropdown.SELECTOR_CONTENT, this.$el);
        this.$input = $('input', this.$el);
        this.$select = $(this.SELECTOR_SELECT, this.$el);
        this.scrollTop = 0;
        this.$unit = $(this.SELECTOR_UNIT, this.$el)

        if (!device.mobile() && !device.tablet()) {
            this.setOptions()
            this.setControlForDesktop()
            this.setDesktopEvents()
        } else {
            this.setControlForMobileDevice()
            this.setMobileDeviceEvents()
        }

        this.setReadOnlyIfNecessary()
    },

    switchUnits: function (currentUnit, newUnit) {
        var hiddenSelect = $('select.hide', this.$el)

        if (hiddenSelect.length > 0) {
            $('select', this.$el).toggleClass('hide')
            var selectedIndex = this.$select.prop('selectedIndex')
            this.$select = $(this.SELECTOR_SELECT, this.$el)
            this.setOptions();

            this.$unit.text(newUnit)
            this.$unit.attr('data-alternative-unit', currentUnit)

            this.resetSelectedOptions()
            var selectedOption = $(this.SELECTOR_CUSTOM_OPTIONS, this.$el).eq(selectedIndex)
            this.setSelectedOption(selectedOption)
            this.setInputBySelectedOption(selectedOption)

            this.setDesktopEvents()

            var $units = $('.material-units');
            if ($units.is(':visible')) {
                $('.underline', $units).removeClass('underline');
                $('span:contains(' + newUnit + ')', $units).addClass('underline');
            }
        }
    },

    setOptions: function() {
        this.$content.html('')

        var $options = $(this.SELECTOR_OPTIONS, this.$el)
        this.options = $options;
        var $selectedOption = $('option:selected', this.$el)

        if (!$options.length)
            return;

        var options = '';

        for (var i = 0, c = $options.length; i < c; i++) {
            var $option = $options.eq(i)     
            var hide = $selectedOption.val() === "10" && $option.val() === "5"     
            options += this.createOptionHtml(
                $option.val(),
                $option.text(),
                $selectedOption.val(),
                hide
            )
        }

        this.$content.html(options)
    },

    setControlForDesktop: function() {
        var $selected = $(this.SELECTOR_OPTIONS + ':selected', this.$el);

        if ($selected.length && $selected.length === 1)
            this.setInputBySelectedOption($selected);
    },

    setControlForMobileDevice: function() {
        this.$content.hide();
        this.$select.addClass('for-mobile-devices');
    },

    setReadOnlyIfNecessary: function() {
        var $options = $('option', this.$select);

        if ($options.length > 2) {
            return;
        }

        var $defaultOption = $('option[value=0]', this.$select);
        if ($defaultOption.length === 0 && $options.length === 2) {
            return;
        }

        var $option;
        if ($options.length === 1) {
            $option = $options;
        } else {
            $option = $('option:not([value=0])', this.$select);
        }

        this.$el.addClass(this.CLASS_READ_ONLY);
        this.setByValue($option.val());
        this.destroyEvents();
    },

    /* CREATE HTML */
    createOptionHtml: function(value, text, selectedOption, hide) {
        if (hide) {
            var $option = $('<div>')
            .addClass(selectedOption === value ? this.CLASS_SELECTED : '')
            .html(text)
            .attr('title', text)
            .attr('data-val', value)
            .css('display', 'none');

            return $option[0].outerHTML;

        } else {
            var $option = $('<div>')
            .addClass(selectedOption === value ? this.CLASS_SELECTED : '')
            .html(text)
            .attr('title', text)
            .attr('data-val', value);

        return $option[0].outerHTML;

        }        
    },

    /* UPDATE HTML */
    resetSelectedOptions: function() {
        $(this.SELECTOR_CUSTOM_OPTIONS, this.$el).removeClass(this.CLASS_SELECTED);
    },

    setSelectedOption: function($option) {
        $option.addClass(this.CLASS_SELECTED);

        var value = $option.data('val');
        this.$select
            .find('option')
            .filter(function() {
                return $(this).val() == value;
            })
            .prop('selected', true);
    },

    toggleContent: function(show) {
        if (show)
            this.$content.addClass('show');
        else
            this.$content.removeClass('show');
    },

    setInputBySelectedOption: function($option) {
        if (!$option || !$option.length)
            return;

        this.$input.val($option.text()).data('val', $option.val());
    },

    setByValue: function(value) {
        var $contentOption = $(this.SELECTOR_CUSTOM_OPTIONS + '[data-val=' + value + ']', this.$el).first();
        var $selectOption = $(this.SELECTOR_OPTIONS + '[value=' + value + ']', this.$el).first();

        this.resetSelectedOptions();
        this.setInputBySelectedOption($selectOption);
        this.setSelectedOption($contentOption);
    },

    closeOtherDropdowns: function() {
        $(Dropdown.SELECTOR_CONTENT)
            .not(this.$content)
            .removeClass('show');
    },

    closeAllDropdowns: function() {
        $(Dropdown.SELECTOR_CONTENT, $(Dropdown.SELECTOR_GROUP)).removeClass('show');
    },

    /* DATA */
    setScrollTop: function() {
        this.scrollTop = this.$content[0].scrollTop;
    },

    /* EVENTS */
    optionClicked: function(evt) {
        var $option = $(evt.currentTarget);

        this.resetSelectedOptions();
        this.setSelectedOption($option);
        this.setInputBySelectedOption($option);
        this.setScrollTop();
        this.toggleContent();
        this.$select.change();

        if (this.options && this.options.changeCallback) {
            var $selectoption = $(
                'select option:contains(' + $option.text() + ')',
                this.$el
            );
            this.options.changeCallback($selectoption);
        }
    },

    inputClicked: function(evt) {
        evt.stopPropagation();

        if (this.$el.hasClass(this.CLASS_READ_ONLY)) {
            return;
        }

        var show = !this.$content.hasClass('show');

        this.closeOtherDropdowns();
        this.toggleContent(show);
        this.$content[0].scrollTop = this.scrollTop;
    },

    selectChanged: function() {
        var $selected = $(this.SELECTOR_OPTIONS + ':selected', this.$el);
        this.setInputBySelectedOption($selected);

        if (this.options && this.options.changeCallback) {
            this.options.changeCallback($selected);
        }
    },

    setDesktopEvents: function() {
        this.optionClickedHandler = this.optionClicked.bind(this);
        this.inputClickedHandler = this.inputClicked.bind(this);

        $(this.SELECTOR_CUSTOM_OPTIONS, this.$el).bind(
            'click',
            this.optionClickedHandler
        );
        this.$input
            .unbind('click')
            .bind('click', this.inputClickedHandler);
    },

    setMobileDeviceEvents: function() {
        this.selectChangedHandler = this.selectChanged.bind(this);
        this.$select.bind('change', this.selectChangedHandler);

        var $selected = $(this.SELECTOR_OPTIONS + ':selected', this.$el);
        if ($selected.length && $selected.length === 1)
            this.setInputBySelectedOption($selected);
    },

    destroyEvents: function() {
        $(this.SELECTOR_CUSTOM_OPTIONS, this.$el).unbind(
            'click',
            this.optionClickedHandler
        );
        this.$input.unbind('click', this.inputClickedHandler);
        this.$select.unbind('change', this.selectChangedHandler);
    }
};
$(document)
    .ready(function() {
        $('.input').each(function(i, input) { new InputGroup().init($(input)); });
    });

var InputGroup = function() {}

InputGroup.CLASS_ELEMENT = 'input';
InputGroup.CLASS_FOCUS = 'focus';
InputGroup.CLASS_FAULT = 'fault';

InputGroup.SELECTOR_ELEMENT = '.' + InputGroup.CLASS_ELEMENT;
InputGroup.SELECTOR_FOCUSED = InputGroup.SELECTOR_ELEMENT + '.' + InputGroup.CLASS_FOCUS;
InputGroup.SELECTOR_INPUT = '> input';

InputGroup.blurOtherInputs = function (evt) {
    var $target = $(evt.target);
    var myInput = null;
    
    if ($target.parents(InputGroup.SELECTOR_ELEMENT).length > 0) {
        myInput = $target.parents(InputGroup.SELECTOR_ELEMENT)[0];
    } else if ($target.hasClass(InputGroup.CLASS_ELEMENT)) {
        myInput = evt.target;
    }

    var $inputs = $(InputGroup.SELECTOR_ELEMENT);
    for (var i = 0, c = $inputs.length; i < c; i++) {
        var input = $inputs.eq(i)[0];

        if (input === myInput) {
            continue;
        } else {
            if (input.InputGroup && input.InputGroup.blur) {
                input.InputGroup.blur();
            }
        }
    }
}
$(window).click(InputGroup.blurOtherInputs);

InputGroup.prototype = {
    /* INIT */
    init: function($element, options) {
        if (!$element || !$element.length)
            return;

        $element[0].InputGroup = this;

        this.$el = $element;
        this.options = options;

        this.$input = $(InputGroup.SELECTOR_INPUT, this.$el);

        if (this.$input.is(':focus')) {
            this.setInputFocused();
        }

        this.setEvents();
    },

    blur: function() {
        this.$el.removeClass(InputGroup.CLASS_FOCUS);
    },

    setInputFocused: function() {
        this.$el.addClass(InputGroup.CLASS_FOCUS);
    },

    /* EVENTS */
    inputClicked: function() {
        this.setInputFocused();
    },

    inputFocused: function (evt) {
        InputGroup.blurOtherInputs(evt);
        this.setInputFocused();
    },

    setEvents: function() {
        this.$input.click(this.inputClicked.bind(this));
        this.$input.focus(this.inputFocused.bind(this));
    }
}
$(document).ready(function () {
    new ListController().init();
});

var ListController = function () {};
ListController.CONTROL_SELECTOR = '.table .block';
ListController.prototype.init = function ($container) {
    $(ListController.CONTROL_SELECTOR, $container).each(function (i, list) {
        new List().init($(list));
    })
}

var List = (function () {
    var _ = {
        SELECTOR: {
            clickAnchor: '.material-information-anchor',
            row: 'ul',
            selectionControl: '.material-selection input'
        },
        CLASS: {
            active: 'active'
        },
        EVENTS: {
            selectionControlChanged: function (evt) {
                var $anchor = $(evt.currentTarget);
                var $row = $anchor.parents(_.SELECTOR.row);

                _.setRowActiveClass($row, $anchor);
            },

            clickAnchorClicked:function(evt){
            	var $anchor = $(evt.currentTarget);
            	var $row = $anchor.parents(_.SELECTOR.row);

            	$(_.SELECTOR.selectionControl, $row).click();
            }
        },

        setRowActiveClass: function ($row, $anchor) {
            if ($anchor.is(':checked')) {
                $row.addClass(_.CLASS.active);
            } else {
                $row.removeClass(_.CLASS.active);
            }

            if ($anchor.is(':radio')) {
                var name = $anchor.attr('name');
                var $otherAnchors = $('input[name="' + name + '"]').not($anchor);
                var $otherRows = $otherAnchors.parents(_.SELECTOR.row);

                $otherRows.removeClass(_.CLASS.active);
            }
        }
    };

    function list() {}
    list.prototype.init = function ($list) {
        if (!$list || !$list.length) {
            return;
        }

        $(_.SELECTOR.selectionControl, $list).change(_.EVENTS.selectionControlChanged);
        $(_.SELECTOR.clickAnchor, $list).click(_.EVENTS.clickAnchorClicked);
    }

    return list;
}());
$(document).ready(function() {
	new LoaderController().init();
});

var LoaderController = function() {};
LoaderController.prototype = {
	init: function($container) {
		$('.loader', $container).each(function(i, loader) { new Loader().init($(loader)); });
	}
};

var Loader = (function() {
	var _ = {
		CLASSES: {
			show:'show'
		},
		show: function() {
			this.$el.addClass(_.CLASSES.show);
		},
		hide: function() {
			this.$el.removeClass(_.CLASSES.show);
		}
	};

	function loader() {}

	loader.prototype = {
		init: function($el) {
			this.$el = $el;

			this.$el.on('custom_show', _.show.bind(this));
			this.$el.on('custom_hide', _.hide.bind(this));
		}
	};
	return loader;
}());
/// <reference path="../libraries/01-jquery-3.1.1.min.js" />
/// <reference path="../popoverinputgroup/popoverinputgroup.js" />
/// <reference path="../popovercalculator/popovercalculator.js" />
/// <reference path="../_shared/js/03-device.min.js" />
/// <reference path="../_shared/js/jquery.global.js"/>

$(document)
    .ready(function() {
        $('.numeric-input').each(function (i, numeric) { new NumericInput().init($(numeric)); });
    });

var NumericInput = function() {}

NumericInput.ATTRIBUTE_MINIMUM_VALUE = 'data-min';
NumericInput.ATTRIBUTE_MAXIMUM_VALUE = 'data-max';
NumericInput.ATTRIBUTE_STEP = 'data-step';

NumericInput.CLASS_ELEMENT = 'numeric-input';
NumericInput.CLASS_BUTTON_UP = 'up';
NumericInput.CLASS_BUTTON_DOWN = 'down';
NumericInput.CLASS_READONLY = 'read-only';
NumericInput.CLASS_FOCUS = 'focus';
NumericInput.CLASS_FAULT = 'fault';

NumericInput.SELECTOR_ELEMENT = '.' + NumericInput.CLASS_ELEMENT;
NumericInput.SELECTOR_FOCUSED = NumericInput.SELECTOR_ELEMENT + '.' + NumericInput.CLASS_FOCUS;
NumericInput.SELECTOR_BUTTON = '.numeric-input-button';
NumericInput.SELECTOR_BUTTONS = '> .numeric-input-buttons .numeric-input-button';
NumericInput.SELECTOR_INPUT = '> input';
NumericInput.SELECTOR_CALCULATOR = '.popover-calculator';
NumericInput.SELECTOR_POPOVER = '.popover-input-group';

NumericInput.SELECTOR_UNIT = '.numeric-input-unit';

NumericInput.blurOtherInputs = function (evt) {
    var $target = $(evt.target);
    var myInput = null;

    if ($target.parents(NumericInput.SELECTOR_ELEMENT).length > 0) {
        myInput = $target.parents(NumericInput.SELECTOR_ELEMENT)[0];
    } else if ($target.hasClass(NumericInput.CLASS_ELEMENT)) {
        myInput = evt.target;
    }

    var $inputs = $(NumericInput.SELECTOR_ELEMENT);
    for (var i = 0, c = $inputs.length; i < c; i++) {
        var input = $inputs.eq(i)[0];

        if (input === myInput) {
            continue;
        } else if (input.NumericInput && input.NumericInput.blur) {
            input.NumericInput.blur();
        }
    }
}
$(window).click(NumericInput.blurOtherInputs);

NumericInput.prototype = {
    /* INIT */
    init: function($element, options) {
        if (!$element || !$element.length)
            return;

        $element[0].NumericInput = this;

        this.$el = $element;
        this.options = options;
        var minimumValueAttribute = $element.attr(NumericInput.ATTRIBUTE_MINIMUM_VALUE);

        if (minimumValueAttribute) {
            this.minimumValue = $.global.parseFloat(minimumValueAttribute);
        }

        this.hasMinimumValue = typeof minimumValueAttribute !== typeof undefined && minimumValueAttribute !== false;
        var maximumValueAttribute = $element.attr(NumericInput.ATTRIBUTE_MAXIMUM_VALUE);

        if (maximumValueAttribute) {
            this.maximumValue = $.global.parseFloat(maximumValueAttribute);
        }

        this.hasMaximumValue = typeof maximumValueAttribute !== typeof undefined && maximumValueAttribute !== false;
        var stepAttribute = $element.attr(NumericInput.ATTRIBUTE_STEP);

        if (typeof stepAttribute !== typeof undefined && stepAttribute !== false) {
            this.step = $.global.parseFloat(stepAttribute);
        } else {
            this.step = 1;
        }

        this.stepIsInteger = typeof this.step === 'number' 
                                && isFinite(this.step) 
                                && Math.floor(this.step) === this.step;

        this.$input = $(NumericInput.SELECTOR_INPUT, this.$el);
        this.$buttons = $(NumericInput.SELECTOR_BUTTONS, this.$el);

        if (options && options.readonly) {
            this.setReadOnly();
        }

        if (this.hasPopover()) {
            new PopoverInputGroup().init(this.$input, $(NumericInput.SELECTOR_POPOVER, this.$el));
        }

        if ($(NumericInput.SELECTOR_CALCULATOR, this.$el).length > 0) {
            new PopoverCalculator().init(this.$input, $(NumericInput.SELECTOR_CALCULATOR, this.$el));
        }

        if (this.$input.is(':focus')) {
            this.setInputFocused();
        }

        this.$unit = $(NumericInput.SELECTOR_UNIT, this.$el);

        this.setEvents();
    },

    hasPopover:function() {
        return $(NumericInput.SELECTOR_POPOVER, this.$el).length > 0;
    },

    isLargerThanMinimumValue: function(value) {
        return (this.hasMinimumValue && value >= this.minimumValue) ||
                !this.hasMinimumValue;
    },

    isSmallerThanMaximumValue: function(value){

        return (this.hasMaximumValue && value <= this.maximumValue) ||
                !this.hasMaximumValue;
    },

    validates: function(value) {
        return this.isLargerThanMinimumValue(value) &&
               this.isSmallerThanMaximumValue(value) &&
               !isNaN(value);
    },

    blur: function() {
        this.$el.removeClass(NumericInput.CLASS_FOCUS);
    },

    setReadOnly: function() {
        this.$el.addClass(NumericInput.CLASS_READONLY);
        this.$input.attr('readonly', 'readonly');
        this.$input.attr('tabindex', '-1');
    },

    /* UPDATE HTML */
    setValue: function(extra) {
        var value = $.global.parseFloat(this.$input.val());
        value += extra;

        if (this.validates(value)) {

            // this is needed, adding 2 floats in javascript returns incorrect numbers. ex: 2.1000000000003
            // when the value is not a rounded integer we show 2 decimals
            if (!this.stepIsInteger || Math.round(value) !== value) {
                value = value.toLocaleString($.global.culture.name, { maximumFractionDigits: 2});
            }

            this.$input.val(value);
            this.$input.trigger('change');
            this.$input.parent().removeClass(NumericInput.CLASS_FAULT);
        }

        if (!this.isLargerThanMinimumValue(value)) {
            this.$input.val(this.minimumValue);
            this.$input.parent().removeClass(NumericInput.CLASS_FAULT);
        }

        if (!this.isSmallerThanMaximumValue(value)) {
            this.$input.val(this.maximumValue);
            this.$input.parent().removeClass(NumericInput.CLASS_FAULT);
        }
    },

    decrease: function() {
        this.setValue(-this.step);
    },

    increase: function() {
        this.setValue(this.step);
    },

    setInputFocused: function() {
        this.$el.addClass(NumericInput.CLASS_FOCUS);
        this.$input[0].select();

        if (this.hasPopover()) {
            var popover = $(NumericInput.SELECTOR_POPOVER, this.$el)[0];

            if (popover.PopoverInputGroup && popover.PopoverInputGroup.show) {
                popover.PopoverInputGroup.show();
            }
        }
    },

    switchUnits: function (currentUnit, newUnit) {
        if (!currentUnit || !newUnit) {
            return;
        }

        this.$unit.text(newUnit);
        this.$unit.attr('data-alternative-unit', currentUnit);

        var $units = $('.pressure-drop-units');
        $('.underline', $units).removeClass('underline');
        $('span:contains(' + newUnit + ')', $units).addClass('underline');

        $('.pressure-drop-unit').text(newUnit);
    },

    /* EVENTS */
    buttonClicked: function(evt) {
        var $button = $(evt.currentTarget);

        if ($button.hasClass(NumericInput.CLASS_BUTTON_UP)) {
            this.increase();
        } else if ($button.hasClass(NumericInput.CLASS_BUTTON_DOWN)) {
            this.decrease();
        }

        this.setInputFocused();
    },

    inputClicked: function() {
        this.setInputFocused();
    },

    inputKeyup: function() {
        var selected = document.getSelection().toString() === this.$input.val();

        var newValue = $.global.parseFloat(this.$input.val());
        if (this.stepIsInteger && newValue != '-'){
            newValue = parseInt(newValue) || '';
        }

        var startSelection = this.$input[0].selectionStart;
        var endSelection = this.$input[0].selectionEnd;

        //this.$input.val(newValue);

        this.$input[0].setSelectionRange(startSelection, endSelection);

        if (selected) {
            this.$input.select();
        }

        if (!this.validates(newValue)) {
            this.$el.addClass(NumericInput.CLASS_FAULT);
        } else {
            this.$el.removeClass(NumericInput.CLASS_FAULT);
        }
    },

    inputFocused: function (evt) {
        if (this.hasPopover()) {
            PopoverInputGroup.blurOtherPopovers(evt);
        }
        
        NumericInput.blurOtherInputs(evt);
        this.setInputFocused();
    },

    inputChanged: function(evt) {
        if (this.hasMinimumValue) {
            var value = parseInt(this.$input.val());

            if (value < this.minimumValue) {
                this.$input.val(this.minimumValue);
            }
        }
    },

    unitClicked: function (evt) {
        var currentUnit = this.$unit.text();
        var newUnit = this.$unit.attr('data-alternative-unit');

        this.switchUnits(currentUnit, newUnit);
    },

    setEvents: function() {
        this.$buttons.click(this.buttonClicked.bind(this));
        this.$input.click(this.inputClicked.bind(this));
        this.$input.keyup(this.inputKeyup.bind(this));
        this.$input.focus(this.inputFocused.bind(this));
        this.$input.change(this.inputChanged.bind(this));
        this.$unit.click(this.unitClicked.bind(this));
    }
}
$(document)
    .ready(function () {
        $(PopoverMenuGroup.SELECTOR_GROUP)
            .each(function (i, popovermenu) {
                new PopoverMenuGroup().init($(popovermenu));
            });
    });

$(window)
    .click(function () {
        new PopoverMenuGroup().hideAllPopoverMenus();
    });

var PopoverMenuGroup = function () {}

PopoverMenuGroup.SELECTOR_GROUP = '.popover-menu-group';
PopoverMenuGroup.SELECTOR_MENU = '.popover-menu';
PopoverMenuGroup.SELECTOR_ANCHOR = '.popover-menu-anchor';
PopoverMenuGroup.CLASS_SHOW = 'show';
PopoverMenuGroup.CLASS_FADE_IN = 'fade-in';
PopoverMenuGroup.prototype = {
    init: function ($el) {
        this.$el = $el;
        this.transitionspeed = 400;
        this.minimumTimeout = 1;
        this.setEvents();
    },

    getPopoverMenuElement: function () {
        return $(PopoverMenuGroup.SELECTOR_MENU, this.$el);
    },

    getPopoverAnchorElement: function () {
        return $(PopoverMenuGroup.SELECTOR_ANCHOR, this.$el);
    },

    hideAllPopoverMenus: function () {
        this.hidePopoverMenu($(PopoverMenuGroup.SELECTOR_MENU));
    },

    hideOtherPopoverMenus: function () {
        var $menu = this.getPopoverMenuElement();
        this.hidePopoverMenu($(PopoverMenuGroup.SELECTOR_MENU).not($menu));
    },

    addClassShowToMenu: function ($menu) {
        $menu.addClass(PopoverMenuGroup.CLASS_SHOW);
    },

    removeClassFadeInFromMenu: function ($menu) {
        $menu.removeClass(PopoverMenuGroup.CLASS_FADE_IN);
    },

    showPopoverMenu: function () {
        var $menu = this.getPopoverMenuElement();

        $menu.addClass(PopoverMenuGroup.CLASS_FADE_IN);
        setTimeout(this.addClassShowToMenu.bind(this, $menu), this.minimumTimeout);
    },

    hidePopoverMenu: function ($menu) {
        $menu.removeClass(PopoverMenuGroup.CLASS_SHOW);
        setTimeout(this.removeClassFadeInFromMenu.bind(this, $menu), this.transitionspeed);
    },

    /* EVENTS */
    anchorClicked: function (evt) {
        evt.stopPropagation();
        evt.preventDefault();

        this.hideOtherPopoverMenus();
        this.showPopoverMenu();
    },

    setEvents: function () {
        var $anchor = this.getPopoverAnchorElement();

        $anchor.click(this.anchorClicked.bind(this));
        this.$el.click(this.anchorClicked.bind(this));
    }
}
var Popup = function() {};

Popup.SELECTOR_POPUP = '.popup';
Popup.CLASS_SHOW = 'show';
Popup.CLASS_DISABLE_SCROLL = 'disable-scroll';

Popup.prototype = {
    show: function($popup) {
        $popup.addClass(Popup.CLASS_SHOW);
        $popup.parent().css('position', 'fixed');
        $('body').addClass(Popup.CLASS_DISABLE_SCROLL);
    },

    hide: function ($popup) {
        $popup.removeClass(Popup.CLASS_SHOW);
        $popup.parent().css('position', '');
        $('body').removeClass(Popup.CLASS_DISABLE_SCROLL);
    }
}
/// <reference path="Popup.js" />
$(document).ready(function() {
    new PopupController().init();
});

var PopupController = function() { this.init(); };

PopupController.prototype = {
    FADER_SELECTOR: '.fader',
    CANCEL_BUTTON_SELECTOR: '.cancel',
    POPUP_CONTENT_CLASS: 'content',

    init: function() {
        var that = this;
        $(this.FADER_SELECTOR).click(function(event) { that.faderClicked(event, that, this); });
        $(this.CANCEL_BUTTON_SELECTOR).click(function(event) { that.cancelButtonClicked(event, that, this) });
    },

    faderClicked: function(event, that, clickedElement) {
        var $target = $(event.target);

        if (!$target.hasClass(that.POPUP_CONTENT_CLASS)
            && $target.parents('.' + that.POPUP_CONTENT_CLASS).length === 0) {
            var $popup = $(clickedElement).parents(Popup.SELECTOR_POPUP);
            new Popup().hide($popup);
        }
    },

    cancelButtonClicked: function(event, that, clickedElement) {
        event.preventDefault();

        var $popup = $(clickedElement).parents(Popup.SELECTOR_POPUP);
        new Popup().hide($popup);
    }
}
$(document)
    .ready(function() {
        $(Progressbar.SELECTOR_GROUP)
            .each(function(i, progressbar) { new Progressbar().init($(progressbar)); });
    });

var Progressbar = function() {}

Progressbar.SELECTOR_GROUP = '.progressbar-group';
Progressbar.SELECTOR_MINIUM = '.minimum';
Progressbar.SELECTOR_MAXIMUM = '.maximum';
Progressbar.SELECTOR_PROGRESSBAR = '.progressbar-progress';

Progressbar.prototype = {
    /* INIT */
    init: function($element) {
        if (!$element || !$element.length)
            return;

        this.$el = $element;
        this.$minVal = $(Progressbar.SELECTOR_MINIUM, this.$el);
        this.$maxVal = $(Progressbar.SELECTOR_MAXIMUM, this.$el);
        this.$progressbar = $(Progressbar.SELECTOR_PROGRESSBAR, this.$el);
        
        this.setProgressbarText();
        this.setProgressbar();
    },
    
    valueToPercent: function (currentVal, maxVal) {
        var maxPercent = 100;
        var percent = maxPercent / maxVal * currentVal;

        return Math.ceil(percent);
    },
    
    removeWhiteSpacesAndLetters: function(element) {
        return element.val().replace(/[^0-9.,]+/, '');
    },

    setProgressbarText: function() {
        this.$newMinVal = this.removeWhiteSpacesAndLetters(this.$minVal);
        this.$newMaxVal = this.removeWhiteSpacesAndLetters(this.$maxVal);
    },
    
    setProgressbar: function() {
        this.$progressVal = this.valueToPercent(this.$newMinVal, this.$newMaxVal);
        
        if ( this.$progressVal > 100 ) {
            this.$progressVal = 100;
        }
        
        this.$progressbar.width(this.$progressVal + '%');
    }
}
/*! nouislider - 9.0.0 - 2016-09-29 21:44:02 */

!function(a){"function"==typeof define&&define.amd?define([],a):"object"==typeof exports?module.exports=a():window.noUiSlider=a()}(function(){"use strict";function a(a,b){var c=document.createElement("div");return j(c,b),a.appendChild(c),c}function b(a){return a.filter(function(a){return!this[a]&&(this[a]=!0)},{})}function c(a,b){return Math.round(a/b)*b}function d(a,b){var c=a.getBoundingClientRect(),d=a.ownerDocument,e=d.documentElement,f=m();return/webkit.*Chrome.*Mobile/i.test(navigator.userAgent)&&(f.x=0),b?c.top+f.y-e.clientTop:c.left+f.x-e.clientLeft}function e(a){return"number"==typeof a&&!isNaN(a)&&isFinite(a)}function f(a,b,c){c>0&&(j(a,b),setTimeout(function(){k(a,b)},c))}function g(a){return Math.max(Math.min(a,100),0)}function h(a){return Array.isArray(a)?a:[a]}function i(a){a=String(a);var b=a.split(".");return b.length>1?b[1].length:0}function j(a,b){a.classList?a.classList.add(b):a.className+=" "+b}function k(a,b){a.classList?a.classList.remove(b):a.className=a.className.replace(new RegExp("(^|\\b)"+b.split(" ").join("|")+"(\\b|$)","gi")," ")}function l(a,b){return a.classList?a.classList.contains(b):new RegExp("\\b"+b+"\\b").test(a.className)}function m(){var a=void 0!==window.pageXOffset,b="CSS1Compat"===(document.compatMode||""),c=a?window.pageXOffset:b?document.documentElement.scrollLeft:document.body.scrollLeft,d=a?window.pageYOffset:b?document.documentElement.scrollTop:document.body.scrollTop;return{x:c,y:d}}function n(){return window.navigator.pointerEnabled?{start:"pointerdown",move:"pointermove",end:"pointerup"}:window.navigator.msPointerEnabled?{start:"MSPointerDown",move:"MSPointerMove",end:"MSPointerUp"}:{start:"mousedown touchstart",move:"mousemove touchmove",end:"mouseup touchend"}}function o(a,b){return 100/(b-a)}function p(a,b){return 100*b/(a[1]-a[0])}function q(a,b){return p(a,a[0]<0?b+Math.abs(a[0]):b-a[0])}function r(a,b){return b*(a[1]-a[0])/100+a[0]}function s(a,b){for(var c=1;a>=b[c];)c+=1;return c}function t(a,b,c){if(c>=a.slice(-1)[0])return 100;var d,e,f,g,h=s(c,a);return d=a[h-1],e=a[h],f=b[h-1],g=b[h],f+q([d,e],c)/o(f,g)}function u(a,b,c){if(c>=100)return a.slice(-1)[0];var d,e,f,g,h=s(c,b);return d=a[h-1],e=a[h],f=b[h-1],g=b[h],r([d,e],(c-f)*o(f,g))}function v(a,b,d,e){if(100===e)return e;var f,g,h=s(e,a);return d?(f=a[h-1],g=a[h],e-f>(g-f)/2?g:f):b[h-1]?a[h-1]+c(e-a[h-1],b[h-1]):e}function w(a,b,c){var d;if("number"==typeof b&&(b=[b]),"[object Array]"!==Object.prototype.toString.call(b))throw new Error("noUiSlider: 'range' contains invalid value.");if(d="min"===a?0:"max"===a?100:parseFloat(a),!e(d)||!e(b[0]))throw new Error("noUiSlider: 'range' value isn't numeric.");c.xPct.push(d),c.xVal.push(b[0]),d?c.xSteps.push(!isNaN(b[1])&&b[1]):isNaN(b[1])||(c.xSteps[0]=b[1]),c.xHighestCompleteStep.push(0)}function x(a,b,c){if(!b)return!0;c.xSteps[a]=p([c.xVal[a],c.xVal[a+1]],b)/o(c.xPct[a],c.xPct[a+1]);var d=(c.xVal[a+1]-c.xVal[a])/c.xNumSteps[a],e=Math.ceil(Number(d.toFixed(3))-1),f=c.xVal[a]+c.xNumSteps[a]*e;c.xHighestCompleteStep[a]=f}function y(a,b,c,d){this.xPct=[],this.xVal=[],this.xSteps=[d||!1],this.xNumSteps=[!1],this.xHighestCompleteStep=[],this.snap=b,this.direction=c;var e,f=[];for(e in a)a.hasOwnProperty(e)&&f.push([a[e],e]);for(f.length&&"object"==typeof f[0][0]?f.sort(function(a,b){return a[0][0]-b[0][0]}):f.sort(function(a,b){return a[0]-b[0]}),e=0;e<f.length;e++)w(f[e][1],f[e][0],this);for(this.xNumSteps=this.xSteps.slice(0),e=0;e<this.xNumSteps.length;e++)x(e,this.xNumSteps[e],this)}function z(a,b){if(!e(b))throw new Error("noUiSlider: 'step' is not numeric.");a.singleStep=b}function A(a,b){if("object"!=typeof b||Array.isArray(b))throw new Error("noUiSlider: 'range' is not an object.");if(void 0===b.min||void 0===b.max)throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");if(b.min===b.max)throw new Error("noUiSlider: 'range' 'min' and 'max' cannot be equal.");a.spectrum=new y(b,a.snap,a.dir,a.singleStep)}function B(a,b){if(b=h(b),!Array.isArray(b)||!b.length)throw new Error("noUiSlider: 'start' option is incorrect.");a.handles=b.length,a.start=b}function C(a,b){if(a.snap=b,"boolean"!=typeof b)throw new Error("noUiSlider: 'snap' option must be a boolean.")}function D(a,b){if(a.animate=b,"boolean"!=typeof b)throw new Error("noUiSlider: 'animate' option must be a boolean.")}function E(a,b){if(a.animationDuration=b,"number"!=typeof b)throw new Error("noUiSlider: 'animationDuration' option must be a number.")}function F(a,b){var c,d=[!1];if(b===!0||b===!1){for(c=1;c<a.handles;c++)d.push(b);d.push(!1)}else{if(!Array.isArray(b)||!b.length||b.length!==a.handles+1)throw new Error("noUiSlider: 'connect' option doesn't match handle count.");d=b}a.connect=d}function G(a,b){switch(b){case"horizontal":a.ort=0;break;case"vertical":a.ort=1;break;default:throw new Error("noUiSlider: 'orientation' option is invalid.")}}function H(a,b){if(!e(b))throw new Error("noUiSlider: 'margin' option must be numeric.");if(0!==b&&(a.margin=a.spectrum.getMargin(b),!a.margin))throw new Error("noUiSlider: 'margin' option is only supported on linear sliders.")}function I(a,b){if(!e(b))throw new Error("noUiSlider: 'limit' option must be numeric.");if(a.limit=a.spectrum.getMargin(b),!a.limit||a.handles<2)throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.")}function J(a,b){switch(b){case"ltr":a.dir=0;break;case"rtl":a.dir=1;break;default:throw new Error("noUiSlider: 'direction' option was not recognized.")}}function K(a,b){if("string"!=typeof b)throw new Error("noUiSlider: 'behaviour' must be a string containing options.");var c=b.indexOf("tap")>=0,d=b.indexOf("drag")>=0,e=b.indexOf("fixed")>=0,f=b.indexOf("snap")>=0,g=b.indexOf("hover")>=0;if(e){if(2!==a.handles)throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");H(a,a.start[1]-a.start[0])}a.events={tap:c||f,drag:d,fixed:e,snap:f,hover:g}}function L(a,b){if(b!==!1)if(b===!0){a.tooltips=[];for(var c=0;c<a.handles;c++)a.tooltips.push(!0)}else{if(a.tooltips=h(b),a.tooltips.length!==a.handles)throw new Error("noUiSlider: must pass a formatter for all handles.");a.tooltips.forEach(function(a){if("boolean"!=typeof a&&("object"!=typeof a||"function"!=typeof a.to))throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.")})}}function M(a,b){if(a.format=b,"function"==typeof b.to&&"function"==typeof b.from)return!0;throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.")}function N(a,b){if(void 0!==b&&"string"!=typeof b&&b!==!1)throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");a.cssPrefix=b}function O(a,b){if(void 0!==b&&"object"!=typeof b)throw new Error("noUiSlider: 'cssClasses' must be an object.");if("string"==typeof a.cssPrefix){a.cssClasses={};for(var c in b)b.hasOwnProperty(c)&&(a.cssClasses[c]=a.cssPrefix+b[c])}else a.cssClasses=b}function P(a,b){if(b!==!0&&b!==!1)throw new Error("noUiSlider: 'useRequestAnimationFrame' option should be true (default) or false.");a.useRequestAnimationFrame=b}function Q(a){var b,c={margin:0,limit:0,animate:!0,animationDuration:300,format:T};b={step:{r:!1,t:z},start:{r:!0,t:B},connect:{r:!0,t:F},direction:{r:!0,t:J},snap:{r:!1,t:C},animate:{r:!1,t:D},animationDuration:{r:!1,t:E},range:{r:!0,t:A},orientation:{r:!1,t:G},margin:{r:!1,t:H},limit:{r:!1,t:I},behaviour:{r:!0,t:K},format:{r:!1,t:M},tooltips:{r:!1,t:L},cssPrefix:{r:!1,t:N},cssClasses:{r:!1,t:O},useRequestAnimationFrame:{r:!1,t:P}};var d={connect:!1,direction:"ltr",behaviour:"tap",orientation:"horizontal",cssPrefix:"noUi-",cssClasses:{target:"target",base:"base",origin:"origin",handle:"handle",horizontal:"horizontal",vertical:"vertical",background:"background",connect:"connect",ltr:"ltr",rtl:"rtl",draggable:"draggable",drag:"state-drag",tap:"state-tap",active:"active",tooltip:"tooltip",pips:"pips",pipsHorizontal:"pips-horizontal",pipsVertical:"pips-vertical",marker:"marker",markerHorizontal:"marker-horizontal",markerVertical:"marker-vertical",markerNormal:"marker-normal",markerLarge:"marker-large",markerSub:"marker-sub",value:"value",valueHorizontal:"value-horizontal",valueVertical:"value-vertical",valueNormal:"value-normal",valueLarge:"value-large",valueSub:"value-sub"},useRequestAnimationFrame:!0};Object.keys(b).forEach(function(e){if(void 0===a[e]&&void 0===d[e]){if(b[e].r)throw new Error("noUiSlider: '"+e+"' is required.");return!0}b[e].t(c,void 0===a[e]?d[e]:a[e])}),c.pips=a.pips;var e=[["left","top"],["right","bottom"]];return c.style=e[c.dir][c.ort],c.styleOposite=e[c.dir?0:1][c.ort],c}function R(c,e,i){function o(b,c){var d=a(b,e.cssClasses.origin),f=a(d,e.cssClasses.handle);return f.setAttribute("data-handle",c),d}function p(b,c){return!!c&&a(b,e.cssClasses.connect)}function q(a,b){ba=[],ca=[],ca.push(p(b,a[0]));for(var c=0;c<e.handles;c++)ba.push(o(b,c)),ha[c]=c,ca.push(p(b,a[c+1]))}function r(b){j(b,e.cssClasses.target),0===e.dir?j(b,e.cssClasses.ltr):j(b,e.cssClasses.rtl),0===e.ort?j(b,e.cssClasses.horizontal):j(b,e.cssClasses.vertical),aa=a(b,e.cssClasses.base)}function s(b,c){return!!e.tooltips[c]&&a(b.firstChild,e.cssClasses.tooltip)}function t(){var a=ba.map(s);Z("update",function(b,c,d){if(a[c]){var f=b[c];e.tooltips[c]!==!0&&(f=e.tooltips[c].to(d[c])),a[c].innerHTML=f}})}function u(a,b,c){if("range"===a||"steps"===a)return ia.xVal;if("count"===a){var d,e=100/(b-1),f=0;for(b=[];(d=f++*e)<=100;)b.push(d);a="positions"}return"positions"===a?b.map(function(a){return ia.fromStepping(c?ia.getStep(a):a)}):"values"===a?c?b.map(function(a){return ia.fromStepping(ia.getStep(ia.toStepping(a)))}):b:void 0}function v(a,c,d){function e(a,b){return(a+b).toFixed(7)/1}var f={},g=ia.xVal[0],h=ia.xVal[ia.xVal.length-1],i=!1,j=!1,k=0;return d=b(d.slice().sort(function(a,b){return a-b})),d[0]!==g&&(d.unshift(g),i=!0),d[d.length-1]!==h&&(d.push(h),j=!0),d.forEach(function(b,g){var h,l,m,n,o,p,q,r,s,t,u=b,v=d[g+1];if("steps"===c&&(h=ia.xNumSteps[g]),h||(h=v-u),u!==!1&&void 0!==v)for(h=Math.max(h,1e-7),l=u;l<=v;l=e(l,h)){for(n=ia.toStepping(l),o=n-k,r=o/a,s=Math.round(r),t=o/s,m=1;m<=s;m+=1)p=k+m*t,f[p.toFixed(5)]=["x",0];q=d.indexOf(l)>-1?1:"steps"===c?2:0,!g&&i&&(q=0),l===v&&j||(f[n.toFixed(5)]=[l,q]),k=n}}),f}function w(a,b,c){function d(a,b){var c=b===e.cssClasses.value,d=c?m:n,f=c?k:l;return b+" "+d[e.ort]+" "+f[a]}function f(a,b,c){return'class="'+d(c[1],b)+'" style="'+e.style+": "+a+'%"'}function g(a,d){d[1]=d[1]&&b?b(d[0],d[1]):d[1],i+="<div "+f(a,e.cssClasses.marker,d)+"></div>",d[1]&&(i+="<div "+f(a,e.cssClasses.value,d)+">"+c.to(d[0])+"</div>")}var h=document.createElement("div"),i="",k=[e.cssClasses.valueNormal,e.cssClasses.valueLarge,e.cssClasses.valueSub],l=[e.cssClasses.markerNormal,e.cssClasses.markerLarge,e.cssClasses.markerSub],m=[e.cssClasses.valueHorizontal,e.cssClasses.valueVertical],n=[e.cssClasses.markerHorizontal,e.cssClasses.markerVertical];return j(h,e.cssClasses.pips),j(h,0===e.ort?e.cssClasses.pipsHorizontal:e.cssClasses.pipsVertical),Object.keys(a).forEach(function(b){g(b,a[b])}),h.innerHTML=i,h}function x(a){var b=a.mode,c=a.density||1,d=a.filter||!1,e=a.values||!1,f=a.stepped||!1,g=u(b,e,f),h=v(c,b,g),i=a.format||{to:Math.round};return fa.appendChild(w(h,d,i))}function y(){var a=aa.getBoundingClientRect(),b="offset"+["Width","Height"][e.ort];return 0===e.ort?a.width||aa[b]:a.height||aa[b]}function z(a,b,c,d){var f=function(b){return!fa.hasAttribute("disabled")&&(!l(fa,e.cssClasses.tap)&&(b=A(b,d.pageOffset),!(a===ea.start&&void 0!==b.buttons&&b.buttons>1)&&((!d.hover||!b.buttons)&&(b.calcPoint=b.points[e.ort],void c(b,d)))))},g=[];return a.split(" ").forEach(function(a){b.addEventListener(a,f,!1),g.push([a,f])}),g}function A(a,b){a.preventDefault();var c,d,e=0===a.type.indexOf("touch"),f=0===a.type.indexOf("mouse"),g=0===a.type.indexOf("pointer"),h=a;if(0===a.type.indexOf("MSPointer")&&(g=!0),e){if(h.touches.length>1)return!1;c=a.changedTouches[0].pageX,d=a.changedTouches[0].pageY}return b=b||m(),(f||g)&&(c=a.clientX+b.x,d=a.clientY+b.y),h.pageOffset=b,h.points=[c,d],h.cursor=f||g,h}function B(a){var b=a-d(aa,e.ort),c=100*b/y();return e.dir?100-c:c}function C(a){var b=100,c=!1;return ba.forEach(function(d,e){if(!d.hasAttribute("disabled")){var f=Math.abs(ga[e]-a);f<b&&(c=e,b=f)}}),c}function D(a,b,c,d){var e=c.slice(),f=[!a,a],g=[a,!a];d=d.slice(),a&&d.reverse(),d.length>1?d.forEach(function(a,c){var d=M(e,a,e[a]+b,f[c],g[c]);d===!1?b=0:(b=d-e[a],e[a]=d)}):f=g=[!0];var h=!1;d.forEach(function(a,d){h=R(a,c[a]+b,f[d],g[d])||h}),h&&d.forEach(function(a){E("update",a),E("slide",a)})}function E(a,b,c){Object.keys(ka).forEach(function(d){var f=d.split(".")[0];a===f&&ka[d].forEach(function(a){a.call(da,ja.map(e.format.to),b,ja.slice(),c||!1,ga.slice())})})}function F(a,b){"mouseout"===a.type&&"HTML"===a.target.nodeName&&null===a.relatedTarget&&H(a,b)}function G(a,b){if(navigator.appVersion.indexOf("MSIE 9")===-1&&0===a.buttons&&0!==b.buttonsProperty)return H(a,b);var c=(e.dir?-1:1)*(a.calcPoint-b.startCalcPoint),d=100*c/b.baseSize;D(c>0,d,b.locations,b.handleNumbers)}function H(a,b){var c=aa.querySelector("."+e.cssClasses.active);null!==c&&k(c,e.cssClasses.active),a.cursor&&(document.body.style.cursor="",document.body.removeEventListener("selectstart",document.body.noUiListener)),document.documentElement.noUiListeners.forEach(function(a){document.documentElement.removeEventListener(a[0],a[1])}),k(fa,e.cssClasses.drag),P(),b.handleNumbers.forEach(function(a){E("set",a),E("change",a),E("end",a)})}function I(a,b){if(1===b.handleNumbers.length){var c=ba[b.handleNumbers[0]];if(c.hasAttribute("disabled"))return!1;j(c.children[0],e.cssClasses.active)}a.preventDefault(),a.stopPropagation();var d=z(ea.move,document.documentElement,G,{startCalcPoint:a.calcPoint,baseSize:y(),pageOffset:a.pageOffset,handleNumbers:b.handleNumbers,buttonsProperty:a.buttons,locations:ga.slice()}),f=z(ea.end,document.documentElement,H,{handleNumbers:b.handleNumbers}),g=z("mouseout",document.documentElement,F,{handleNumbers:b.handleNumbers});if(document.documentElement.noUiListeners=d.concat(f,g),a.cursor){document.body.style.cursor=getComputedStyle(a.target).cursor,ba.length>1&&j(fa,e.cssClasses.drag);var h=function(){return!1};document.body.noUiListener=h,document.body.addEventListener("selectstart",h,!1)}b.handleNumbers.forEach(function(a){E("start",a)})}function J(a){a.stopPropagation();var b=B(a.calcPoint),c=C(b);return c!==!1&&(e.events.snap||f(fa,e.cssClasses.tap,e.animationDuration),R(c,b,!0,!0),P(),E("slide",c,!0),E("set",c,!0),E("change",c,!0),E("update",c,!0),void(e.events.snap&&I(a,{handleNumbers:[c]})))}function K(a){var b=B(a.calcPoint),c=ia.getStep(b),d=ia.fromStepping(c);Object.keys(ka).forEach(function(a){"hover"===a.split(".")[0]&&ka[a].forEach(function(a){a.call(da,d)})})}function L(a){a.fixed||ba.forEach(function(a,b){z(ea.start,a.children[0],I,{handleNumbers:[b]})}),a.tap&&z(ea.start,aa,J,{}),a.hover&&z(ea.move,aa,K,{hover:!0}),a.drag&&ca.forEach(function(b,c){if(b!==!1&&0!==c&&c!==ca.length-1){var d=ba[c-1],f=ba[c],g=[b];j(b,e.cssClasses.draggable),a.fixed&&(g.push(d.children[0]),g.push(f.children[0])),g.forEach(function(a){z(ea.start,a,I,{handles:[d,f],handleNumbers:[c-1,c]})})}})}function M(a,b,c,d,f){return ba.length>1&&(d&&b>0&&(c=Math.max(c,a[b-1]+e.margin)),f&&b<ba.length-1&&(c=Math.min(c,a[b+1]-e.margin))),ba.length>1&&e.limit&&(d&&b>0&&(c=Math.min(c,a[b-1]+e.limit)),f&&b<ba.length-1&&(c=Math.max(c,a[b+1]-e.limit))),c=ia.getStep(c),c=g(c),c!==a[b]&&c}function N(a){return a+"%"}function O(a,b){ga[a]=b,ja[a]=ia.fromStepping(b);var c=function(){ba[a].style[e.style]=N(b),S(a),S(a+1)};window.requestAnimationFrame&&e.useRequestAnimationFrame?window.requestAnimationFrame(c):c()}function P(){ha.forEach(function(a){var b=ga[a]>50?-1:1,c=3+(ba.length+b*a);ba[a].childNodes[0].style.zIndex=c})}function R(a,b,c,d){return b=M(ga,a,b,c,d),b!==!1&&(O(a,b),!0)}function S(a){if(ca[a]){var b=0,c=100;0!==a&&(b=ga[a-1]),a!==ca.length-1&&(c=ga[a]),ca[a].style[e.style]=N(b),ca[a].style[e.styleOposite]=N(100-c)}}function T(a,b){null!==a&&a!==!1&&("number"==typeof a&&(a=String(a)),a=e.format.from(a),a===!1||isNaN(a)||R(b,ia.toStepping(a),!1,!1))}function U(a,b){var c=h(a),d=void 0===ga[0];b=void 0===b||!!b,c.forEach(T),e.animate&&!d&&f(fa,e.cssClasses.tap,e.animationDuration),ha.forEach(function(a){R(a,ga[a],!0,!1)}),P(),ha.forEach(function(a){E("update",a),null!==c[a]&&b&&E("set",a)})}function V(a){U(e.start,a)}function W(){var a=ja.map(e.format.to);return 1===a.length?a[0]:a}function X(){for(var a in e.cssClasses)e.cssClasses.hasOwnProperty(a)&&k(fa,e.cssClasses[a]);for(;fa.firstChild;)fa.removeChild(fa.firstChild);delete fa.noUiSlider}function Y(){return ga.map(function(a,b){var c=ia.getNearbySteps(a),d=ja[b],e=c.thisStep.step,f=null;e!==!1&&d+e>c.stepAfter.startValue&&(e=c.stepAfter.startValue-d),f=d>c.thisStep.startValue?c.thisStep.step:c.stepBefore.step!==!1&&d-c.stepBefore.highestStep,100===a?e=null:0===a&&(f=null);var g=ia.countStepDecimals();return null!==e&&e!==!1&&(e=Number(e.toFixed(g))),null!==f&&f!==!1&&(f=Number(f.toFixed(g))),[f,e]})}function Z(a,b){ka[a]=ka[a]||[],ka[a].push(b),"update"===a.split(".")[0]&&ba.forEach(function(a,b){E("update",b)})}function $(a){var b=a&&a.split(".")[0],c=b&&a.substring(b.length);Object.keys(ka).forEach(function(a){var d=a.split(".")[0],e=a.substring(d.length);b&&b!==d||c&&c!==e||delete ka[a]})}function _(a,b){var c=W(),d=["margin","limit","range","animate","snap","step","format"];d.forEach(function(b){void 0!==a[b]&&(i[b]=a[b])});var f=Q(i);d.forEach(function(b){void 0!==a[b]&&(e[b]=f[b])}),f.spectrum.direction=ia.direction,ia=f.spectrum,e.margin=f.margin,e.limit=f.limit,ga=[],U(a.start||c,b)}var aa,ba,ca,da,ea=n(),fa=c,ga=[],ha=[],ia=e.spectrum,ja=[],ka={};if(fa.noUiSlider)throw new Error("Slider was already initialized.");return r(fa),q(e.connect,aa),da={destroy:X,steps:Y,on:Z,off:$,get:W,set:U,reset:V,__moveHandles:function(a,b,c){D(a,b,ga,c)},options:i,updateOptions:_,target:fa,pips:x},L(e.events),U(e.start),e.pips&&x(e.pips),e.tooltips&&t(),da}function S(a,b){if(!a.nodeName)throw new Error("noUiSlider.create requires a single element.");var c=Q(b,a),d=R(a,c,b);return a.noUiSlider=d,d}y.prototype.getMargin=function(a){var b=this.xNumSteps[0];if(b&&a%b)throw new Error("noUiSlider: 'limit' and 'margin' must be divisible by step.");return 2===this.xPct.length&&p(this.xVal,a)},y.prototype.toStepping=function(a){return a=t(this.xVal,this.xPct,a)},y.prototype.fromStepping=function(a){return u(this.xVal,this.xPct,a)},y.prototype.getStep=function(a){return a=v(this.xPct,this.xSteps,this.snap,a)},y.prototype.getNearbySteps=function(a){var b=s(a,this.xPct);return{stepBefore:{startValue:this.xVal[b-2],step:this.xNumSteps[b-2],highestStep:this.xHighestCompleteStep[b-2]},thisStep:{startValue:this.xVal[b-1],step:this.xNumSteps[b-1],highestStep:this.xHighestCompleteStep[b-1]},stepAfter:{startValue:this.xVal[b-0],step:this.xNumSteps[b-0],highestStep:this.xHighestCompleteStep[b-0]}}},y.prototype.countStepDecimals=function(){var a=this.xNumSteps.map(i);return Math.max.apply(null,a)},y.prototype.convert=function(a){return this.getStep(this.toStepping(a))};var T={to:function(a){return void 0!==a&&a.toFixed(2)},from:Number};return{create:S}});
/// <reference path="../libraries/jquery-3.1.1.min.js" />
/// <reference path="../libraries/nouislider.min.js" />

/* OPTIONS EXPLANATION
 * format: the text of the pips will be changed to the return of the function
 * behaviour: 'tap': make the closest sliderhandle handle when the slider gets tapped
 * connect: [true, false]: can be used to control the bar between the handles, or the edges of the slider. 
                            Pass an array with a boolean for every connecting element, including the edges of the slider. 
                            Pass true to set the bars between the handles, but not between the handles and the sliders edges.
 * start: [0]: sets the number of handles and corresponding start positions, relative to range,
 * step: 5: to make the handles jump between intervals
 * range: min, max, and possible other percentages
 * snap: force the slider to jump between the specified values
 * orientation: set the slider to 'vertical' or 'horizontal'
 */

/* PIP OPTIONS EXPLANATION
 * mode: 'values': pips are generated at value-based positions on the slider
 * stepped: true: the pips will be matched to the slider steps
 * values: specific pip values
 */

var Slider = function ($element, suffix, slideroptions, valueoptions) {
    if (!$element || !$element.length)
        return;

    this.$el = $element;
    this.el = $element[0];
    this.valuesuffix = suffix;
    this.init(slideroptions, valueoptions);
}

Slider.prototype = {
    /* INIT */
    SELECTOR_VALUE: '.noUi-value',
    SELECTOR_HANDLE: '.noUi-handle',
    SELECTOR_CONNECT: '.noUi-connect',
    CLASS_CURRENT: 'active',
    SELECTOR_MSG: '.lwt-message',
    SELECTOR_DROPDOWN_CONTENT: '.dropdown-content',
    SELECTOR_DROPDOWN_INPUT: '.dropdown input',
    SELECTOR_DROPDOWN: '.dropdown',

    init: function (slideroptions, valueoptions) {
        this.setOptions(slideroptions, valueoptions);
        this.createNoUiSlider();
        this.resetWidthLastValue();
        this.setLabel();
        this.setEvents();
        this.values = slideroptions.start;
    },

    createNoUiSlider: function () {
        noUiSlider.create(this.el, this.options);
    },

    reset: function () {
        this.el.noUiSlider.reset();
    },

    resetWidthLastValue: function () {
        var $last = $(this.SELECTOR_VALUE, this.$el).last();
        var left = $last.css('left');
        $last.css('left', '').addClass('active').width(Math.ceil($last.width())).css('left', left).removeClass('active');
    },

    setOptions: function (slideroptions, valueoptions) {
        var pips = null;
        if (valueoptions) {
            pips = $.extend({
                mode: 'values',
                stepped: true
            }, valueoptions);

            if (this.valuesuffix) {
                var self = this;
                pips.format = {
                    'to': function (value) {
                        return value.toFixed(0) + self.valuesuffix;
                    },
                    'from': Number
                }
            }
        }

        this.options = $.extend({
            behaviour: 'tap',
            connect: [true, false],
            pips: pips
        }, slideroptions);
    },

    setLabel: function (value) {
        var options = this.el.noUiSlider.options;
        var pips = options && options.pips && options.pips.values;
        var $label = null;

        if(options.tooltips)
            return;

        if (!pips)
            return;

        if (!value && value !== 0)
            value = options.start;

        for (var i = 0, c = pips.length; i < c; i++) {
            if (pips[i] !== value)
                continue;

            $label = $('.noUi-value', this.$el).eq(i);
            break;
        }

        if (!$label || !$label.length)
            return;

        $label.addClass(this.CLASS_CURRENT);
    },

    setHandleColours: function () {
        var colours = this.el.noUiSlider.options.colours;

        if (!colours)
            return;

        for (var i = 0, c = colours.length; i < c; i++) {
            var $handle = $(this.SELECTOR_HANDLE + ':eq(' + i + ')', this.$el);

            if (!$handle || !$handle.length)
                return;

            $handle.addClass(colours[i]);
        }
    },

    setHandleConnectColour: function () {
        var options = this.el.noUiSlider.options;
        var colours = options.colours;
        var connect = options.connect;

        if (!colours || connect !== true)
            return;

        $(this.SELECTOR_CONNECT, this.$el).addClass(colours[0]);
    },

    setMaxLock: function (slider, margin, myHandleIndex, handleIndex) {
        this.maxLockSlider = slider;
        this.maxLockSliderMargin = margin || 0;
        this.maxLockSliderHandleIndex = handleIndex || 0;
        this.maxLockMyHandleIndex = myHandleIndex || 0;
    },

    setMinLock: function (slider, margin, myHandleIndex, handleIndex) {
        this.minLockSlider = slider;
        this.minLockSliderMargin = margin || 0;
        this.minLockSliderHandleIndex = handleIndex || 0;
        this.minLockMyHandleIndex = myHandleIndex || 0;
    },

    /* GETTERS */
    getValues: function () {
        return this.values;
    },

    getOptions: function () {
        return this.el && this.el.noUiSlider && this.el.noUiSlider.options;
    },

    getMaxValueByMaxLock: function () {
        return this.maxLockSlider.getValues()[this.maxLockSliderHandleIndex] - this.maxLockSliderMargin;
    },

    getMinValueByMinLock: function () {
        return this.minLockSlider.getValues()[this.minLockSliderHandleIndex] + this.minLockSliderMargin;
    },

    getNoUiSlider: function () {
        return this.el.noUiSlider;
    },

    getSettingName: function () {
        return this.$el.data('setting');
    },

    /* SETTERS */
    updateOptions: function (options) {
        if (!this.el || !this.el.noUiSlider)
            return;

        this.el.noUiSlider.updateOptions(options);
    },

    setByUnencoded:function(unencoded) {
        this.el.noUiSlider.set(unencoded);
    },

    /* UPDATE HTML */
    updateCurrentLabel: function (unencoded) {
        $(this.SELECTOR_VALUE, this.$el).removeClass(this.CLASS_CURRENT);

        for (var i = 0, c = unencoded.length; i < c; i++) {
            this.setLabel(unencoded[i]);
        }
    },

    /* VALIDATE */
    validateValuesWithMaxLockSlider: function (value) {
        var lockvalue = this.getMaxValueByMaxLock();

        if (value < lockvalue)
            return true;

        return false;
    },

    validateValuesWithMinLockSlider: function (value) {
        if (value > this.getMinValueByMinLock())
            return true;

        return false;
    },

    /* EVENTS */
    valueClicked: function (evt) {
        var $value = $(evt.currentTarget);

        this.el.noUiSlider.set($value.text().replace(this.valuesuffix, ''));
        $(this.SELECTOR_VALUE, this.$el).removeClass(this.CLASS_CURRENT);
        $value.addClass(this.CLASS_CURRENT);
    },

    onSlide: function (values, handle, unencoded, tap, positions) {
        var selectedDiv = $(this.SELECTOR_MSG, this.$msg);
        var dropdownInput = $(this.SELECTOR_DROPDOWN_INPUT, this.$dropdownInput)
        var dropdown = $(this.SELECTOR_DROPDOWN)[0]
        console.log(selectedDiv);
        console.log($(this.SELECTOR_DROPDOWN))

        $(this.SELECTOR_DROPDOWN)[0].Dropdown.resetSelectedOptions()
        
        if (parseInt(values[1], 10) < 55) {
            selectedDiv.css('visibility', 'hidden');
            dropdownInput.val(5)
            dropdown.Dropdown.setSelectedOption($('.dropdown-content [data-val="5"]'))
            $('.dropdown-content [data-val="5"]').show();
            dropdownInput.prop('disabled', false);
            dropdownInput.css('color', '#455a68');
        }     
        else {
            selectedDiv.css('visibility', 'visible');
            dropdownInput.val(10)
            $('.dropdown-content [data-val="5"]').hide();
            dropdownInput.prop('disabled', true);
            dropdownInput.css('color', '#c1c4c8');
        }  


        if (this.maxLockSlider && handle === this.maxLockMyHandleIndex && !this.validateValuesWithMaxLockSlider(unencoded[handle])) {
            this.values[handle] = this.getMaxValueByMaxLock();
            this.el.noUiSlider.set(this.values);
            return;
        }

        if (this.minLockSlider && handle === this.minLockMyHandleIndex && !this.validateValuesWithMinLockSlider(unencoded[handle])) {
            this.values[handle] = this.getMinValueByMinLock();
            this.el.noUiSlider.set(this.values);
            return;
        }

        this.values = unencoded;
        this.updateCurrentLabel(unencoded);
    },

    onSet: function (values, handle, unencoded, tap, positions) {
        this.values = unencoded;
    },

    setEvents: function () {
        if (this.$el.hasClass('read-only')) {
            this.el.setAttribute('disabled', true);
        } else {
            $(this.SELECTOR_VALUE, this.$el).click(this.valueClicked.bind(this));
            this.el.noUiSlider.on('slide', this.onSlide.bind(this));
            this.el.noUiSlider.on('set', this.onSet.bind(this));
        }
    }
}

$(document).ready(function() {
    new SliderGroupController().init();
});

var SliderGroupController = (function() {
    var _ = {
        SELECTOR: {
            sliderGroup: '.slider-group',
            slider: '.slider',
            minValue: '.min-value',
            maxValue: '.max-value',
            stepValue: '.step-value',
            currentValue: '.current-value',
            pipValues: '.pips-values option',
            minTranslation: '.translation-min-value',
            maxTranslation: '.translation-max-value',
            currentTranslation: '.translation-current-value',
            tooltips: '.noUi-tooltip',
            handles: '.noUi-origin'
        },
        initSlider: function($element) {
            var $slider = $(_.SELECTOR.slider, $element);
            var minimum = parseInt($(_.SELECTOR.minValue, $element).val());
            var maximum = parseInt($(_.SELECTOR.maxValue, $element).val());
            var current = parseInt($(_.SELECTOR.currentValue, $element).val());

            var stepValue = $(_.SELECTOR.stepValue, $element).val();
            var $pipValues = $(_.SELECTOR.pipValues, $element);

            var minimumTranslation = $(_.SELECTOR.minTranslation).val();
            var maximumTranslation = $(_.SELECTOR.maxTranslation).val();
            var currentTranslation = $(_.SELECTOR.currentTranslation).val();

            var slider = new Slider($slider, null, {
                start: [minimum, current, maximum],
                connect: [true, true, true, true],
                range: {
                    min: minimum,
                    max: maximum
                },
                tooltips: true,
                format: {
                    to: function(value) {
                        return value.toFixed(0) + ' °C';
                    },
                    from: function(value) {
                        return value.replace(' °C', '');
                    }
                }
            });

            var $tooltips = $(_.SELECTOR.tooltips, $slider);
            $tooltips
                .eq(0)
                .attr('data-translation', minimumTranslation)
                .addClass('align-left');
            $tooltips.eq(1).attr('data-translation', currentTranslation);
            $tooltips
                .eq(2)
                .attr('data-translation', maximumTranslation)
                .addClass('align-right');

            var $handles = $(_.SELECTOR.handles, $slider);
            $handles.eq(0).attr('disabled', true);
            $handles.eq(2).attr('disabled', true);

            if (stepValue) {
                $slider[0].noUiSlider.updateOptions(
                    {
                        step: parseInt(stepValue)
                    },
                    true
                );
            } else if (!!$pipValues.length) {
                var pipValues = $.map($pipValues, function(pipValue, index) {
                    return parseInt($(pipValue).val());
                });
                var min = Math.min.apply(null, pipValues);
                var max = Math.max.apply(null, pipValues);
                var range = {};
                for (var i = 0; i < pipValues.length; i++) {
                    var pipValue = pipValues[i];
                    var key = '';
                    if (pipValue === min) {
                        key = 'min';
                    } else if (pipValue === max) {
                        key = 'max';
                    } else {
                        key = ((pipValue - min) * 100) / (max - min) + '%';
                    }

                    range[key] = [pipValue, pipValue, pipValue];
                }

                $slider[0].noUiSlider.updateOptions({
                    range: range,
                    pips: {
                        mode: 'values',
                        values: pipValues,
                        stepped: true
                    }
                });
            }
        }
    };

    function sliderGroupController() {}

    sliderGroupController.prototype = {
        init: function() {
            $(_.SELECTOR.sliderGroup).each(function(i, sliderGroup) {
                _.initSlider($(sliderGroup));
            });
        }
    };
    return sliderGroupController;
})();

$(document).ready(function () {
    new SoundPressureController().init();
});

var SoundPressureController = function () {}
SoundPressureController.prototype = {
    init: function ($container) {
        $('.sound-pressure-group', $container).each(function (i, soundPressure) {
            new SoundPressure().init($(soundPressure));
        })
    }
};

var SoundPressure = (function () {
    var _ = {
        SELECTOR: {
            stopPoint: '.sound-pressure-stop-points',
            gradient: '.sound-gradient',
            background: '.sound-background',
            maximum: '.sound-pressure-maximum',
            label: '.sound-pressure span'
        },
        ATTRIBUTE: {
            width: 'width',
            x: 'x'
        },
        CLASS: {
            warningTrigger: 'sound-pressure-warning-trigger',
            warning: 'warning'
        },
        getSelectedStopPoint: function ($el) {
            var $stopPoint = $(_.SELECTOR.stopPoint, $el).find(':selected');

            return parseInt($stopPoint.text());
        },
        setToStopPoint: function ($el) {
            var stopPoint = _.getSelectedStopPoint($el);
            var maximum = parseInt($(_.SELECTOR.maximum, $el).val());
            var initialWidth = $(_.SELECTOR.gradient, $el).width();
            var $background = $(_.SELECTOR.background, $el);
            var $label = $(_.SELECTOR.label, $el);

            var width = initialWidth / maximum * (maximum - stopPoint);
            var left = initialWidth - width;

            if (isNaN(width) || isNaN(left)) {
                return;
            }

            $label.text(stopPoint);
            $background
                .attr(_.ATTRIBUTE.width, width)
                .attr(_.ATTRIBUTE.x, left);
        },

        showOrHideWarning: function ($el) {
            if ($(_.SELECTOR.stopPoint, $el).find(':selected').hasClass(_.CLASS.warningTrigger)) {
                $el.addClass(_.CLASS.warning);
            } else {
                $el.removeClass(_.CLASS.warning);
            }
        }
    };

    function soundPressure() {}
    soundPressure.prototype = {
        init: function ($el) {
            if (!$el || !$el.length) {
                return;
            }

            this.$el = $el;
            $el[0].SoundPressure = this;

            _.setToStopPoint($el);
        },
        setByTrigger: function (trigger) {
            $(_.SELECTOR.stopPoint, this.$el).val(trigger);
            _.setToStopPoint(this.$el);
            _.showOrHideWarning(this.$el);
        }
    };
    return soundPressure;
})();
$(document).ready(function () {
    new TabGroupController().init();
});

var TabGroupController = (function () {
    var _ = {
        SELECTOR: {
            tabGroup: '.tab-group'
        }
    };

    function tabGroupController() {}
    tabGroupController.prototype = {
        init: function ($container) {
            $(_.SELECTOR.tabGroup, $container).each(function (i, tabgroup) {
                new TabGroup($(tabgroup)).init();
            });
        }
    };

    return tabGroupController;
}());

var TabGroup = function ($el) {
    this.$el = $el;
};

TabGroup.SELECTOR_TAB = '.tab';
TabGroup.SELECTOR_TAB_CONTENT = '.tab-content';
TabGroup.CLASS_ACTIVE = 'active';
TabGroup.CLASS_SHOW = 'show';
TabGroup.prototype = {
    init: function () {
        this.setEvents();
    },

    /*  UPDATE HTML */
    /*______________*/
    setAllTabsToNotActive: function () {
        $(TabGroup.SELECTOR_TAB, this.$el).removeClass(TabGroup.CLASS_ACTIVE);
        this.$el.nextAll(TabGroup.SELECTOR_TAB_CONTENT).removeClass(TabGroup.CLASS_SHOW);
    },

    setTabToActive: function ($tab) {
        $tab.addClass(TabGroup.CLASS_ACTIVE);
        this.$el.nextAll($tab.attr('href') + TabGroup.SELECTOR_TAB_CONTENT).first().addClass(TabGroup.CLASS_SHOW);
    },

    /*  EVENTS  */
    /*__________*/
    tabClicked: function (evt) {
        evt.preventDefault();

        var $tab = $(evt.currentTarget);
        this.setAllTabsToNotActive();
        this.setTabToActive($tab);
    },

    setEvents: function () {
        $(TabGroup.SELECTOR_TAB, this.$el).click(this.tabClicked.bind(this));
    }
}
/// <reference path="../../../Controls/_shared/js/03-device.min.js" />
$(document).ready(function() {
    new HeaderAnimator().init();
});

var HeaderAnimator = function () { };

HeaderAnimator.prototype = {
    init: function () {
        this.initVariables();
        this.setEvents();
    },

    initVariables: function () {
        this.minimumScroll = 80; // Minimum scrollheight to show the header (ideally the height of the header)
        this.prevScrollTop = -1;
        this.startScrollTop = -1;
        this.direction = 0;
        this.prevDirection = 0;
    },

    /*  SETTERS */
    /*__________*/
    setDirection: function (delta) {
        //1 is down, -1 is up, 0 is no scroll

        if (delta !== 0) {
            this.direction = delta >= 0 ? 1 : -1;
        } else {
            this.direction = 0;
        }
    },

    setStartScrollTop: function (scrollTop) {
        this.startScrollTop = scrollTop;
    },

    /*  CHECKS */
    /*_________*/
    previousScrollTopHasInitValue: function () {
        return this.prevScrollTop === -1;
    },

    /*  CALCULATIONS */
    /*_______________*/
    determineScrollTop: function () {
        var scrollTop = $(window).scrollTop();

        //For iOS and other OS with bump animations on top, show the search box when you arrive at the top of the page
        if (scrollTop < this.minimumScroll) {
            scrollTop = 0;
        }

        return scrollTop;
    },

    determineDelta: function (scrollTop) {
        return scrollTop - this.prevScrollTop;
    },

    /*  EVENTS  */
    /*__________*/
    documentScrolled: function () {
        var scrollTop = this.determineScrollTop();

        if (this.previousScrollTopHasInitValue()) {
            this.setStartScrollTop(scrollTop);
        } else {
            var delta = this.determineDelta(scrollTop);
            this.setDirection(delta);
        }

        //If the direction is different and up or down, reset the startscroll
        if (this.direction !== this.prevDirection) {
            if (this.prevDirection !== 0) {
                this.setStartScrollTop(scrollTop);
            }

            this.prevDirection = this.direction;
        }

        //See how much has been scrolled and in what direction to show or hide the search box
        var scrollDelta = Math.abs(scrollTop - this.startScrollTop);
        var $body = $('body');
        if (scrollDelta > 0 && this.direction === 1) {
            $body.addClass('hideheader');
        } else if (scrollDelta > this.minimumScroll && this.direction === -1) {
            $body.removeClass('hideheader');
        }

        this.prevScrollTop = scrollTop;
    },

    iosDocumentScrolled: function () {
        var scrollTop = $(window).scrollTop();
        this.prevScrollTop = scrollTop;
        this.startScrollTop = scrollTop;
        this.direction = 0;
        this.prevDirection = 0;
    },

    setEvents: function () {
        var $document = $(document);

        $document.on('scroll', this.documentScrolled.bind(this));

        if (device.ios() && window.navigator.standalone) {
            $document.on('touchstart', this.documentScrolled.bind(this));
            $document.on('touchend', this.documentScrolled.bind(this));
            $document.on('scroll', this.iosDocumentScrolled.bind(this), 250);
        }
    }
}
$(document).ready(function () {
  new ReturnToHsnController().init();
});

var ReturnToHsnController = function () { };

ReturnToHsnController.redirectToHsn = function () {
  window.location = $('#hsn-url').val();
};

ReturnToHsnController.prototype = {
  init: function () {
    $(".return-to-hsn").click(this.returnToHsnClicked.bind(this));
    $("input[name=returntohsn-group]").change(
      this.returnToHsnRadioButtonChanged.bind(this)
    );
    $('#save-project').on('click', this.saveProjectButtonClicked.bind(this));
  },

  returnToHsnRadioButtonChanged: function (event) {
    var value = $('input[name=returntohsn-group]:checked').val();

    if (value === '1') {
      this.saveProject();
    } else {
      ReturnToHsnController.redirectToHsn();
    }
  },

  returnToHsnClicked: function (event) {
    event.preventDefault();
    new Popup().show($(".popup.return-to-hsn-popup"));
  },

  saveProjectButtonClicked: function (event) {
    event.preventDefault();
    this.saveProject();
  },

  saveProject: function () {
    new Popup().hide($('.popup.return-to-hsn-popup'));
    new Popup().show($('.popup.load-hsn-popup'));

    AjaxCall.send("/HSN/saveproject", {}, function (response, errorHappened) {
      if (errorHappened === true) {
        $('input[name=returntohsn-group]').prop('checked', false);
      } else {
        ReturnToHsnController.redirectToHsn();
      }
    });
  }
};

/// <reference path="../../../Controls/_shared/js/03-device.min.js" />
$(document).ready(function() {
  new RoomHeaderAnimator().init();
});

var RoomHeaderAnimator = function() {};
RoomHeaderAnimator.prototype = {
  init: function() {
    this.initVariables();
    this.setEvents();
  },
  initVariables: function() {
    this.minimumScroll = 20; // Minimum scrollheight to show the header (ideally the height of the header) --> changed this so the scroll is the same as when the room header sticks to the subheader
    this.prevScrollTop = -1;
    this.startScrollTop = -1;
    this.direction = 0;
    this.prevDirection = 0;
  },
  /*  SETTERS */
  /*__________*/
  setDirection: function(delta) {
    //1 is down, -1 is up, 0 is no scroll
    if (delta !== 0) {
      this.direction = delta >= 0 ? 1 : -1;
    } else {
      this.direction = 0;
    }
  },
  setStartScrollTop: function(scrollTop) {
    this.startScrollTop = scrollTop;
  },
  /*  CHECKS */
  /*_________*/
  previousScrollTopHasInitValue: function() {
    return this.prevScrollTop === -1;
  },
  /*  CALCULATIONS */
  /*_______________*/
  determineScrollTop: function() {
    var scrollTop = $(window).scrollTop();
    //For iOS and other OS with bump animations on top, show the search box when you arrive at the top of the page
    if (scrollTop < this.minimumScroll) {
      scrollTop = 0;
    }
    return scrollTop;
  },
  determineDelta: function(scrollTop) {
    return scrollTop - this.prevScrollTop;
  },
  /*  EVENTS  */
  /*__________*/
  documentScrolled: function() {
    var scrollTop = this.determineScrollTop();
    if (this.previousScrollTopHasInitValue()) {
      this.setStartScrollTop(scrollTop);
    } else {
      var delta = this.determineDelta(scrollTop);
      this.setDirection(delta);
    }
    //If the direction is different and up or down, reset the startscroll
    if (this.direction !== this.prevDirection) {
      if (this.prevDirection !== 0) {
        this.setStartScrollTop(scrollTop);
      }
      this.prevDirection = this.direction;
    }
    //See how much has been scrolled and in what direction to show or hide the search box
    var scrollDelta = Math.abs(scrollTop - this.startScrollTop);
    var $body = $("body");
    if (scrollDelta > 20 && this.direction === 1) {
      $body.addClass("hideroomheader");
    } else if (scrollTop <= this.minimumScroll && this.direction === -1) {
      $body.removeClass("hideroomheader");
    }
    this.prevScrollTop = scrollTop;
  },
  iosDocumentScrolled: function() {
    var scrollTop = $(window).scrollTop();
    this.prevScrollTop = scrollTop;
    this.startScrollTop = scrollTop;
    this.direction = 0;
    this.prevDirection = 0;
  },
  setEvents: function() {
    var $document = $(document);
    $document.on("scroll", this.documentScrolled.bind(this));
    if (device.ios() && window.navigator.standalone) {
      $document.on("touchstart", this.documentScrolled.bind(this));
      $document.on("touchend", this.documentScrolled.bind(this));
      $document.on("scroll", this.iosDocumentScrolled.bind(this), 250);
    }
  }
};

// This part is used to fix a bug with onbeforeunload. This is needed for Safari on Mac. Safari has a feature which caches the page aggressively.
// Alas Safari also has a bug that it does not take AJAX updates into account. Which resulted
// in old data that was shown when the back button was pressed.
// The isRefresh property is set because the onbeforeunload event is called when we do a 'location.reload'
// and the old data that Safari shows would be saved and would overwrite the data of the item that should be shown.
window.onpageshow = function(event) {
  if (event.persisted) {
    window.isRefresh = true;
    window.location.reload();
  }
};

// This is needed because window.onerror is not always called so we try/catch our routes en
function wrapErrors(fn) {
  // don't wrap function more than once
  if (!fn.__wrapped__) {
    fn.__wrapped__ = function() {
      try {
        return fn.apply(this, arguments);
      } catch (e) {
        if (isProduction) {
          Sentry.captureException(e);
        } else {
          throw e; // re-throw the error
        }
      }
    };
  }

  return fn.__wrapped__;
}

function addRoute(routes, route, routeFn) {
  routes[route] = wrapErrors(routeFn);
}

$(document).ready(function() {
  if (isProduction) {
    Sentry.init({
      dsn: sentryDsn,
      release: assetVersion,
      environment: sentryEnvironment
    });
  }

  window.async = true;
  var routes = new Array();
  addRoute(routes, "/projectinfo", function() {
    new ProjectInfoController().init();
    new SaveProjectController().init();
  });

  addRoute(routes, "/zone", function() {
    new ZoneOverviewController().init();
  });

  addRoute(routes, "/room", function() {
    new FanSelectionController().init();
    new CalculateCapacityController().init();
    new UpdateOptionsController().init();
    new UpdateSpeedController().init();
    new SaveFanCoilController().init();
  });

  addRoute(routes, "/equipmentlist", function() {
    new EquipmentListController().init();
  });

  for (var route in routes) {
    if (window.location.pathname.toLowerCase().indexOf(route) > -1) {
      try {
        routes[route]();
      } catch (e) {
        console.error(e.stack);
      }
    }
  }
});

/// https://css-tricks.com/guides/form-validation/
$(document).ready(function() {
  new FormValidator().init();
});

var FormValidator = (function() {
  var _ = {
    SELECTOR_FORM: "form.validate",
    SELECTOR_FORM_EMAIL_VALIDATION: "form.validate-email",
    SELECTOR_INPUT: ".input",
    SELECTOR_NUMERIC_INPUT: ".numeric-input",
    SELECTOR_CHECKBOX: ".checkbox-group",
    SELECTOR_DROPDOWN: ".dropdown",
    SELECTOR_SUBMIT: "button[type=submit]",

    SELECTOR_ERROR: ".error",
    SELECTOR_VALUE_MISSING: ".error.value-missing",
    SELECTOR_TYPE_MISMATCH: ".error.type-mismatch",
    //SELECTOR_TOO_SHORT: '.error.too-short',
    SELECTOR_TOO_LONG: ".error.too-long",
    SELECTOR_BAD_INPUT: ".error.bad-input",
    //SELECTOR_STEP_MISMATCH: '.error.step-mismatch',
    SELECTOR_RANGE_UNDERFLOW: ".error.range-underflow",
    SELECTOR_RANGE_OVERFLOW: ".error.range-overflow",
    SELECTOR_PATTERN_MISMATCH: ".error.pattern-mismatch",
    SELECTOR_GENERAL: ".error.general",

    SELECTOR_EMAIL_VALIDATION_URL: "input[name=EmailValidationUrl]",

    CLASS_FAULT: "fault",
    CLASS_VALIDATE: "validate",

    ATTRIBUTE_DATA_LOADER_TARGET: "data-loader-target",

    hasError: function(element) {
      var $element = $(element);

      // Don't validate submits, buttons, file and reset inputs, and disabled fields
      if (
        element.disabled ||
        element.type === "file" ||
        element.type === "reset" ||
        element.type === "submit" ||
        element.type === "button"
      )
        return null;

      // If not visible, return null (do not do check this if it is a checkbox or a select)
      if (
        !$element.is(":visible") &&
        !$element.is(":checkbox") &&
        !$element.is("select")
      )
        return null;

      // Get validity
      var validity = element.validity;

      if (
        $element[0].type === "email" &&
        $element.parents(_.SELECTOR_FORM_EMAIL_VALIDATION).length &&
        !_.isEmailValid($element.val())
      ) {
        return $element.nextAll(_.SELECTOR_BAD_INPUT);
      }

      if (!validity) {
        return null;
      }

      var $numeric = $element.parents(_.SELECTOR_NUMERIC_INPUT);
      if (
        $numeric.length > 0 &&
        typeof NumericInput !== typeof undefined &&
        !!$numeric[0].NumericInput
      ) {
        var numericInput = $numeric[0].NumericInput;
        var value = $.global.parseFloat($element.val());

        if (!element.required && !$element.val()) {
          return null;
        }

        if (
          !!numericInput.isLargerThanMinimumValue &&
          !numericInput.isLargerThanMinimumValue(value)
        ) {
          return $element.nextAll(_.SELECTOR_RANGE_UNDERFLOW);
        }

        if (
          !!numericInput.isSmallerThanMaximumValue &&
          !numericInput.isSmallerThanMaximumValue(value)
        ) {
          return $element.nextAll(_.SELECTOR_RANGE_OVERFLOW);
        }
      }

      var $dropdown = $element.parents(_.SELECTOR_DROPDOWN);
      if ($dropdown.length > 0 && $element.is("select") && element.required) {
        var $selected = $element.find(":selected");

        if (!$selected.attr("value")) {
          return $element.nextAll(_.SELECTOR_VALUE_MISSING);
        }
      }

      // If valid, return null
      if (validity.valid) return null;

      // If field is required and empty
      if (validity.valueMissing)
        return $element.nextAll(_.SELECTOR_VALUE_MISSING);

      // If not the right type
      if (validity.typeMismatch)
        return $element.nextAll(_.SELECTOR_TYPE_MISMATCH);

      // If too short
      //if (validity.tooShort) return 'Please lengthen this text.';

      // If too long
      if (validity.tooLong) return $element.nextAll(_.SELECTOR_TOO_LONG);

      // If number input isn't a number
      if (validity.badInput) return $element.nextAll(_.SELECTOR_BAD_INPUT);

      // If a number value doesn't match the step interval
      //if (validity.stepMismatch) return 'Please select a valid value.';

      // If a number field is over the max
      if (validity.rangeOverflow)
        return $element.nextAll(_.SELECTOR_RANGE_OVERFLOW);

      // If a number field is below the min
      if (validity.rangeUnderflow)
        return $element.nextAll(_.SELECTOR_RANGE_UNDERFLOW);

      // If pattern doesn't match
      if (validity.patternMismatch)
        return $element.nextAll(_.SELECTOR_PATTERN_MISMATCH);

      // If all else fails, return a generic catchall error
      return $element.nextAll(_.SELECTOR_GENERAL);
    },

    showError: function($element, $error) {
      var parentSelector = [
        _.SELECTOR_INPUT,
        _.SELECTOR_NUMERIC_INPUT,
        _.SELECTOR_CHECKBOX,
        _.SELECTOR_DROPDOWN
      ].join(", ");

      $element.parents(parentSelector).addClass(_.CLASS_FAULT);
      $element.nextAll(_.SELECTOR_ERROR).hide();
      $error.show();
    },

    hideError: function($element) {
      var parentSelector = [
        _.SELECTOR_INPUT,
        _.SELECTOR_NUMERIC_INPUT,
        _.SELECTOR_CHECKBOX,
        _.SELECTOR_DROPDOWN
      ].join(", ");

      $element.parents(parentSelector).removeClass(_.CLASS_FAULT);
      $element.nextAll(_.SELECTOR_ERROR).hide();
    },

    isFormValid: function(elements) {
      var $error,
        firstElementWithError = null,
        element,
        $element;

      for (var i = 0, c = elements.length; i < c; i++) {
        element = elements[i];
        $element = $(element);
        $error = _.hasError(element);

        if ($error) {
          _.showError($element, $error);
        } else {
          _.hideError($element);
          continue;
        }

        if (!firstElementWithError) {
          firstElementWithError = element;
        }
      }

      return firstElementWithError;
    },

    isEmailValid: function(email) {
      var url = $(_.SELECTOR_EMAIL_VALIDATION_URL).val();
      if (url.indexOf("?currentuserid") > -1) {
        url += "&";
      } else {
        url += "?";
      }
      url += "email=" + email;
      var isValid = false;

      $.ajax({
        url: url,
        type: "GET",
        contentType: "application/json; charset=utf-8",
        async: false,
        timeout: 1000, // sets timeout to 1 second,
        error: function() {
          isValid = false;
        },
        success: function(data) {
          if (!data.alreadyUsed) {
            //email has not been found
            isValid = true;
          } else if (data.myEmail) {
            //found as my own email
            isValid = true;
          } else {
            isValid = false;
          }
        }
      });

      return isValid;
    },

    elementBlurred: function(evt) {
      var $element = $(evt.target);

      if (!$element.parents(_.SELECTOR_FORM).length) {
        return;
      }

      var $error = _.hasError(evt.target);

      if ($error) {
        _.showError($element, $error);
      } else {
        _.hideError($element);
      }
    },

    formSubmitted: function(evt) {
      var elements = evt.currentTarget.elements;
      var firstElementWithError = _.isFormValid(elements);

      if (firstElementWithError) {
        evt.preventDefault();
        firstElementWithError.focus();
        return false;
      }

      var $submit = $(_.SELECTOR_SUBMIT, evt.currentTarget);
      if ($submit.length) {
        $submit[0].disabled = true;
      }

      $(".loader").trigger("custom_show");

      return true;
    }
  };

  function formValidator() {}

  formValidator.prototype = {
    init: function() {
      $(_.SELECTOR_FORM)
        .attr("novalidate", true)
        .on("submit", _.formSubmitted);
      document.addEventListener("blur", _.elementBlurred, true);
      $(document).on("change", _.elementBlurred);
    },

    initForm: function($form) {
      if (!$form.hasClass(_.CLASS_VALIDATE)) {
        return;
      }

      $form.attr("novalidate", true).on("submit", _.formSubmitted);
    },

    isEditValid: function($edit) {
      if (!$edit.hasClass(_.CLASS_VALIDATE)) {
        return true;
      }

      var $elements = $(".numeric-input input, .input input", $edit);
      var elements = [];

      for (var i = 0, c = $elements.length; i < c; i++) {
        elements.push($elements.eq(i)[0]);
      }

      var firstElementWithError = _.isFormValid(elements);

      if (firstElementWithError) {
        firstElementWithError.focus();
        return false;
      }

      return true;
    }
  };
  return formValidator;
})();

/// <reference path="../popup/popup.js" />
///<reference path="../../Libraries/js/01-jquery-3.4.1.min.js"/>

$(document).ready(function () {
    new LoaderController().init();
});

var LoaderController = function () { };
LoaderController.prototype = {
    SELECTOR_ANCHOR: '[data-loader-target]:not(form):not(.save-mode-anchor)',
    SELECTOR_LOADER: '.content-loader',
    SELECTOR_POPUP_LOADER: '.loader-popup',

    ATTRIBUTE_DATA_LOADER_TARGET: 'data-loader-target',

    init: function($container) {
        var self = this;
        $(this.SELECTOR_ANCHOR, $container).each(function(i, anchor) {
            self.initLoaderFor($(anchor));
        });
    },

    initLoaderFor: function($anchor) {
        var loaderId = $anchor.attr(this.ATTRIBUTE_DATA_LOADER_TARGET);

        var $loader = $(this.SELECTOR_LOADER + '#' + loaderId);
        if (!$loader.length) {
            $loader = $(this.SELECTOR_POPUP_LOADER + '#' + loaderId);
        }

        function onAnchorClick() {
            new Loader().show($loader);
        }

        $anchor.on('click', onAnchorClick);
    },

    showLoaderFor: function($anchor) {
        var loaderId = $anchor.attr(this.ATTRIBUTE_DATA_LOADER_TARGET);

        var $loader = $(this.SELECTOR_LOADER + '#' + loaderId);
        if (!$loader.length) {
            $loader = $(this.SELECTOR_POPUP_LOADER + '#' + loaderId);
        }

        if (!$loader.length) {
            return;
        }

        new Loader().show($loader);
    },

    hideLoaderFor: function ($anchor) {
        var loaderId = $anchor.attr(this.ATTRIBUTE_DATA_LOADER_TARGET);

        var $loader = $(this.SELECTOR_LOADER + '#' + loaderId);
        if (!$loader.length) {
            $loader = $(this.SELECTOR_POPUP_LOADER + '#' + loaderId);
        }

        if (!$loader.length) {
            return;
        }

        new Loader().hide($loader);
    }
}

var Loader = (function () {
    var _ = {
        class: {
            FADE_OUT: 'fade-out',
            POPUP:'popup'
        }
    };

    function loader() {}

    loader.prototype = {
        show: function ($loader) {
            if ($loader.hasClass(_.class.POPUP) && typeof Popup != 'undefined') {
                new Popup().show($loader);
            } else {
                $loader.removeClass(_.class.FADE_OUT);
            }
        },

        hide: function($loader) {
            if ($loader.hasClass(_.class.POPUP) && typeof Popup != 'undefined') {
                new Popup().hide($loader);
            } else {
                $loader.addClass(_.class.FADE_OUT);
            }
        }
    };
    return loader;
}());
/// <reference path="Popup.js" />
var PopoverController = function () { this.init(); };

PopoverController.prototype = {
    ANCHOR_SELECTOR: '.popover-anchor',
    POPOVER_SELECTOR: '.popover',

    init: function ()
    {
        var $anchors = $(this.ANCHOR_SELECTOR);

        for (var i = 0, c = $anchors.length; i < c; i++) {
            var $popover = $anchors.eq(i).nextAll(this.POPOVER_SELECTOR).first();

            new Popover($anchors.eq(i), $popover);
        }
    }
}
var Popup = function() {};

Popup.SELECTOR_POPUP = '.popup';
Popup.CLASS_SHOW = 'show';
Popup.CLASS_DISABLE_SCROLL = 'disable-scroll';

Popup.prototype = {
    show: function($popup) {
        $popup.addClass(Popup.CLASS_SHOW);
        $popup.parent().css('position', 'fixed');
        $('body').addClass(Popup.CLASS_DISABLE_SCROLL);
    },

    hide: function ($popup) {
        $popup.removeClass(Popup.CLASS_SHOW);
        $popup.parent().css('position', '');
        $('body').removeClass(Popup.CLASS_DISABLE_SCROLL);
    }
}
$(document).ready(function() {
  new ShowHideController().init();
});

var ShowHideController = function() {};
ShowHideController.prototype.init = function($container) {
  $(".show-hide-trigger", $container).each(function(i, showHide) {
    new ShowHide().init($(showHide));
  });
};

var ShowHide = (function() {
  var _ = {
    SELECTOR: {
      SEGMENT_CONTROL: {
        input: "input[type=radio]"
      }
    },
    CLASS: {
      segmentGroup: "segment-group",
      hide: "hide"
    },
    ATTRIBUTE: {
      name: "name"
    },
    EVENT: {
      triggerChanged: function(evt) {
        var $trigger = $(evt.currentTarget);
        var triggerValue = $trigger.val();
        var triggerName = $trigger.attr(_.ATTRIBUTE.name);
        var triggerId = triggerName.replace("-group", "") + "-" + triggerValue;

        _.hideListeners(triggerName + "-listener");
        _.showListeners(triggerId);
      }
    },

    isSegmentControl: function($el) {
      return $el.hasClass(_.CLASS.segmentGroup);
    },

    showListeners: function(listenerClass) {
      $("." + listenerClass).removeClass(_.CLASS.hide);
    },

    hideListeners: function(listenerClass) {
      $("." + listenerClass).addClass(_.CLASS.hide);
    }
  };

  function showHide() {}
  showHide.prototype = {
    init: function($el) {
      if (!$el || !$el.length) {
        return;
      }

      if (_.isSegmentControl($el)) {
        this.initSegmentControl($el);
      }
    },

    initSegmentControl: function($el) {
      $(_.SELECTOR.SEGMENT_CONTROL.input, $el).change(_.EVENT.triggerChanged);
    }
  };
  return showHide;
})();

var CalculateCapacityController = (function() {
  var _ = {
    SELECTOR: {
      CALCULATE_CAPACITY: {
        segmentgroup: ".calculate-capacity.segment-group:not(.hide) input",
        url: "#source-calculate-fan-coil-capacity"
      },
      FAN_COIL: {
        element: ".fan-coil",
        capacityBars: ".capacity-bar",
        specifications: "#fancoil-specifications"
      },
      ROOM: {
        id: "#source-room-id",
        capacityBars: ".footer .capacity-bar"
      },
      SPECIFICATION: {
        capacity: ".source-capacity-specification div",
        sensibleCapacity: ".source-sensible-capacity-specification div",
        soundPressureLevel: ".source-sound-pressure-specification div",
        soundPower: ".source-sound-power-specification div",
        waterPressureDrop: ".source-water-pressure-drop-specification div",
        waterFlowRate: ".source-water-flow-specification div",
        airFlow: ".source-air-flow-specification div",
        outletAirTemperature:
          ".source-outlet-air-temperature-specification div",
        outletAirRelativeHumidity:
          ".source-outlet-air-relative-humidity-specification div",
        dehumidication: ".source-dehumidification-specification div"
      }
    },

    EVENT: {
      calculationParamChanged: function(evt) {
        var $param = $(evt.currentTarget);
        var $fanCoil = $param.parents(_.SELECTOR.FAN_COIL.element).first();

        _.update($fanCoil);
      }
    },
    ATTRIBUTE: {
      SEGMENT: {
        ajaxName: "data-name"
      },
      FAN_COIL: {
        id: "data-id"
      }
    },

    update: function($fanCoil) {
      var url = $(_.SELECTOR.CALCULATE_CAPACITY.url).val();
      var json = _.createJson($fanCoil);

      //Send breadcrumb to sentry to easily reproduce the request & response
      if (typeof Sentry !== "undefined") {
        Sentry.addBreadcrumb({
          category: "calculate-capacity",
          message: "Calculate fan coil capacity",
          level: Sentry.Severity.info,
          data: json
        });
      }

      var callback = function(resp) {
        if (!resp) {
          return;
        }

        if (typeof Sentry !== "undefined") {
          Sentry.addBreadcrumb({
            category: "calculate-capacity",
            message: "Capacity fan coil is calculated",
            level: Sentry.Severity.info,
            data: resp
          });
        }

        var coolingCapacityRaw =
        resp && resp.CoolingSpecification && resp.CoolingSpecification.CapacityRaw;
        var coolingCapacity =
        resp && resp.CoolingSpecification && resp.CoolingSpecification.Capacity;

        _.updateCapacityBarGroup(
          $fanCoil.find(_.SELECTOR.FAN_COIL.capacityBars),
          (resp && resp.HeatingSpecification ) ? resp.HeatingSpecification.CapacityRaw : null,
          (resp && resp.HeatingSpecification ) ? resp.HeatingSpecification.Capacity : null,
          coolingCapacityRaw,
          coolingCapacity
        );
        _.updateCapacityBarGroup(
          $(_.SELECTOR.ROOM.capacityBars),
          resp.RoomHeatingCapacity,
          resp.RoomHeatingCapacityFormatted,
          resp.RoomCoolingCapacity,
          resp.RoomCoolingCapacityFormatted
        );

        _.updateSpecifications($fanCoil, resp);
      };

      AjaxCall.send(url, json, callback);
    },

    updateCapacityBarGroup: function(
      $capacityBars,
      heatingCapacity,
      heatingCapacityFormatted,
      coolingCapacity,
      coolingCapacityFormatted
    ) {
      var $coolingCapacityBar, $heatingCapacityBar;
      if ($capacityBars.length == 2) {
        $coolingCapacityBar = $capacityBars.eq(0);
        $heatingCapacityBar = $capacityBars.eq(1);
      } else {
        $heatingCapacityBar = $capacityBars.eq(0);
      }

      $heatingCapacityBar[0].CapacityBar.refresh(
        heatingCapacity,
        heatingCapacityFormatted
      );
      if (!!$coolingCapacityBar) {
        $coolingCapacityBar[0].CapacityBar.refresh(
          coolingCapacity,
          coolingCapacityFormatted
        );
      }
    },

    updateSpecifications: function($fanCoil, resp) {
      var coolingCapacityIndex = !!resp.CoolingSpecification ? 1 : null;
      var heatingCapacityIndex = !!resp.CoolingSpecification ? 2 : 1;

      if (!!coolingCapacityIndex) {
        $fanCoil
          .find(_.SELECTOR.SPECIFICATION.capacity)
          .eq(coolingCapacityIndex)
          .text(resp.CoolingSpecification.Capacity);
        $fanCoil
            .find(_.SELECTOR.SPECIFICATION.sensibleCapacity)
            .eq(coolingCapacityIndex)
            .text(resp.CoolingSpecification.SensibleCapacity);
        $fanCoil
          .find(_.SELECTOR.SPECIFICATION.soundPressureLevel)
          .eq(coolingCapacityIndex)
          .text(resp.CoolingSpecification.SoundPressure);
        $fanCoil
          .find(_.SELECTOR.SPECIFICATION.soundPower)
          .eq(coolingCapacityIndex)
          .text(resp.CoolingSpecification.SoundPower);
        $fanCoil
          .find(_.SELECTOR.SPECIFICATION.waterPressureDrop)
          .eq(coolingCapacityIndex)
          .text(resp.CoolingSpecification.PressureDrop);
        $fanCoil
          .find(_.SELECTOR.SPECIFICATION.waterFlowRate)
          .eq(coolingCapacityIndex)
          .text(resp.CoolingSpecification.WaterFlow);
        $fanCoil
          .find(_.SELECTOR.SPECIFICATION.airFlow)
          .eq(coolingCapacityIndex)
          .text(resp.CoolingSpecification.AirFlow);
        $fanCoil
          .find(_.SELECTOR.SPECIFICATION.outletAirTemperature)
          .eq(coolingCapacityIndex)
          .text(resp.CoolingSpecification.OutletDbAirTemperature);
        $fanCoil
          .find(_.SELECTOR.SPECIFICATION.outletAirRelativeHumidity)
          .eq(coolingCapacityIndex)
          .text(resp.CoolingSpecification.OutletAirRelativeHumidity);
        $fanCoil
          .find(_.SELECTOR.SPECIFICATION.dehumidication)
          .eq(coolingCapacityIndex)
          .text(resp.CoolingSpecification.DeHumidification);
      }

      if(resp && resp.HeatingSpecification) {
        $fanCoil
          .find(_.SELECTOR.SPECIFICATION.capacity)
          .eq(heatingCapacityIndex)
          .text(resp.HeatingSpecification.Capacity);
        $fanCoil
          .find(_.SELECTOR.SPECIFICATION.soundPressureLevel)
          .eq(heatingCapacityIndex)
          .text(resp.HeatingSpecification.SoundPressure);
          $fanCoil
          .find(_.SELECTOR.SPECIFICATION.soundPower)
          .eq(heatingCapacityIndex)
          .text(resp.HeatingSpecification.SoundPower);
        $fanCoil
          .find(_.SELECTOR.SPECIFICATION.waterPressureDrop)
          .eq(heatingCapacityIndex)
          .text(resp.HeatingSpecification.PressureDrop);
        $fanCoil
          .find(_.SELECTOR.SPECIFICATION.waterFlowRate)
          .eq(heatingCapacityIndex)
          .text(resp.HeatingSpecification.WaterFlow);
        $fanCoil
          .find(_.SELECTOR.SPECIFICATION.airFlow)
          .eq(heatingCapacityIndex)
          .text(resp.HeatingSpecification.AirFlow);
        $fanCoil
          .find(_.SELECTOR.SPECIFICATION.outletAirTemperature)
          .eq(heatingCapacityIndex)
          .text(resp.HeatingSpecification.OutletDbAirTemperature);
      }      
    },

    createJson: function($fanCoil) {
      var json = {
        Id: $fanCoil.attr(_.ATTRIBUTE.FAN_COIL.id),
        RoomId: $(_.SELECTOR.ROOM.id).val()
      };

      $fanCoil
        .find(_.SELECTOR.CALCULATE_CAPACITY.segmentgroup + ":checked")
        .each(function(i, segment) {
          var $segment = $(segment);
          json[$segment.attr(_.ATTRIBUTE.SEGMENT.ajaxName)] = $segment.val();
        });

      return json;
    }
  };

  function calculateCapacityController() {}
  calculateCapacityController.prototype = {
    init: function() {
      $(document).on(
        "change",
        _.SELECTOR.CALCULATE_CAPACITY.segmentgroup,
        _.EVENT.calculationParamChanged
      );
    },

    recalculate: function() {
      var $lastFanCoil = $(_.SELECTOR.FAN_COIL.element).last();

      _.update($lastFanCoil);
    }
  };
  return calculateCapacityController;
})();

CalculateCapacityController.recalculate = function() {
  new CalculateCapacityController().recalculate();
};

var EquipmentListController = (function() {
    var _ = {
        SELECTOR: {
            segment: '.segment-group .segment input',
            equipmentList: '.table'
        },
        CLASS: {
            hide: 'hide'
        },
        EVENT: {
            groupByChanged: function(evt) {
                var $groupBy = $(evt.currentTarget);
                var groupByClass = $groupBy.attr('id');
                _.hideEquipmentLists();
                _.showEquipmentList(groupByClass);
            }
        },
        showEquipmentList: function(groupByClass) {
            $(_.SELECTOR.equipmentList + '.' + groupByClass).removeClass(_.CLASS.hide);
        },
        hideEquipmentLists: function() {
            $(_.SELECTOR.equipmentList).addClass(_.CLASS.hide);
        }
    };

    function equipmentListController() {};
    equipmentListController.prototype = {
        init: function() {
            $(_.SELECTOR.segment).change(_.EVENT.groupByChanged);
        }
    };
    return equipmentListController;
}());
var FanSelectionController = (function() {
  var _ = {
    SELECTOR: {
      roomProperties: ".room > .advanced-property-group",
      ADD_FAN_COIL: {
        trigger: "#source-add-new-fan-coil",
        section: ".add-fan-coil"
      },
      DELETE_FANCOIL: {
        anchor: ".delete-fancoil",
        target: ".fan-coil",
        popup: ".delete-fan-coil-popup",
        idPlaceholder: "#fan-coil-id-remove",
        form: "form"
      },
      SOUND_PRESSURE: {
        triggerGroup: ".segment-group.sound-pressure-trigger",
        trigger: "input",
        control: ".sound-pressure-group"
      },
      ROOM_TYPE: {
        type: ".source-room-type select",
        name: ".source-room-name input",
        temperature: ".source-room-temperature select",
        heatingTemperature: ".source-room-heating-temperature input"
      },
      OPTION_DETAIL: {
        trigger: ".material-info",
        anchor: ".material-information-anchor",
        titlePlaceholder: "#source-option-detail-popup-title",
        imagePlaceholder: "#source-option-detail-popup-image",
        textPlaceholder: "#source-option-detail-popup-text",
        namePlaceholder: "#source-option-detail-popup-name",
        popup: ".option-detail-popup"
      }
    },
    ATTRIBUTE: {
      ADD_FAN_COIL_TRIGGER: {
        href: "data-href"
      },
      FAN_COIL: {
        id: "data-id"
      },
      OPTION_DETAIL: {
        title: "data-popuptitle",
        image: "data-popupimage",
        text: "data-popuptext",
        name: "data-popupname"
      }
    },
    EVENT: {
      documentClicked: function(evt) {
        var $originalTarget = $(evt.target);

        if ($originalTarget.parents(_.SELECTOR.roomProperties).length > 0) {
          return;
        }

        new AdvancedProperty().closeElement();
      },
      addFanCoilClicked: function() {
        _.addNewFanCoil();
      },

      deleteFancoilClicked: function(evt) {
        var $anchor = $(evt.currentTarget);
        var $fanCoil = $anchor
          .parents(_.SELECTOR.DELETE_FANCOIL.target)
          .first();

        _.setDeletePopup($fanCoil);
        _.showDeletePopup();
      },

      deleteFanCoilConfirmed: function() {
        // NEVER stop the event, the submit is executed through ajax!

        _.deleteFanCoil();
      },

      soundPressureTriggerChanged: function(evt) {
        var $trigger = $(evt.currentTarget);
        var trigger = $trigger.val();
        var $group = $trigger
          .parents(_.SELECTOR.SOUND_PRESSURE.triggerGroup)
          .first();
        var $soundPressure = $group
          .nextAll(_.SELECTOR.SOUND_PRESSURE.control)
          .first();

        $soundPressure[0].SoundPressure.setByTrigger(trigger);
      },

      roomTypeChanged: function() {
        _.setControlsByRoomType();
      },

      optionInfoClicked: function(evt) {
        var $trigger = $(evt.currentTarget);
        var $anchor = $trigger.prevAll(_.SELECTOR.OPTION_DETAIL.anchor).first();

        _.setOptionDetailPopup($anchor);
        _.showOptionDetailPopup();
      }
    },

    addNewFanCoil: function() {
      function callback(html) {
        var $fanCoil = $(html);

        //01. add HTML
        $fanCoil.insertBefore(_.SELECTOR.ADD_FAN_COIL.section);

        //02. Update capacity
        new CalculateCapacityController().recalculate();

        //03. Init controls in new fan coil
        new ShowHideController().init($fanCoil);
        new CapacityBarController().init($fanCoil);
        new TabGroupController().init($fanCoil);
        new SoundPressureController().init($fanCoil);
        new ListController().init($fanCoil);
      }

      var path = $(_.SELECTOR.ADD_FAN_COIL.trigger).attr(
        _.ATTRIBUTE.ADD_FAN_COIL_TRIGGER.href
      );
      AjaxCall.getHtml(path, null, callback);
    },

    setDeletePopup: function($fanCoil) {
      var id = $fanCoil.attr(_.ATTRIBUTE.FAN_COIL.id);

      $(_.SELECTOR.DELETE_FANCOIL.idPlaceholder).val(id);
    },

    showDeletePopup: function() {
      new Popup().show($(_.SELECTOR.DELETE_FANCOIL.popup));
    },

    deleteFanCoil: function() {
      var id = $(_.SELECTOR.DELETE_FANCOIL.idPlaceholder).val();

      $(
        _.SELECTOR.DELETE_FANCOIL.target +
          "[" +
          _.ATTRIBUTE.FAN_COIL.id +
          "=" +
          id +
          "]"
      ).remove();
      new Popup().hide($(_.SELECTOR.DELETE_FANCOIL.popup));
    },

    setControlsByRoomType: function() {
      var $roomType = $(_.SELECTOR.ROOM_TYPE.type);
      var $roomName = $(_.SELECTOR.ROOM_TYPE.name);
      var $roomTemperature = $(_.SELECTOR.ROOM_TYPE.temperature);
      var $roomHeatingTemperature = $(_.SELECTOR.ROOM_TYPE.heatingTemperature);

      $roomTemperature.val($roomType.val());

      var roomType = $(":selected", $roomType)
        .text()
        .trim();
      var roomTemperature = $.global.parseFloat(
        $(":selected", $roomTemperature).text()
      );
      var roomName = $roomName.val();
      var roomTypesWithRoomName = $("option", $roomType).filter(function() {
        return $(this)
          .text()
          .trim()
          .startsWith(roomName);
      });

      if (roomTypesWithRoomName.length > 0) {
        $roomName.val(roomType || "");
      }

      $roomHeatingTemperature.val(0);
      $roomHeatingTemperature
        .parents(".numeric-input")
        .first()[0]
        .NumericInput.setValue(roomTemperature);
    },

    setOptionDetailPopup: function($option) {
      var title = $option.attr(_.ATTRIBUTE.OPTION_DETAIL.title);
      var image = $option.attr(_.ATTRIBUTE.OPTION_DETAIL.image);
      var text = $option.attr(_.ATTRIBUTE.OPTION_DETAIL.text);
      var name = $option.attr(_.ATTRIBUTE.OPTION_DETAIL.name);

      $(_.SELECTOR.OPTION_DETAIL.titlePlaceholder).text(title);
      $(_.SELECTOR.OPTION_DETAIL.imagePlaceholder).attr("src", image);
      $(_.SELECTOR.OPTION_DETAIL.textPlaceholder).text(text);
      $(_.SELECTOR.OPTION_DETAIL.namePlaceholder).text(name);

      if (!image) {
        $(_.SELECTOR.OPTION_DETAIL.imagePlaceholder).removeAttr("src");
      }
    },

    showOptionDetailPopup: function() {
      new Popup().show($(_.SELECTOR.OPTION_DETAIL.popup));
    }
  };

  function fanSelectionController() {}
  fanSelectionController.prototype.init = function() {
    $(document).on("click", _.EVENT.documentClicked);
    $(document).on(
      "change",
      _.SELECTOR.SOUND_PRESSURE.triggerGroup +
        " " +
        _.SELECTOR.SOUND_PRESSURE.trigger,
      _.EVENT.soundPressureTriggerChanged
    );
    $(document).on(
      "click",
      _.SELECTOR.DELETE_FANCOIL.anchor,
      _.EVENT.deleteFancoilClicked
    );
    $(document).on(
      "click",
      _.SELECTOR.OPTION_DETAIL.trigger,
      _.EVENT.optionInfoClicked
    );
    $(_.SELECTOR.ADD_FAN_COIL.trigger).click(_.EVENT.addFanCoilClicked);
    $(_.SELECTOR.ROOM_TYPE.type).change(_.EVENT.roomTypeChanged);
    $(_.SELECTOR.DELETE_FANCOIL.popup)
      .find(_.SELECTOR.DELETE_FANCOIL.form)
      .submit(_.EVENT.deleteFanCoilConfirmed);
  };

  return fanSelectionController;
})();

var ProjectInfoController = (function() {
	var _ = {};
	function projectInfoController() {}
	projectInfoController.prototype = {
		init: function() {}
	};
	return projectInfoController;
})();

var SaveFanCoilController = (function () {
    var _ = {
        SELECTOR: {
            ELEMENTS: {
                segment: '.save-fan-coil.segment-group:not(.hide) input',
                option: 'ul.save-fan-coil input'
            },
            FAN_COIL: {
                element: '.fan-coil'
            },
            ROOM: {
                id: '#source-room-id'
            },
            url: '#source-save-fan-coil'
        },

        ATTRIBUTE: {
            FAN_COIL: {
                id: 'data-id'
            },
            SEGMENT: {
                ajaxName: 'data-name'
            },
            OPTION: {
                ajaxName: 'data-name'
            }
        },

        EVENT: {
            saveParamChanged: function (evt) {
                var $param = $(evt.currentTarget);
                var $fanCoil = $param.parents(_.SELECTOR.FAN_COIL.element).first();

                _.save($fanCoil);
            }
        },

        save: function ($fanCoil) {
            var url = $(_.SELECTOR.url).val();
            var json = _.createJson($fanCoil);

            AjaxCall.send(url, json);
        },

        createJson: function ($fanCoil) {
            var json = {
                Id: $fanCoil.attr(_.ATTRIBUTE.FAN_COIL.id),
                RoomId: $(_.SELECTOR.ROOM.id).val()
            }

            $fanCoil.find(_.SELECTOR.ELEMENTS.segment + ':checked').each(function (i, segment) {
                var $segment = $(segment);
                json[$segment.attr(_.ATTRIBUTE.SEGMENT.ajaxName)] = $segment.val();
            });

            $fanCoil.find(_.SELECTOR.ELEMENTS.option + ':checked').each(function (i, option) {
                var $option = $(option);
                var $optionProperty = $option.attr(_.ATTRIBUTE.SEGMENT.ajaxName);

                if (!json[$optionProperty]) {
                    json[$optionProperty] = [];
                }
                json[$optionProperty].push($option.val());
            });

            return json;
        }
    };

    function saveFanCoilController() {}
    saveFanCoilController.prototype = {
        init: function () {
            $(document).on('change', _.SELECTOR.ELEMENTS.segment, _.EVENT.saveParamChanged);
            $(document).on('change', _.SELECTOR.ELEMENTS.option, _.EVENT.saveParamChanged);

        }
    };
    return saveFanCoilController;
}());
var SaveProjectController = (function() {
  var _ = {
    SELECTOR: {
      ELEMENTS: {
        slider: ".update-project.slider-group .slider",
        dropdown: ".update-project.dropdown-group select"
      },
      url: "#source-save-project"
    },

    ATTRIBUTE: {
      SLIDER: {
        ajaxName: "data-name"
      }
    },

    EVENT: {
      sliderSet: function(values, handle, unencoded, tap, positions) {
        _.save();
      }
    },

    save: function() {
      var url = $(_.SELECTOR.url).val();
      var json = _.createJson();

      AjaxCall.send(url, json);
    },

    createJson: function() {
      var json = {};

      $(_.SELECTOR.ELEMENTS.slider).each(function(i, slider) {
        var noUiSlider = slider.noUiSlider;
        var formattedValue = noUiSlider.get()[1];
        var stringValue = noUiSlider.options.format.from(formattedValue);
        var value = parseInt(stringValue);

        json[$(slider).attr("name")] = value;
      });

      $(_.SELECTOR.ELEMENTS.dropdown).each(function(i, dropdown) {
        var $dropdown = $(dropdown);

        json[$dropdown.attr("name")] = $dropdown.val();
      });

      return json;
    }
  };

  function saveProjectController() {}
  saveProjectController.prototype = {
    init: function() {
      $(_.SELECTOR.ELEMENTS.slider).each(function(i, slider) {
        slider.noUiSlider.on("set", _.EVENT.sliderSet);
      });
      $(_.SELECTOR.ELEMENTS.dropdown).change(_.save);
    }
  };
  return saveProjectController;
})();

var UpdateOptionsController = (function() {
  var _ = {
    SELECTOR: {
      segment: ".update-options.segment-group:not(.hide) input",
      option: "ul.update-options input",
      fanCoil: ".fan-coil",
      roomId: "#source-room-id",
      url: "#source-update-options",
      options: "#fancoil-options .table"
    },

    ATTRIBUTE: {
      FAN_COIL: {
        id: "data-id"
      },
      SEGMENT: {
        ajaxName: "data-name"
      }
    },

    EVENT: {
      triggerChanged: function(evt) {
        var $trigger = $(evt.currentTarget);
        var $fanCoil = $trigger.parents(_.SELECTOR.fanCoil).first();

        _.update($fanCoil);
      }
    },

    update: function($fanCoil) {
      var url = $(_.SELECTOR.url).val();
      var json = _.createJson($fanCoil);
      var callback = function(resp) {
        if (!resp) {
          return;
        }

        var $oldOptions = $fanCoil.find(_.SELECTOR.options);
        var $newOptions = $(resp);
        $newOptions.insertBefore($oldOptions.first());
        $oldOptions.remove();

        new ListController().init($fanCoil);
      };

      AjaxCall.send(url, json, callback);
    },

    createJson: function($fanCoil) {
      var json = {
        Id: $fanCoil.attr(_.ATTRIBUTE.FAN_COIL.id),
        RoomId: $(_.SELECTOR.roomId).val()
      };

      $fanCoil.find(_.SELECTOR.segment + ":checked").each(function(i, segment) {
        var $segment = $(segment);
        json[$segment.attr(_.ATTRIBUTE.SEGMENT.ajaxName)] = $segment.val();
      });

      $fanCoil.find(_.SELECTOR.option + ":checked").each(function(i, option) {
        var $option = $(option);
        var $optionProperty = $option.attr(_.ATTRIBUTE.SEGMENT.ajaxName);

        if (!json[$optionProperty]) {
          json[$optionProperty] = [];
        }
        json[$optionProperty].push($option.val());
      });

      return json;
    }
  };

  function updateOptionsController() {}
  updateOptionsController.prototype = {
    init: function() {
      $(document).on("change", _.SELECTOR.segment, _.EVENT.triggerChanged);
      $(document).on("change", _.SELECTOR.option, _.EVENT.triggerChanged);
    }
  };

  return updateOptionsController;
})();

var UpdateSpeedController = (function() {
	var _ = {
		SELECTOR: {
			trigger: '.update-speed.segment-group:not(.hide) input',
			fanCoil: '.fan-coil',
			roomId: '#source-room-id',
			url: '#source-update-speed',
			container: '#fancoil-fanspeed'
		},
		ATTRIBUTE: {
			FAN_COIL: {
				id: 'data-id'
			},
			SEGMENT: {
				ajaxName: 'data-name'
			}
		},
		EVENT: {
			triggerChanged: function(evt) {
				var $trigger = $(evt.currentTarget);
				var $fanCoil = $trigger.parents(_.SELECTOR.fanCoil);

				_.update($fanCoil);
			}
		},

		update: function($fanCoil) {
			var url = $(_.SELECTOR.url).val();
			var json = _.createJson($fanCoil);
			var callback = function(resp) {
				if (!resp) {
					return;
				}

				var $container = $fanCoil.find(_.SELECTOR.container);
				$container.html(resp);

				new SoundPressureController().init($container);
			};

			AjaxCall.send(url, json, callback);
		},

		createJson: function($fanCoil) {
			var json = {
				Id: $fanCoil.attr(_.ATTRIBUTE.FAN_COIL.id),
				RoomId: $(_.SELECTOR.roomId).val()
			};

			$fanCoil.find(_.SELECTOR.trigger + ':checked').each(function(i, segment) {
				var $segment = $(segment);
				json[$segment.attr(_.ATTRIBUTE.SEGMENT.ajaxName)] = $segment.val();
			});

			return json;
		}
	};
	function updateSpeedController() {}
	updateSpeedController.prototype = {
		init: function() {
			$(document).on('change', _.SELECTOR.trigger, _.EVENT.triggerChanged);
		}
	};

	return updateSpeedController;
})();

var ZoneOverviewController = (function () {
    var _ = {
        SELECTOR: {
            room: '.room-overview',
            roomMenu: '.popover-menu',
            DELETE_ROOM: {
                anchor: '.popover-menu-group .delete',
                popup: '.delete-room-popup',
                namePlaceholder: '#room-name-remove',
                idPlaceholder: '#room-id-remove'
            }
        },
        ATTRIBUTE: {
            ROOM: {
                id: 'data-id',
                name: 'data-name'
            }
        },
        EVENT: {
            roomBlurred: function (evt) {
                var $room = $(evt.currentTarget);
                var $menu = $(_.SELECTOR.roomMenu);

                _.hideRoomPopoverMenu($menu);
            },
            deleteRoomClicked: function (evt) {
                var $anchor = $(evt.currentTarget);
                var $room = $anchor.parents(_.SELECTOR.room);

                _.setDeletePopup($room);
                _.showDeletePopup();

                return false;
            }
        },

        setDeletePopup: function ($room) {
            var id = $room.attr(_.ATTRIBUTE.ROOM.id);
            var name = $room.attr(_.ATTRIBUTE.ROOM.name);

            $(_.SELECTOR.DELETE_ROOM.idPlaceholder).val(id);
            $(_.SELECTOR.DELETE_ROOM.namePlaceholder).text(name);
        },

        showDeletePopup: function () {
            new Popup().show($(_.SELECTOR.DELETE_ROOM.popup));
        },

        hideRoomPopoverMenu: function ($menu) {
            setTimeout(function () {
                new PopoverMenuGroup().hidePopoverMenu($menu);
            }, 400);
        }
    };

    function zoneOverviewController() {}
    zoneOverviewController.prototype = {
        init: function () {
            $(_.SELECTOR.DELETE_ROOM.anchor).click(_.EVENT.deleteRoomClicked);
            $(_.SELECTOR.room).mouseleave(_.EVENT.roomBlurred);
        }
    };
    return zoneOverviewController;
}());